/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: any; output: any; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /**
   * A JSON Web Token defined by [RFC 7519](https://tools.ietf.org/html/rfc7519)
   * which securely represents claims between two parties.
   */
  JwtToken: { input: any; output: any; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any; }
};

export type AccessRight = {
  __typename?: 'AccessRight';
  edit?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  use?: Maybe<Scalars['Boolean']['output']>;
};

/** All input for the `authAccessToken` mutation. */
export type AuthAccessTokenInput = {
  accessTokenExpiration?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  profileTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userRefreshToken?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `authAccessToken` mutation. */
export type AuthAccessTokenPayload = {
  __typename?: 'AuthAccessTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `authRefreshToken` mutation. */
export type AuthRefreshTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userLogin?: InputMaybe<Scalars['String']['input']>;
  userPassword?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `authRefreshToken` mutation. */
export type AuthRefreshTokenPayload = {
  __typename?: 'AuthRefreshTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  refreshToken?: Maybe<RefreshToken>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** All input for the `bumpSchemaVersion` mutation. */
export type BumpSchemaVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  schemas?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** The output of our `bumpSchemaVersion` mutation. */
export type BumpSchemaVersionPayload = {
  __typename?: 'BumpSchemaVersionPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** Control Execution is a data type that is used to represent an individual RPC/Control call event or RPC/Report feedback. It is used to provide communication interface between RPC/Control caller and RPC/Control execution module.  */
export type ControlExecution = Node & {
  __typename?: 'ControlExecution';
  /** Indicated if RPC/Control was Acknowledged by Controller or not.  */
  ack?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `User` that is related to this `ControlExecution`. */
  caller?: Maybe<User>;
  /** Caller ID of the RPC/Control Execution or Controller ID for REPORT. */
  callerId?: Maybe<Scalars['UUID']['output']>;
  /** Controller ID (User of type APP) responsible for the execution of this Control. */
  controller?: Maybe<Scalars['UUID']['output']>;
  /** Timestamp of Control Execution start. */
  createdAt: Scalars['Datetime']['output'];
  /** If Type is RPC then indicates if the execution of RPC/Control is finished or not. If Type is REPORT then indicates if this Report is final for related RPC/Control (linked_control_id). */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** If Type is RPC indicates if execution has finished with error. If Type is REPORT indicates if this Report is regarding an error.  */
  error?: Maybe<Scalars['String']['output']>;
  helperParams?: Maybe<Scalars['JSON']['output']>;
  /** Control Execution unique ID. */
  id: Scalars['Int']['output'];
  /** If Type is REPORT contains related RPC/Control Execution uuid for it.  */
  linkedControlId?: Maybe<Scalars['BigInt']['output']>;
  /** Name of the RPC/Control being called or name of the Report provided by Controller. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Object` that is related to this `ControlExecution`. */
  object?: Maybe<Object>;
  /** Object ID related to this Control Execution. */
  objectId: Scalars['UUID']['output'];
  /** Parameters for RPC/Control being called or Report details provided by Controller. */
  params: Scalars['JSON']['output'];
  /** Type of Control Execution record (RPC/REPORT/STEALTH). */
  type?: Maybe<ControlTypes>;
};

/**
 * A condition to be used against `ControlExecution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ControlExecutionCondition = {
  /** Checks for equality with the object’s `ack` field. */
  ack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `callerId` field. */
  callerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `controller` field. */
  controller?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `done` field. */
  done?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `error` field. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `helperParams` field. */
  helperParams?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `linkedControlId` field. */
  linkedControlId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `params` field. */
  params?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ControlTypes>;
};

/** A filter to be used against `ControlExecution` object types. All fields are combined with a logical ‘and.’ */
export type ControlExecutionFilter = {
  /** Filter by the object’s `ack` field. */
  ack?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ControlExecutionFilter>>;
  /** Filter by the object’s `caller` relation. */
  caller?: InputMaybe<UserFilter>;
  /** A related `caller` exists. */
  callerExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `callerId` field. */
  callerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `controller` field. */
  controller?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `done` field. */
  done?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `error` field. */
  error?: InputMaybe<StringFilter>;
  /** Filter by the object’s `helperParams` field. */
  helperParams?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `linkedControlId` field. */
  linkedControlId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ControlExecutionFilter>;
  /** Filter by the object’s `object` relation. */
  object?: InputMaybe<ObjectFilter>;
  /** A related `object` exists. */
  objectExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ControlExecutionFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<ControlTypesFilter>;
};

/** An input for mutations affecting `ControlExecution` */
export type ControlExecutionInput = {
  /** Controller ID (User of type APP) responsible for the execution of this Control. */
  controller?: InputMaybe<Scalars['UUID']['input']>;
  helperParams?: InputMaybe<Scalars['JSON']['input']>;
  /** If Type is REPORT contains related RPC/Control Execution uuid for it.  */
  linkedControlId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Name of the RPC/Control being called or name of the Report provided by Controller. */
  name: Scalars['String']['input'];
  /** Object ID related to this Control Execution. */
  objectId: Scalars['UUID']['input'];
  /** Parameters for RPC/Control being called or Report details provided by Controller. */
  params: Scalars['JSON']['input'];
};

/** A connection to a list of `ControlExecution` values. */
export type ControlExecutionsConnection = {
  __typename?: 'ControlExecutionsConnection';
  /** A list of edges which contains the `ControlExecution` and cursor to aid in pagination. */
  edges: Array<ControlExecutionsEdge>;
  /** A list of `ControlExecution` objects. */
  nodes: Array<Maybe<ControlExecution>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ControlExecution` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ControlExecution` edge in the connection. */
export type ControlExecutionsEdge = {
  __typename?: 'ControlExecutionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ControlExecution` at the end of the edge. */
  node?: Maybe<ControlExecution>;
};

/** Methods to use when ordering `ControlExecution`. */
export enum ControlExecutionsOrderBy {
  AckAsc = 'ACK_ASC',
  AckDesc = 'ACK_DESC',
  CallerIdAsc = 'CALLER_ID_ASC',
  CallerIdDesc = 'CALLER_ID_DESC',
  ControllerAsc = 'CONTROLLER_ASC',
  ControllerDesc = 'CONTROLLER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DoneAsc = 'DONE_ASC',
  DoneDesc = 'DONE_DESC',
  ErrorAsc = 'ERROR_ASC',
  ErrorDesc = 'ERROR_DESC',
  HelperParamsAsc = 'HELPER_PARAMS_ASC',
  HelperParamsDesc = 'HELPER_PARAMS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinkedControlIdAsc = 'LINKED_CONTROL_ID_ASC',
  LinkedControlIdDesc = 'LINKED_CONTROL_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ParamsAsc = 'PARAMS_ASC',
  ParamsDesc = 'PARAMS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type ControlExecutionsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: ControlExecutionsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type ControlExecutionsSortBy = {
  field?: InputMaybe<ControlExecutionsSortableField>;
};

/** Sortable concrete fields for the `ControlExecution` type. */
export enum ControlExecutionsSortableField {
  Ack = 'ACK',
  CallerId = 'CALLER_ID',
  Controller = 'CONTROLLER',
  CreatedAt = 'CREATED_AT',
  Done = 'DONE',
  Error = 'ERROR',
  HelperParams = 'HELPER_PARAMS',
  Id = 'ID',
  LinkedControlId = 'LINKED_CONTROL_ID',
  Name = 'NAME',
  ObjectId = 'OBJECT_ID',
  Params = 'PARAMS',
  Type = 'TYPE'
}

export enum ControlTypes {
  Report = 'REPORT',
  Rpc = 'RPC',
  RpcStealth = 'RPC_STEALTH'
}

/** A filter to be used against ControlTypes fields. All fields are combined with a logical ‘and.’ */
export type ControlTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ControlTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ControlTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ControlTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ControlTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ControlTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ControlTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ControlTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ControlTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ControlTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ControlTypes>>;
};

/** All input for the create `ControlExecution` mutation. */
export type CreateControlExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ControlExecution` to be created by this mutation. */
  controlExecution: ControlExecutionInput;
};

/** The output of our create `ControlExecution` mutation. */
export type CreateControlExecutionPayload = {
  __typename?: 'CreateControlExecutionPayload';
  /** Reads a single `User` that is related to this `ControlExecution`. */
  caller?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ControlExecution` that was created by this mutation. */
  controlExecution?: Maybe<ControlExecution>;
  /** An edge for our `ControlExecution`. May be used by Relay 1. */
  controlExecutionEdge?: Maybe<ControlExecutionsEdge>;
  /** Reads a single `Object` that is related to this `ControlExecution`. */
  object?: Maybe<Object>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ControlExecution` mutation. */
export type CreateControlExecutionPayloadControlExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
};

/** All input for the `createControlExecutionReport` mutation. */
export type CreateControlExecutionReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  done: Scalars['Boolean']['input'];
  error: Scalars['Boolean']['input'];
  linkedControlId: Scalars['Int']['input'];
  report: Scalars['String']['input'];
  reportDetails: Scalars['JSON']['input'];
};

/** The output of our `createControlExecutionReport` mutation. */
export type CreateControlExecutionReportPayload = {
  __typename?: 'CreateControlExecutionReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CreateControlExecutionStealthByPropertyValueInput = {
  enrichWith: Array<Property2Input>;
  groupName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  params: Scalars['JSON']['input'];
  property: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type CreateControlExecutionStealthByPropertyValuePayload = {
  __typename?: 'CreateControlExecutionStealthByPropertyValuePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** All input for the `createControlExecutionStealth` mutation. */
export type CreateControlExecutionStealthInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  objectId: Scalars['UUID']['input'];
  params: Scalars['JSON']['input'];
};

/** The output of our `createControlExecutionStealth` mutation. */
export type CreateControlExecutionStealthPayload = {
  __typename?: 'CreateControlExecutionStealthPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `createControlExecutionSync` mutation. */
export type CreateControlExecutionSyncInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  objectId: Scalars['UUID']['input'];
  params: Scalars['JSON']['input'];
  timeout: Scalars['Int']['input'];
};

/** The output of our `createControlExecutionSync` mutation. */
export type CreateControlExecutionSyncPayload = {
  __typename?: 'CreateControlExecutionSyncPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  rpcResult?: Maybe<RpcResult>;
};

/** All input for the create `NotificationDelivery` mutation. */
export type CreateNotificationDeliveryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `NotificationDelivery` to be created by this mutation. */
  notificationDelivery: NotificationDeliveryInput;
};

/** The output of our create `NotificationDelivery` mutation. */
export type CreateNotificationDeliveryPayload = {
  __typename?: 'CreateNotificationDeliveryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Object` that is related to this `NotificationDelivery`. */
  deliveryConfig?: Maybe<Object>;
  /** Reads a single `Notification` that is related to this `NotificationDelivery`. */
  notification?: Maybe<Notification>;
  /** The `NotificationDelivery` that was created by this mutation. */
  notificationDelivery?: Maybe<NotificationDelivery>;
  /** An edge for our `NotificationDelivery`. May be used by Relay 1. */
  notificationDeliveryEdge?: Maybe<NotificationDeliveriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `NotificationDelivery`. */
  userByUser?: Maybe<User>;
};


/** The output of our create `NotificationDelivery` mutation. */
export type CreateNotificationDeliveryPayloadNotificationDeliveryEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
};

/** All input for the create `Notification` mutation. */
export type CreateNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Notification` to be created by this mutation. */
  notification: NotificationInput;
};

/** The output of our create `Notification` mutation. */
export type CreateNotificationPayload = {
  __typename?: 'CreateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Notification` that was created by this mutation. */
  notification?: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge?: Maybe<NotificationsEdge>;
  /** Reads a single `Object` that is related to this `Notification`. */
  object?: Maybe<Object>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Notification`. */
  userByBy?: Maybe<User>;
};


/** The output of our create `Notification` mutation. */
export type CreateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `createObjectCopy` mutation. */
export type CreateObjectCopyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copyObjectLinks?: InputMaybe<Scalars['Boolean']['input']>;
  copyPropertyLinks?: InputMaybe<Scalars['Boolean']['input']>;
  newObjectDescription?: InputMaybe<Scalars['String']['input']>;
  newObjectName?: InputMaybe<Scalars['String']['input']>;
  newObjectTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  overrideProperties?: InputMaybe<Array<InputMaybe<PropertyByNameInput>>>;
};

/** The output of our `createObjectCopy` mutation. */
export type CreateObjectCopyPayload = {
  __typename?: 'CreateObjectCopyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** All input for the create `Object` mutation. */
export type CreateObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Object` to be created by this mutation. */
  object: ObjectInput;
};

/** The output of our create `Object` mutation. */
export type CreateObjectPayload = {
  __typename?: 'CreateObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Object` that was created by this mutation. */
  object?: Maybe<Object>;
  /** An edge for our `Object`. May be used by Relay 1. */
  objectEdge?: Maybe<ObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our create `Object` mutation. */
export type CreateObjectPayloadObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
};

/** All input for the create `ObjectPropertiesHistory` mutation. */
export type CreateObjectPropertiesHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ObjectPropertiesHistory` to be created by this mutation. */
  objectPropertiesHistory: ObjectPropertiesHistoryInput;
};

/** The output of our create `ObjectPropertiesHistory` mutation. */
export type CreateObjectPropertiesHistoryPayload = {
  __typename?: 'CreateObjectPropertiesHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ObjectPropertiesHistory` that was created by this mutation. */
  objectPropertiesHistory?: Maybe<ObjectPropertiesHistory>;
  /** An edge for our `ObjectPropertiesHistory`. May be used by Relay 1. */
  objectPropertiesHistoryEdge?: Maybe<ObjectPropertiesHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ObjectPropertiesHistory`. */
  userByBy?: Maybe<User>;
};


/** The output of our create `ObjectPropertiesHistory` mutation. */
export type CreateObjectPropertiesHistoryPayloadObjectPropertiesHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
};

/** All input for the `createObjectWithProperties` mutation. */
export type CreateObjectWithPropertiesInput = {
  childs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editorGroup?: InputMaybe<Scalars['UUID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyedProperties?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  properties?: InputMaybe<Array<InputMaybe<PropertyByNameInput>>>;
  propertiesLinks?: InputMaybe<Array<InputMaybe<PropertyLinkInput>>>;
  readerGroup?: InputMaybe<Scalars['UUID']['input']>;
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  schemaTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userGroup?: InputMaybe<Scalars['UUID']['input']>;
  userProfile?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `createObjectWithProperties` mutation. */
export type CreateObjectWithPropertiesPayload = {
  __typename?: 'CreateObjectWithPropertiesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** All input for the create `ObjectsToObject` mutation. */
export type CreateObjectsToObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ObjectsToObject` to be created by this mutation. */
  objectsToObject: ObjectsToObjectInput;
};

/** The output of our create `ObjectsToObject` mutation. */
export type CreateObjectsToObjectPayload = {
  __typename?: 'CreateObjectsToObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Object` that is related to this `ObjectsToObject`. */
  object1?: Maybe<Object>;
  /** Reads a single `Object` that is related to this `ObjectsToObject`. */
  object2?: Maybe<Object>;
  /** The `ObjectsToObject` that was created by this mutation. */
  objectsToObject?: Maybe<ObjectsToObject>;
  /** An edge for our `ObjectsToObject`. May be used by Relay 1. */
  objectsToObjectEdge?: Maybe<ObjectsToObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ObjectsToObject` mutation. */
export type CreateObjectsToObjectPayloadObjectsToObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
};

/** All input for the `createObjectsToObjects` mutation. */
export type CreateObjectsToObjectsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sourceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** The output of our `createObjectsToObjects` mutation. */
export type CreateObjectsToObjectsPayload = {
  __typename?: 'CreateObjectsToObjectsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `PropertyType` mutation. */
export type CreatePropertyTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PropertyType` to be created by this mutation. */
  propertyType: PropertyTypeInput;
};

/** The output of our create `PropertyType` mutation. */
export type CreatePropertyTypePayload = {
  __typename?: 'CreatePropertyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PropertyType` that was created by this mutation. */
  propertyType?: Maybe<PropertyType>;
  /** An edge for our `PropertyType`. May be used by Relay 1. */
  propertyTypeEdge?: Maybe<PropertyTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PropertyType` mutation. */
export type CreatePropertyTypePayloadPropertyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
};

/** All input for the create `SchemaControl` mutation. */
export type CreateSchemaControlInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SchemaControl` to be created by this mutation. */
  schemaControl: SchemaControlInput;
};

/** The output of our create `SchemaControl` mutation. */
export type CreateSchemaControlPayload = {
  __typename?: 'CreateSchemaControlPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `SchemaControl`. */
  schema?: Maybe<Schema>;
  /** The `SchemaControl` that was created by this mutation. */
  schemaControl?: Maybe<SchemaControl>;
  /** An edge for our `SchemaControl`. May be used by Relay 1. */
  schemaControlEdge?: Maybe<SchemaControlsEdge>;
  /** Reads a single `User` that is related to this `SchemaControl`. */
  userByBy?: Maybe<User>;
};


/** The output of our create `SchemaControl` mutation. */
export type CreateSchemaControlPayloadSchemaControlEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
};

/** All input for the `createSchemaCopy` mutation. */
export type CreateSchemaCopyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  linkToSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  newSchemaDescription?: InputMaybe<Scalars['String']['input']>;
  newSchemaName?: InputMaybe<Scalars['String']['input']>;
  newSchemaTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `createSchemaCopy` mutation. */
export type CreateSchemaCopyPayload = {
  __typename?: 'CreateSchemaCopyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** All input for the create `Schema` mutation. */
export type CreateSchemaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Schema` to be created by this mutation. */
  schema: SchemaInput;
};

/** The output of our create `Schema` mutation. */
export type CreateSchemaPayload = {
  __typename?: 'CreateSchemaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Schema` that was created by this mutation. */
  schema?: Maybe<Schema>;
  /** An edge for our `Schema`. May be used by Relay 1. */
  schemaEdge?: Maybe<SchemataEdge>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our create `Schema` mutation. */
export type CreateSchemaPayloadSchemaEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
};

/** All input for the create `SchemaProperty` mutation. */
export type CreateSchemaPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SchemaProperty` to be created by this mutation. */
  schemaProperty: SchemaPropertyInput;
};

/** The output of our create `SchemaProperty` mutation. */
export type CreateSchemaPropertyPayload = {
  __typename?: 'CreateSchemaPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `SchemaProperty`. */
  schema?: Maybe<Schema>;
  /** The `SchemaProperty` that was created by this mutation. */
  schemaProperty?: Maybe<SchemaProperty>;
  /** An edge for our `SchemaProperty`. May be used by Relay 1. */
  schemaPropertyEdge?: Maybe<SchemaPropertiesEdge>;
  /** Reads a single `PropertyType` that is related to this `SchemaProperty`. */
  type?: Maybe<PropertyType>;
  /** Reads a single `User` that is related to this `SchemaProperty`. */
  userByBy?: Maybe<User>;
};


/** The output of our create `SchemaProperty` mutation. */
export type CreateSchemaPropertyPayloadSchemaPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
};

/** All input for the create `Translation` mutation. */
export type CreateTranslationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Translation` to be created by this mutation. */
  translation: TranslationInput;
};

/** The output of our create `Translation` mutation. */
export type CreateTranslationPayload = {
  __typename?: 'CreateTranslationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Translation` that was created by this mutation. */
  translation?: Maybe<Translation>;
  /** An edge for our `Translation`. May be used by Relay 1. */
  translationEdge?: Maybe<TranslationsEdge>;
};


/** The output of our create `Translation` mutation. */
export type CreateTranslationPayloadTranslationEdgeArgs = {
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
};

/** All input for the create `UserGroup` mutation. */
export type CreateUserGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserGroup` to be created by this mutation. */
  userGroup: UserGroupInput;
};

/** The output of our create `UserGroup` mutation. */
export type CreateUserGroupPayload = {
  __typename?: 'CreateUserGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserGroup`. */
  userByBy?: Maybe<User>;
  /** The `UserGroup` that was created by this mutation. */
  userGroup?: Maybe<UserGroup>;
  /** An edge for our `UserGroup`. May be used by Relay 1. */
  userGroupEdge?: Maybe<UserGroupsEdge>;
};


/** The output of our create `UserGroup` mutation. */
export type CreateUserGroupPayloadUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UsersToGroup` mutation. */
export type CreateUsersToGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UsersToGroup` to be created by this mutation. */
  usersToGroup: UsersToGroupInput;
};

/** The output of our create `UsersToGroup` mutation. */
export type CreateUsersToGroupPayload = {
  __typename?: 'CreateUsersToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UsersToGroup`. */
  user?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `UsersToGroup`. */
  userGroup?: Maybe<UserGroup>;
  /** The `UsersToGroup` that was created by this mutation. */
  usersToGroup?: Maybe<UsersToGroup>;
  /** An edge for our `UsersToGroup`. May be used by Relay 1. */
  usersToGroupEdge?: Maybe<UsersToGroupsEdge>;
};


/** The output of our create `UsersToGroup` mutation. */
export type CreateUsersToGroupPayloadUsersToGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
};

/** All input for the create `UsersToObject` mutation. */
export type CreateUsersToObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UsersToObject` to be created by this mutation. */
  usersToObject: UsersToObjectInput;
};

/** The output of our create `UsersToObject` mutation. */
export type CreateUsersToObjectPayload = {
  __typename?: 'CreateUsersToObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Object` that is related to this `UsersToObject`. */
  object?: Maybe<Object>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UsersToObject`. */
  user?: Maybe<User>;
  /** The `UsersToObject` that was created by this mutation. */
  usersToObject?: Maybe<UsersToObject>;
  /** An edge for our `UsersToObject`. May be used by Relay 1. */
  usersToObjectEdge?: Maybe<UsersToObjectsEdge>;
};


/** The output of our create `UsersToObject` mutation. */
export type CreateUsersToObjectPayloadUsersToObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DbInfo = {
  __typename?: 'DbInfo';
  appUsers?: Maybe<Scalars['Int']['output']>;
  controls?: Maybe<Scalars['Int']['output']>;
  controlsSize?: Maybe<Scalars['BigInt']['output']>;
  dbSize?: Maybe<Scalars['BigInt']['output']>;
  deliveries?: Maybe<Scalars['Int']['output']>;
  deliveriesSize?: Maybe<Scalars['BigInt']['output']>;
  devices?: Maybe<Scalars['Int']['output']>;
  devicesOffline?: Maybe<Scalars['Int']['output']>;
  historySize?: Maybe<Scalars['BigInt']['output']>;
  mediaSize?: Maybe<Scalars['BigInt']['output']>;
  notifications?: Maybe<Scalars['Int']['output']>;
  notificationsSize?: Maybe<Scalars['BigInt']['output']>;
  objects?: Maybe<Scalars['Int']['output']>;
  pps?: Maybe<Scalars['Int']['output']>;
  props10Min?: Maybe<Scalars['Int']['output']>;
  retention?: Maybe<Scalars['String']['output']>;
  tsVersion?: Maybe<Scalars['String']['output']>;
  userGroups?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
  usersDisabled?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** All input for the `deleteObjectByNodeId` mutation. */
export type DeleteObjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Object` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteObject` mutation. */
export type DeleteObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique Object ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Object` mutation. */
export type DeleteObjectPayload = {
  __typename?: 'DeleteObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedObjectNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Object` that was deleted by this mutation. */
  object?: Maybe<Object>;
  /** An edge for our `Object`. May be used by Relay 1. */
  objectEdge?: Maybe<ObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our delete `Object` mutation. */
export type DeleteObjectPayloadObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
};

/** All input for the `deleteObjectPropertiesHistoryByNodeId` mutation. */
export type DeleteObjectPropertiesHistoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ObjectPropertiesHistory` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteObjectPropertiesHistory` mutation. */
export type DeleteObjectPropertiesHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  recordedAt: Scalars['Datetime']['input'];
};

/** The output of our delete `ObjectPropertiesHistory` mutation. */
export type DeleteObjectPropertiesHistoryPayload = {
  __typename?: 'DeleteObjectPropertiesHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedObjectPropertiesHistoryNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `ObjectPropertiesHistory` that was deleted by this mutation. */
  objectPropertiesHistory?: Maybe<ObjectPropertiesHistory>;
  /** An edge for our `ObjectPropertiesHistory`. May be used by Relay 1. */
  objectPropertiesHistoryEdge?: Maybe<ObjectPropertiesHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ObjectPropertiesHistory`. */
  userByBy?: Maybe<User>;
};


/** The output of our delete `ObjectPropertiesHistory` mutation. */
export type DeleteObjectPropertiesHistoryPayloadObjectPropertiesHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
};

/** All input for the `deleteObjectsToObjectByNodeId` mutation. */
export type DeleteObjectsToObjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ObjectsToObject` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteObjectsToObjectByObject1IdAndObject2Id` mutation. */
export type DeleteObjectsToObjectByObject1IdAndObject2IdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Object ID connected to.  */
  object1Id: Scalars['UUID']['input'];
  /** Object ID connecting to.  */
  object2Id: Scalars['UUID']['input'];
};

/** All input for the `deleteObjectsToObject` mutation. */
export type DeleteObjectsToObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Relation unique ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ObjectsToObject` mutation. */
export type DeleteObjectsToObjectPayload = {
  __typename?: 'DeleteObjectsToObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedObjectsToObjectNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Object` that is related to this `ObjectsToObject`. */
  object1?: Maybe<Object>;
  /** Reads a single `Object` that is related to this `ObjectsToObject`. */
  object2?: Maybe<Object>;
  /** The `ObjectsToObject` that was deleted by this mutation. */
  objectsToObject?: Maybe<ObjectsToObject>;
  /** An edge for our `ObjectsToObject`. May be used by Relay 1. */
  objectsToObjectEdge?: Maybe<ObjectsToObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ObjectsToObject` mutation. */
export type DeleteObjectsToObjectPayloadObjectsToObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
};

/** All input for the `deletePropertyTypeByName` mutation. */
export type DeletePropertyTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type name (must be unique) */
  name: Scalars['String']['input'];
};

/** All input for the `deletePropertyTypeByNodeId` mutation. */
export type DeletePropertyTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PropertyType` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deletePropertyType` mutation. */
export type DeletePropertyTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type id. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `PropertyType` mutation. */
export type DeletePropertyTypePayload = {
  __typename?: 'DeletePropertyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPropertyTypeNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `PropertyType` that was deleted by this mutation. */
  propertyType?: Maybe<PropertyType>;
  /** An edge for our `PropertyType`. May be used by Relay 1. */
  propertyTypeEdge?: Maybe<PropertyTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PropertyType` mutation. */
export type DeletePropertyTypePayloadPropertyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
};

/** All input for the `deleteSchemaByNodeId` mutation. */
export type DeleteSchemaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Schema` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteSchemaControlByNodeId` mutation. */
export type DeleteSchemaControlByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaControl` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteSchemaControl` mutation. */
export type DeleteSchemaControlInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schema Controls unique ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `SchemaControl` mutation. */
export type DeleteSchemaControlPayload = {
  __typename?: 'DeleteSchemaControlPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaControlNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `SchemaControl`. */
  schema?: Maybe<Schema>;
  /** The `SchemaControl` that was deleted by this mutation. */
  schemaControl?: Maybe<SchemaControl>;
  /** An edge for our `SchemaControl`. May be used by Relay 1. */
  schemaControlEdge?: Maybe<SchemaControlsEdge>;
  /** Reads a single `User` that is related to this `SchemaControl`. */
  userByBy?: Maybe<User>;
};


/** The output of our delete `SchemaControl` mutation. */
export type DeleteSchemaControlPayloadSchemaControlEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
};

/** All input for the `deleteSchema` mutation. */
export type DeleteSchemaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schema unique ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Schema` mutation. */
export type DeleteSchemaPayload = {
  __typename?: 'DeleteSchemaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Schema` that was deleted by this mutation. */
  schema?: Maybe<Schema>;
  /** An edge for our `Schema`. May be used by Relay 1. */
  schemaEdge?: Maybe<SchemataEdge>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our delete `Schema` mutation. */
export type DeleteSchemaPayloadSchemaEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
};

/** All input for the `deleteSchemaPropertyByNodeId` mutation. */
export type DeleteSchemaPropertyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaProperty` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteSchemaProperty` mutation. */
export type DeleteSchemaPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property unique ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `SchemaProperty` mutation. */
export type DeleteSchemaPropertyPayload = {
  __typename?: 'DeleteSchemaPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaPropertyNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `SchemaProperty`. */
  schema?: Maybe<Schema>;
  /** The `SchemaProperty` that was deleted by this mutation. */
  schemaProperty?: Maybe<SchemaProperty>;
  /** An edge for our `SchemaProperty`. May be used by Relay 1. */
  schemaPropertyEdge?: Maybe<SchemaPropertiesEdge>;
  /** Reads a single `PropertyType` that is related to this `SchemaProperty`. */
  type?: Maybe<PropertyType>;
  /** Reads a single `User` that is related to this `SchemaProperty`. */
  userByBy?: Maybe<User>;
};


/** The output of our delete `SchemaProperty` mutation. */
export type DeleteSchemaPropertyPayloadSchemaPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
};

/** All input for the `deleteUserByLogin` mutation. */
export type DeleteUserByLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User's login name (User name).  */
  login: Scalars['String']['input'];
};

/** All input for the `deleteUserByNodeId` mutation. */
export type DeleteUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserGroupByGroupName` mutation. */
export type DeleteUserGroupByGroupNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User Group name.  */
  groupName: Scalars['String']['input'];
};

/** All input for the `deleteUserGroupByNodeId` mutation. */
export type DeleteUserGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserGroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUserGroup` mutation. */
export type DeleteUserGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User Group unique ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UserGroup` mutation. */
export type DeleteUserGroupPayload = {
  __typename?: 'DeleteUserGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserGroup`. */
  userByBy?: Maybe<User>;
  /** The `UserGroup` that was deleted by this mutation. */
  userGroup?: Maybe<UserGroup>;
  /** An edge for our `UserGroup`. May be used by Relay 1. */
  userGroupEdge?: Maybe<UserGroupsEdge>;
};


/** The output of our delete `UserGroup` mutation. */
export type DeleteUserGroupPayloadUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User unique ID. */
  id: Scalars['UUID']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUsersToGroupByNodeId` mutation. */
export type DeleteUsersToGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UsersToGroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUsersToGroupByUserIdAndUserGroupId` mutation. */
export type DeleteUsersToGroupByUserIdAndUserGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User Group unique ID. */
  userGroupId: Scalars['UUID']['input'];
  /** User unique ID. */
  userId: Scalars['UUID']['input'];
};

/** All input for the `deleteUsersToGroup` mutation. */
export type DeleteUsersToGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UsersToGroup` mutation. */
export type DeleteUsersToGroupPayload = {
  __typename?: 'DeleteUsersToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUsersToGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UsersToGroup`. */
  user?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `UsersToGroup`. */
  userGroup?: Maybe<UserGroup>;
  /** The `UsersToGroup` that was deleted by this mutation. */
  usersToGroup?: Maybe<UsersToGroup>;
  /** An edge for our `UsersToGroup`. May be used by Relay 1. */
  usersToGroupEdge?: Maybe<UsersToGroupsEdge>;
};


/** The output of our delete `UsersToGroup` mutation. */
export type DeleteUsersToGroupPayloadUsersToGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
};

/** All input for the `deleteUsersToObjectByNodeId` mutation. */
export type DeleteUsersToObjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UsersToObject` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteUsersToObjectByUserIdAndObjectId` mutation. */
export type DeleteUsersToObjectByUserIdAndObjectIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Object unique ID. */
  objectId: Scalars['UUID']['input'];
  /** User unique ID. */
  userId: Scalars['UUID']['input'];
};

/** All input for the `deleteUsersToObject` mutation. */
export type DeleteUsersToObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UsersToObject` mutation. */
export type DeleteUsersToObjectPayload = {
  __typename?: 'DeleteUsersToObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUsersToObjectNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Object` that is related to this `UsersToObject`. */
  object?: Maybe<Object>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UsersToObject`. */
  user?: Maybe<User>;
  /** The `UsersToObject` that was deleted by this mutation. */
  usersToObject?: Maybe<UsersToObject>;
  /** An edge for our `UsersToObject`. May be used by Relay 1. */
  usersToObjectEdge?: Maybe<UsersToObjectsEdge>;
};


/** The output of our delete `UsersToObject` mutation. */
export type DeleteUsersToObjectPayloadUsersToObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
};

/** An input for mutations affecting `DetailedObject` */
export type DetailedObjectInput = {
  childs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyedProperties?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  namedProperties?: InputMaybe<Array<InputMaybe<PropertyByNameInput>>>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  parents?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  properties?: InputMaybe<Array<InputMaybe<PropertyByIdInput>>>;
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

export enum Expiry {
  Expired = 'EXPIRED',
  ExpiringSoon = 'EXPIRING_SOON',
  LongExpired = 'LONG_EXPIRED',
  NotExpired = 'NOT_EXPIRED'
}

/** All input for the `exportConfiguration` mutation. */
export type ExportConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `exportConfiguration` mutation. */
export type ExportConfigurationPayload = {
  __typename?: 'ExportConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']['output']>;
};

/** All input for the `iDoInsertControlExecution` mutation. */
export type IDoInsertControlExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
};

/** The output of our `iDoInsertControlExecution` mutation. */
export type IDoInsertControlExecutionPayload = {
  __typename?: 'IDoInsertControlExecutionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `importSchema` mutation. */
export type ImportSchemaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jsonSchema?: InputMaybe<Scalars['String']['input']>;
  preserveDefaultValues?: InputMaybe<Scalars['Boolean']['input']>;
  updateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The output of our `importSchema` mutation. */
export type ImportSchemaPayload = {
  __typename?: 'ImportSchemaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']['output']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']['output']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']['output']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']['output']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type License = {
  __typename?: 'License';
  expired?: Maybe<Expiry>;
  info?: Maybe<Scalars['JSON']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type ListenControlExecutionsPayload = {
  __typename?: 'ListenControlExecutionsPayload';
  event?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']['output']>;
};

export type ListenNotificationsPayload = {
  __typename?: 'ListenNotificationsPayload';
  event?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']['output']>;
};

export type ListenObjectsPayload = {
  __typename?: 'ListenObjectsPayload';
  event?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']['output']>;
};

export type ListenPayload = {
  __typename?: 'ListenPayload';
  event?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']['output']>;
};

export type ListenSchemasPayload = {
  __typename?: 'ListenSchemasPayload';
  event?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']['output']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Generates Access Token String from Refresh Token.  */
  authAccessToken?: Maybe<AuthAccessTokenPayload>;
  /** Returns a Refresh Token String if authorization is successful. Refresh Token can be used to get Access Token.  */
  authRefreshToken?: Maybe<AuthRefreshTokenPayload>;
  bumpSchemaVersion?: Maybe<BumpSchemaVersionPayload>;
  /** Creates a single `ControlExecution`. */
  createControlExecution?: Maybe<CreateControlExecutionPayload>;
  /** Register intermediary or final report of the RPC/Control execution.  */
  createControlExecutionReport?: Maybe<CreateControlExecutionReportPayload>;
  /** Initiate execution of Stealth RPC/Control.  */
  createControlExecutionStealth?: Maybe<CreateControlExecutionStealthPayload>;
  createControlExecutionStealthByPropertyValue?: Maybe<CreateControlExecutionStealthByPropertyValuePayload>;
  createControlExecutionSync?: Maybe<CreateControlExecutionSyncPayload>;
  /** Creates a single `Notification`. */
  createNotification?: Maybe<CreateNotificationPayload>;
  /** Creates a single `NotificationDelivery`. */
  createNotificationDelivery?: Maybe<CreateNotificationDeliveryPayload>;
  /** Creates a single `Object`. */
  createObject?: Maybe<CreateObjectPayload>;
  /** Creates copy of an object with all it's properties and fragments values. Optionally it copies also all linked objects and keep linked properties. */
  createObjectCopy?: Maybe<CreateObjectCopyPayload>;
  /** Creates a single `ObjectPropertiesHistory`. */
  createObjectPropertiesHistory?: Maybe<CreateObjectPropertiesHistoryPayload>;
  createObjectWithProperties?: Maybe<CreateObjectWithPropertiesPayload>;
  /** Creates a single `ObjectsToObject`. */
  createObjectsToObject?: Maybe<CreateObjectsToObjectPayload>;
  /** Creates ObjectToObject relation for each pair of source and destination  uuid arrays members.  If relationship already exists, it's skipped. Returns number of rows actually inserted. */
  createObjectsToObjects?: Maybe<CreateObjectsToObjectsPayload>;
  /** Creates a single `PropertyType`. */
  createPropertyType?: Maybe<CreatePropertyTypePayload>;
  /** Creates a single `Schema`. */
  createSchema?: Maybe<CreateSchemaPayload>;
  /** Creates a single `SchemaControl`. */
  createSchemaControl?: Maybe<CreateSchemaControlPayload>;
  /** Creates a Schema copy.  */
  createSchemaCopy?: Maybe<CreateSchemaCopyPayload>;
  /** Creates a single `SchemaProperty`. */
  createSchemaProperty?: Maybe<CreateSchemaPropertyPayload>;
  /** Creates a single `Translation`. */
  createTranslation?: Maybe<CreateTranslationPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserGroup`. */
  createUserGroup?: Maybe<CreateUserGroupPayload>;
  /** Creates a single `UsersToGroup`. */
  createUsersToGroup?: Maybe<CreateUsersToGroupPayload>;
  /** Creates a single `UsersToObject`. */
  createUsersToObject?: Maybe<CreateUsersToObjectPayload>;
  /** Deletes a single `Object` using a unique key. */
  deleteObject?: Maybe<DeleteObjectPayload>;
  /** Deletes a single `Object` using its globally unique id. */
  deleteObjectByNodeId?: Maybe<DeleteObjectPayload>;
  /** Deletes a single `ObjectPropertiesHistory` using a unique key. */
  deleteObjectPropertiesHistory?: Maybe<DeleteObjectPropertiesHistoryPayload>;
  /** Deletes a single `ObjectPropertiesHistory` using its globally unique id. */
  deleteObjectPropertiesHistoryByNodeId?: Maybe<DeleteObjectPropertiesHistoryPayload>;
  /** Deletes a single `ObjectsToObject` using a unique key. */
  deleteObjectsToObject?: Maybe<DeleteObjectsToObjectPayload>;
  /** Deletes a single `ObjectsToObject` using its globally unique id. */
  deleteObjectsToObjectByNodeId?: Maybe<DeleteObjectsToObjectPayload>;
  /** Deletes a single `ObjectsToObject` using a unique key. */
  deleteObjectsToObjectByObject1IdAndObject2Id?: Maybe<DeleteObjectsToObjectPayload>;
  /** Deletes a single `PropertyType` using a unique key. */
  deletePropertyType?: Maybe<DeletePropertyTypePayload>;
  /** Deletes a single `PropertyType` using a unique key. */
  deletePropertyTypeByName?: Maybe<DeletePropertyTypePayload>;
  /** Deletes a single `PropertyType` using its globally unique id. */
  deletePropertyTypeByNodeId?: Maybe<DeletePropertyTypePayload>;
  /** Deletes a single `Schema` using a unique key. */
  deleteSchema?: Maybe<DeleteSchemaPayload>;
  /** Deletes a single `Schema` using its globally unique id. */
  deleteSchemaByNodeId?: Maybe<DeleteSchemaPayload>;
  /** Deletes a single `SchemaControl` using a unique key. */
  deleteSchemaControl?: Maybe<DeleteSchemaControlPayload>;
  /** Deletes a single `SchemaControl` using its globally unique id. */
  deleteSchemaControlByNodeId?: Maybe<DeleteSchemaControlPayload>;
  /** Deletes a single `SchemaProperty` using a unique key. */
  deleteSchemaProperty?: Maybe<DeleteSchemaPropertyPayload>;
  /** Deletes a single `SchemaProperty` using its globally unique id. */
  deleteSchemaPropertyByNodeId?: Maybe<DeleteSchemaPropertyPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByLogin?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUserByNodeId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserGroup` using a unique key. */
  deleteUserGroup?: Maybe<DeleteUserGroupPayload>;
  /** Deletes a single `UserGroup` using a unique key. */
  deleteUserGroupByGroupName?: Maybe<DeleteUserGroupPayload>;
  /** Deletes a single `UserGroup` using its globally unique id. */
  deleteUserGroupByNodeId?: Maybe<DeleteUserGroupPayload>;
  /** Deletes a single `UsersToGroup` using a unique key. */
  deleteUsersToGroup?: Maybe<DeleteUsersToGroupPayload>;
  /** Deletes a single `UsersToGroup` using its globally unique id. */
  deleteUsersToGroupByNodeId?: Maybe<DeleteUsersToGroupPayload>;
  /** Deletes a single `UsersToGroup` using a unique key. */
  deleteUsersToGroupByUserIdAndUserGroupId?: Maybe<DeleteUsersToGroupPayload>;
  /** Deletes a single `UsersToObject` using a unique key. */
  deleteUsersToObject?: Maybe<DeleteUsersToObjectPayload>;
  /** Deletes a single `UsersToObject` using its globally unique id. */
  deleteUsersToObjectByNodeId?: Maybe<DeleteUsersToObjectPayload>;
  /** Deletes a single `UsersToObject` using a unique key. */
  deleteUsersToObjectByUserIdAndObjectId?: Maybe<DeleteUsersToObjectPayload>;
  exportConfiguration?: Maybe<ExportConfigurationPayload>;
  iDoInsertControlExecution?: Maybe<IDoInsertControlExecutionPayload>;
  /**
   * Import schema into the platform in JSON format (which should be passed as an escaped String parameter). Use ExportSchema to get the file which can be edited if needed and then imported. If ID of Schema is omitted, then Platform would try to use Identification Tags to check for schema existence in the Platform. All schemas with matching Identification Tags would be updated. Otherwise, new schema would be created.
   * UpdateOnly mode can be used to update only existing schemas in the Platform, no new schemas would be added. It is false by default and can be omitted.
   */
  importSchema?: Maybe<ImportSchemaPayload>;
  /** Creates one or many `Object`. */
  mnCreateObject?: Maybe<MnCreateObjectPayload>;
  /** Creates one or many `Schema`. */
  mnCreateSchema?: Maybe<MnCreateSchemaPayload>;
  /** Creates one or many `User`. */
  mnCreateUser?: Maybe<MnCreateUserPayload>;
  /** Deletes one or many `Object` a unique key via a patch. */
  mnDeleteObject?: Maybe<MnDeleteObjectPayload>;
  /** Deletes one or many `Schema` a unique key via a patch. */
  mnDeleteSchema?: Maybe<MnDeleteSchemaPayload>;
  /** Deletes one or many `User` a unique key via a patch. */
  mnDeleteUser?: Maybe<MnDeleteUserPayload>;
  /** Updates one or many `Object` using a unique key and a patch. */
  mnUpdateObject?: Maybe<MnUpdateObjectPayload>;
  /** Updates one or many `Schema` using a unique key and a patch. */
  mnUpdateSchema?: Maybe<MnUpdateSchemaPayload>;
  /** Updates one or many `User` using a unique key and a patch. */
  mnUpdateUser?: Maybe<MnUpdateUserPayload>;
  /** Reset object property by uuid to default value from schema. */
  resetProperty?: Maybe<ResetPropertyPayload>;
  /** Returns set of permissions (edit, use, read) provided to user to access entire object. If user_id is omitted, uses i_current_user_id() instead. */
  resolveObjectPermissions?: Maybe<ResolveObjectPermissionsPayload>;
  /** Set/unset objects as a favourite.  */
  setObjectFavourite?: Maybe<SetObjectFavouritePayload>;
  /** Set/unset object as a muted.  */
  setObjectMuted?: Maybe<SetObjectMutedPayload>;
  /** Acknowledge RPC/Control receive. */
  updateControlExecutionAck?: Maybe<UpdateControlExecutionAckPayload>;
  /** Update Property of Json Array type with provided array element.  */
  updateJsonPropertyArray?: Maybe<UpdateJsonPropertyArrayPayload>;
  /** Updates a single `Object` using a unique key and a patch. */
  updateObject?: Maybe<UpdateObjectPayload>;
  /** Updates a single `Object` using its globally unique id and a patch. */
  updateObjectByNodeId?: Maybe<UpdateObjectPayload>;
  /** Update object properties by their respective ids.  */
  updateObjectPropertiesById?: Maybe<UpdateObjectPropertiesByIdPayload>;
  updateObjectPropertiesByKey?: Maybe<UpdateObjectPropertiesByKeyPayload>;
  updateObjectPropertiesByName?: Maybe<UpdateObjectPropertiesByNamePayload>;
  /** Updates a single `ObjectPropertiesHistory` using a unique key and a patch. */
  updateObjectPropertiesHistory?: Maybe<UpdateObjectPropertiesHistoryPayload>;
  /** Updates a single `ObjectPropertiesHistory` using its globally unique id and a patch. */
  updateObjectPropertiesHistoryByNodeId?: Maybe<UpdateObjectPropertiesHistoryPayload>;
  /** Updates a single `ObjectProperty` using a unique key and a patch. */
  updateObjectProperty?: Maybe<UpdateObjectPropertyPayload>;
  /** Updates a single `ObjectProperty` using its globally unique id and a patch. */
  updateObjectPropertyByNodeId?: Maybe<UpdateObjectPropertyPayload>;
  /**
   * Update PropertyValue by ObjectID & GroupName & PropertyName.
   * @deprecated true
   */
  updateObjectPropertyByObjectGroupProperty?: Maybe<UpdateObjectPropertyByObjectGroupPropertyPayload>;
  /** Allows to update an Object, update its Properties, update links to Parent Objects and update links to Child Objects. */
  updateObjectWithProperties?: Maybe<UpdateObjectWithPropertiesPayload>;
  updateObjectsPropertiesByKey?: Maybe<UpdateObjectsPropertiesByKeyPayload>;
  /** Updates a single `PropertyType` using a unique key and a patch. */
  updatePropertyType?: Maybe<UpdatePropertyTypePayload>;
  /** Updates a single `PropertyType` using a unique key and a patch. */
  updatePropertyTypeByName?: Maybe<UpdatePropertyTypePayload>;
  /** Updates a single `PropertyType` using its globally unique id and a patch. */
  updatePropertyTypeByNodeId?: Maybe<UpdatePropertyTypePayload>;
  /** Updates a single `Schema` using a unique key and a patch. */
  updateSchema?: Maybe<UpdateSchemaPayload>;
  /** Updates a single `Schema` using its globally unique id and a patch. */
  updateSchemaByNodeId?: Maybe<UpdateSchemaPayload>;
  /** Updates a single `SchemaControl` using a unique key and a patch. */
  updateSchemaControl?: Maybe<UpdateSchemaControlPayload>;
  /** Updates a single `SchemaControl` using its globally unique id and a patch. */
  updateSchemaControlByNodeId?: Maybe<UpdateSchemaControlPayload>;
  /**
   * Update schema properties defaults by their respective ids.
   * @deprecated true
   */
  updateSchemaPropertiesById?: Maybe<UpdateSchemaPropertiesByIdPayload>;
  /** Update schema properties default values and if value_init set to true, initialise all object properties, derived from this schema, with default values.  */
  updateSchemaPropertiesDefaults?: Maybe<UpdateSchemaPropertiesDefaultsPayload>;
  /** Updates a single `SchemaProperty` using a unique key and a patch. */
  updateSchemaProperty?: Maybe<UpdateSchemaPropertyPayload>;
  /** Updates a single `SchemaProperty` using its globally unique id and a patch. */
  updateSchemaPropertyByNodeId?: Maybe<UpdateSchemaPropertyPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByLogin?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserByNodeId?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserGroup` using a unique key and a patch. */
  updateUserGroup?: Maybe<UpdateUserGroupPayload>;
  /** Updates a single `UserGroup` using a unique key and a patch. */
  updateUserGroupByGroupName?: Maybe<UpdateUserGroupPayload>;
  /** Updates a single `UserGroup` using its globally unique id and a patch. */
  updateUserGroupByNodeId?: Maybe<UpdateUserGroupPayload>;
  /** Updates a single `UsersToGroup` using a unique key and a patch. */
  updateUsersToGroup?: Maybe<UpdateUsersToGroupPayload>;
  /** Updates a single `UsersToGroup` using its globally unique id and a patch. */
  updateUsersToGroupByNodeId?: Maybe<UpdateUsersToGroupPayload>;
  /** Updates a single `UsersToGroup` using a unique key and a patch. */
  updateUsersToGroupByUserIdAndUserGroupId?: Maybe<UpdateUsersToGroupPayload>;
  /** Updates a single `UsersToObject` using a unique key and a patch. */
  updateUsersToObject?: Maybe<UpdateUsersToObjectPayload>;
  /** Updates a single `UsersToObject` using its globally unique id and a patch. */
  updateUsersToObjectByNodeId?: Maybe<UpdateUsersToObjectPayload>;
  /** Updates a single `UsersToObject` using a unique key and a patch. */
  updateUsersToObjectByUserIdAndObjectId?: Maybe<UpdateUsersToObjectPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthAccessTokenArgs = {
  input: AuthAccessTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthRefreshTokenArgs = {
  input: AuthRefreshTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBumpSchemaVersionArgs = {
  input: BumpSchemaVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlExecutionArgs = {
  input: CreateControlExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlExecutionReportArgs = {
  input: CreateControlExecutionReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlExecutionStealthArgs = {
  input: CreateControlExecutionStealthInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlExecutionStealthByPropertyValueArgs = {
  input: CreateControlExecutionStealthByPropertyValueInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateControlExecutionSyncArgs = {
  input: CreateControlExecutionSyncInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationDeliveryArgs = {
  input: CreateNotificationDeliveryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateObjectArgs = {
  input: CreateObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateObjectCopyArgs = {
  input: CreateObjectCopyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateObjectPropertiesHistoryArgs = {
  input: CreateObjectPropertiesHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateObjectWithPropertiesArgs = {
  input: CreateObjectWithPropertiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateObjectsToObjectArgs = {
  input: CreateObjectsToObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateObjectsToObjectsArgs = {
  input: CreateObjectsToObjectsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePropertyTypeArgs = {
  input: CreatePropertyTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaArgs = {
  input: CreateSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaControlArgs = {
  input: CreateSchemaControlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaCopyArgs = {
  input: CreateSchemaCopyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSchemaPropertyArgs = {
  input: CreateSchemaPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTranslationArgs = {
  input: CreateTranslationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserGroupArgs = {
  input: CreateUserGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUsersToGroupArgs = {
  input: CreateUsersToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUsersToObjectArgs = {
  input: CreateUsersToObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectArgs = {
  input: DeleteObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectByNodeIdArgs = {
  input: DeleteObjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectPropertiesHistoryArgs = {
  input: DeleteObjectPropertiesHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectPropertiesHistoryByNodeIdArgs = {
  input: DeleteObjectPropertiesHistoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectsToObjectArgs = {
  input: DeleteObjectsToObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectsToObjectByNodeIdArgs = {
  input: DeleteObjectsToObjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteObjectsToObjectByObject1IdAndObject2IdArgs = {
  input: DeleteObjectsToObjectByObject1IdAndObject2IdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyTypeArgs = {
  input: DeletePropertyTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyTypeByNameArgs = {
  input: DeletePropertyTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyTypeByNodeIdArgs = {
  input: DeletePropertyTypeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaArgs = {
  input: DeleteSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaByNodeIdArgs = {
  input: DeleteSchemaByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaControlArgs = {
  input: DeleteSchemaControlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaControlByNodeIdArgs = {
  input: DeleteSchemaControlByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaPropertyArgs = {
  input: DeleteSchemaPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchemaPropertyByNodeIdArgs = {
  input: DeleteSchemaPropertyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByLoginArgs = {
  input: DeleteUserByLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByNodeIdArgs = {
  input: DeleteUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserGroupArgs = {
  input: DeleteUserGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserGroupByGroupNameArgs = {
  input: DeleteUserGroupByGroupNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserGroupByNodeIdArgs = {
  input: DeleteUserGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersToGroupArgs = {
  input: DeleteUsersToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersToGroupByNodeIdArgs = {
  input: DeleteUsersToGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersToGroupByUserIdAndUserGroupIdArgs = {
  input: DeleteUsersToGroupByUserIdAndUserGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersToObjectArgs = {
  input: DeleteUsersToObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersToObjectByNodeIdArgs = {
  input: DeleteUsersToObjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersToObjectByUserIdAndObjectIdArgs = {
  input: DeleteUsersToObjectByUserIdAndObjectIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExportConfigurationArgs = {
  input: ExportConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationIDoInsertControlExecutionArgs = {
  input: IDoInsertControlExecutionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportSchemaArgs = {
  input: ImportSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateObjectArgs = {
  input: MnCreateObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateSchemaArgs = {
  input: MnCreateSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateUserArgs = {
  input: MnCreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteObjectArgs = {
  input: MnDeleteObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteSchemaArgs = {
  input: MnDeleteSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteUserArgs = {
  input: MnDeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateObjectArgs = {
  input: MnUpdateObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateSchemaArgs = {
  input: MnUpdateSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateUserArgs = {
  input: MnUpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPropertyArgs = {
  input: ResetPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResolveObjectPermissionsArgs = {
  input: ResolveObjectPermissionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetObjectFavouriteArgs = {
  input: SetObjectFavouriteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetObjectMutedArgs = {
  input: SetObjectMutedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateControlExecutionAckArgs = {
  input: UpdateControlExecutionAckInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateJsonPropertyArrayArgs = {
  input: UpdateJsonPropertyArrayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectArgs = {
  input: UpdateObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectByNodeIdArgs = {
  input: UpdateObjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertiesByIdArgs = {
  input: UpdateObjectPropertiesByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertiesByKeyArgs = {
  input: UpdateObjectPropertiesByKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertiesByNameArgs = {
  input: UpdateObjectPropertiesByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertiesHistoryArgs = {
  input: UpdateObjectPropertiesHistoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertiesHistoryByNodeIdArgs = {
  input: UpdateObjectPropertiesHistoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertyArgs = {
  input: UpdateObjectPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertyByNodeIdArgs = {
  input: UpdateObjectPropertyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectPropertyByObjectGroupPropertyArgs = {
  input: UpdateObjectPropertyByObjectGroupPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectWithPropertiesArgs = {
  input: UpdateObjectWithPropertiesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateObjectsPropertiesByKeyArgs = {
  input: UpdateObjectsPropertiesByKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyTypeArgs = {
  input: UpdatePropertyTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyTypeByNameArgs = {
  input: UpdatePropertyTypeByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyTypeByNodeIdArgs = {
  input: UpdatePropertyTypeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaArgs = {
  input: UpdateSchemaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaByNodeIdArgs = {
  input: UpdateSchemaByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaControlArgs = {
  input: UpdateSchemaControlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaControlByNodeIdArgs = {
  input: UpdateSchemaControlByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaPropertiesByIdArgs = {
  input: UpdateSchemaPropertiesByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaPropertiesDefaultsArgs = {
  input: UpdateSchemaPropertiesDefaultsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaPropertyArgs = {
  input: UpdateSchemaPropertyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSchemaPropertyByNodeIdArgs = {
  input: UpdateSchemaPropertyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByLoginArgs = {
  input: UpdateUserByLoginInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByNodeIdArgs = {
  input: UpdateUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserGroupArgs = {
  input: UpdateUserGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserGroupByGroupNameArgs = {
  input: UpdateUserGroupByGroupNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserGroupByNodeIdArgs = {
  input: UpdateUserGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUsersToGroupArgs = {
  input: UpdateUsersToGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUsersToGroupByNodeIdArgs = {
  input: UpdateUsersToGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUsersToGroupByUserIdAndUserGroupIdArgs = {
  input: UpdateUsersToGroupByUserIdAndUserGroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUsersToObjectArgs = {
  input: UpdateUsersToObjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUsersToObjectByNodeIdArgs = {
  input: UpdateUsersToObjectByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUsersToObjectByUserIdAndObjectIdArgs = {
  input: UpdateUsersToObjectByUserIdAndObjectIdInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** Notification represents the Notification generated within the platform.  */
export type Notification = Node & {
  __typename?: 'Notification';
  by: Scalars['UUID']['output'];
  /** Synthetic field: returns a user name, creator of the notification. */
  byName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveries: Array<NotificationDelivery>;
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveriesConnection: NotificationDeliveriesConnection;
  /** Reads a single `Object` that is related to this `Notification`. */
  object?: Maybe<Object>;
  objectId?: Maybe<Scalars['UUID']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
  spec?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Reads a single `User` that is related to this `Notification`. */
  userByBy?: Maybe<User>;
};


/** Notification represents the Notification generated within the platform.  */
export type NotificationNotificationDeliveriesArgs = {
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** Notification represents the Notification generated within the platform.  */
export type NotificationNotificationDeliveriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `objectName` field. */
  objectName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `spec` field. */
  spec?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection to a list of `NotificationDelivery` values. */
export type NotificationDeliveriesConnection = {
  __typename?: 'NotificationDeliveriesConnection';
  /** A list of edges which contains the `NotificationDelivery` and cursor to aid in pagination. */
  edges: Array<NotificationDeliveriesEdge>;
  /** A list of `NotificationDelivery` objects. */
  nodes: Array<Maybe<NotificationDelivery>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationDelivery` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NotificationDelivery` edge in the connection. */
export type NotificationDeliveriesEdge = {
  __typename?: 'NotificationDeliveriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NotificationDelivery` at the end of the edge. */
  node?: Maybe<NotificationDelivery>;
};

/** Methods to use when ordering `NotificationDelivery`. */
export enum NotificationDeliveriesOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeliveredAsc = 'DELIVERED_ASC',
  DeliveredDesc = 'DELIVERED_DESC',
  DeliveryConfigIdAsc = 'DELIVERY_CONFIG_ID_ASC',
  DeliveryConfigIdDesc = 'DELIVERY_CONFIG_ID_DESC',
  DeliveryPathAsc = 'DELIVERY_PATH_ASC',
  DeliveryPathDesc = 'DELIVERY_PATH_DESC',
  ErrorAsc = 'ERROR_ASC',
  ErrorDesc = 'ERROR_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  Natural = 'NATURAL',
  NotificationIdAsc = 'NOTIFICATION_ID_ASC',
  NotificationIdDesc = 'NOTIFICATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserLoginAsc = 'USER_LOGIN_ASC',
  UserLoginDesc = 'USER_LOGIN_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type NotificationDeliveriesSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: NotificationDeliveriesSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type NotificationDeliveriesSortBy = {
  field?: InputMaybe<NotificationDeliveriesSortableField>;
};

/** Sortable concrete fields for the `NotificationDelivery` type. */
export enum NotificationDeliveriesSortableField {
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  Delivered = 'DELIVERED',
  DeliveryConfigId = 'DELIVERY_CONFIG_ID',
  DeliveryPath = 'DELIVERY_PATH',
  Error = 'ERROR',
  Id = 'ID',
  Message = 'MESSAGE',
  NotificationId = 'NOTIFICATION_ID',
  User = 'USER',
  UserLogin = 'USER_LOGIN'
}

/** Notification Delivery is used to represent an individual event of Notification delivery via supported delivery ways (i.e. email, SMS, whatsapp, other).  */
export type NotificationDelivery = Node & {
  __typename?: 'NotificationDelivery';
  by: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  delivered: Scalars['Boolean']['output'];
  /** Reads a single `Object` that is related to this `NotificationDelivery`. */
  deliveryConfig?: Maybe<Object>;
  deliveryConfigId?: Maybe<Scalars['UUID']['output']>;
  deliveryPath: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /** Notification Delivery unique ID. */
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Notification` that is related to this `NotificationDelivery`. */
  notification?: Maybe<Notification>;
  notificationId: Scalars['UUID']['output'];
  user?: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `User` that is related to this `NotificationDelivery`. */
  userByUser?: Maybe<User>;
  userLogin: Scalars['String']['output'];
};

/**
 * A condition to be used against `NotificationDelivery` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type NotificationDeliveryCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `delivered` field. */
  delivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `deliveryConfigId` field. */
  deliveryConfigId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `deliveryPath` field. */
  deliveryPath?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `error` field. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `notificationId` field. */
  notificationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `user` field. */
  user?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userLogin` field. */
  userLogin?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `NotificationDelivery` object types. All fields are combined with a logical ‘and.’ */
export type NotificationDeliveryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationDeliveryFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `delivered` field. */
  delivered?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `deliveryConfig` relation. */
  deliveryConfig?: InputMaybe<ObjectFilter>;
  /** A related `deliveryConfig` exists. */
  deliveryConfigExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `deliveryConfigId` field. */
  deliveryConfigId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `deliveryPath` field. */
  deliveryPath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `error` field. */
  error?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationDeliveryFilter>;
  /** Filter by the object’s `notification` relation. */
  notification?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationId` field. */
  notificationId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationDeliveryFilter>>;
  /** Filter by the object’s `user` field. */
  user?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userByUser` relation. */
  userByUser?: InputMaybe<UserFilter>;
  /** A related `userByUser` exists. */
  userByUserExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userLogin` field. */
  userLogin?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `NotificationDelivery` */
export type NotificationDeliveryInput = {
  delivered: Scalars['Boolean']['input'];
  deliveryConfigId?: InputMaybe<Scalars['UUID']['input']>;
  deliveryPath: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  /** Notification Delivery unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  message: Scalars['String']['input'];
  notificationId: Scalars['UUID']['input'];
  user?: InputMaybe<Scalars['UUID']['input']>;
  userLogin: Scalars['String']['input'];
};

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `byName` field. */
  byName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationFilter>;
  /** Filter by the object’s `notificationDeliveriesConnection` relation. */
  notificationDeliveriesConnection?: InputMaybe<NotificationToManyNotificationDeliveryFilter>;
  /** Some related `notificationDeliveriesConnection` exist. */
  notificationDeliveriesConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `object` relation. */
  object?: InputMaybe<ObjectFilter>;
  /** A related `object` exists. */
  objectExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `objectName` field. */
  objectName?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
};

/** An input for mutations affecting `Notification` */
export type NotificationInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  message: Scalars['String']['input'];
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A filter to be used against many `NotificationDelivery` object types. All fields are combined with a logical ‘and.’ */
export type NotificationToManyNotificationDeliveryFilter = {
  /** Every related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationDeliveryFilter>;
  /** No related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationDeliveryFilter>;
  /** Some related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationDeliveryFilter>;
};

/** A connection to a list of `Notification` values. */
export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<NotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Maybe<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Notification` edge in the connection. */
export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Notification` at the end of the edge. */
  node?: Maybe<Notification>;
};

/** Methods to use when ordering `Notification`. */
export enum NotificationsOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  ByNameAsc = 'BY_NAME_ASC',
  ByNameDesc = 'BY_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ObjectNameAsc = 'OBJECT_NAME_ASC',
  ObjectNameDesc = 'OBJECT_NAME_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SpecAsc = 'SPEC_ASC',
  SpecDesc = 'SPEC_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type NotificationsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: NotificationsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type NotificationsSortBy = {
  field?: InputMaybe<NotificationsSortableField>;
};

/** Sortable concrete fields for the `Notification` type. */
export enum NotificationsSortableField {
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Message = 'MESSAGE',
  ObjectId = 'OBJECT_ID',
  ObjectName = 'OBJECT_NAME',
  Spec = 'SPEC',
  Tags = 'TAGS'
}

/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type Object = Node & {
  __typename?: 'Object';
  /** User last updated the Object. */
  by?: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `ControlExecution`. */
  controlExecutions: Array<ControlExecution>;
  /** Reads and enables pagination through a set of `ControlExecution`. */
  controlExecutionsConnection: ControlExecutionsConnection;
  /** Object creation timestamp. */
  createdAt: Scalars['Datetime']['output'];
  /** Object description */
  description?: Maybe<Scalars['String']['output']>;
  /** Returns "Device/BATTERY_LEVEL" property for an object.  */
  deviceBatteryLevel?: Maybe<Scalars['JSON']['output']>;
  /** Returns "Device/DC_POWER" property for an object.  */
  deviceBatteryType?: Maybe<Scalars['JSON']['output']>;
  /** Returns "Device/Emulation" property for an object.  */
  deviceEmulation?: Maybe<Scalars['JSON']['output']>;
  /** Returns "Device/RESPONSE_STATUS" property for an object.  */
  deviceResponseStatus?: Maybe<Scalars['JSON']['output']>;
  dynamicAttribute?: Maybe<Scalars['JSON']['output']>;
  /** User Group with EditorGroup access permission.  */
  editorgroup: Scalars['UUID']['output'];
  /** Administrative Object's status. */
  enabled: Scalars['Boolean']['output'];
  /** Synthetic field: returns "true" if object is favourite and "false" if not.  */
  favourite?: Maybe<Scalars['Boolean']['output']>;
  /** Synthetic field: returns user group name based on the provided group type ("editorgroup/usergroup/readergroup") for this object. */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Returns true if current Object is a hard-linked to some parent Object (i.e. can't be removed directly). */
  hardLinked?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Object ID. */
  id: Scalars['UUID']['output'];
  /** Returns "Credentials/FILENAME" property for an object.  */
  mediaFilename?: Maybe<Scalars['JSON']['output']>;
  /** Returns "Credentials/SIZE" property for an object.  */
  mediaSize?: Maybe<Scalars['JSON']['output']>;
  /** Returns "Credentials/TYPE" property for an object.  */
  mediaType?: Maybe<Scalars['JSON']['output']>;
  /** Synthetic field: returns "true" if object is muted and "false" if not.  */
  muted?: Maybe<Scalars['Boolean']['output']>;
  /** Object's name. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveriesByDeliveryConfigId: Array<NotificationDelivery>;
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveriesByDeliveryConfigIdConnection: NotificationDeliveriesConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Array<Notification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection: NotificationsConnection;
  /** Reads and enables pagination through a set of `ObjectProperty`. */
  objectProperties: Array<ObjectProperty>;
  /** Reads and enables pagination through a set of `ObjectProperty`. */
  objectPropertiesConnection: ObjectPropertiesConnection;
  /** Reads and enables pagination through a set of `ObjectsToObject`. */
  objectsToObjectsByObject1Id: Array<ObjectsToObject>;
  /** Reads and enables pagination through a set of `ObjectsToObject`. */
  objectsToObjectsByObject1IdConnection: ObjectsToObjectsConnection;
  /** Reads and enables pagination through a set of `ObjectsToObject`. */
  objectsToObjectsByObject2Id: Array<ObjectsToObject>;
  /** Reads and enables pagination through a set of `ObjectsToObject`. */
  objectsToObjectsByObject2IdConnection: ObjectsToObjectsConnection;
  /** Synthetic field: returns property value based on the provided property name in the format "group_name/property_name". */
  property?: Maybe<Scalars['JSON']['output']>;
  /** Synthetic field: returns property value (as bool) based on the provided property name in the format "group_name/property_name". */
  propertyBool?: Maybe<Scalars['Boolean']['output']>;
  /** Synthetic field: returns property value (as float) based on the provided property name in the format "group_name/property_name". */
  propertyDouble?: Maybe<Scalars['Float']['output']>;
  /** Synthetic field: returns property value (as int) based on the provided property name in the format "group_name/property_name". */
  propertyInt?: Maybe<Scalars['Int']['output']>;
  /** Synthetic field: returns property updatedAt value (timestamp) based on the provided property name in the format "group_name/property_name". */
  propertyTs?: Maybe<Scalars['Datetime']['output']>;
  /** User Group with ReaderGroup access permission.  */
  readergroup: Scalars['UUID']['output'];
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** ID of the Schema used to create the Object */
  schemaId: Scalars['UUID']['output'];
  /** Synthetic field: returns schema name for this object. */
  schemaName?: Maybe<Scalars['String']['output']>;
  /**
   * Synthetic field: returns the list of tags associated with object's schema.
   * @filterable
   */
  schemaTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Allows to return Schema tags (1) as a string with ":" delimiter and (2) with some tags provided as parameters filtered out.  */
  schemaTagsString?: Maybe<Scalars['String']['output']>;
  /** Synthetic field: returns schema type for this object. */
  schemaType?: Maybe<Scalars['String']['output']>;
  /** Synthetic field: returns object UUID as string for further filtering. */
  stringId?: Maybe<Scalars['String']['output']>;
  /** Tags for Object clusterization */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Object last update timestamp. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfiles: Array<UserProfile>;
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfilesConnection: UserProfilesConnection;
  /** User Group with UserGroup access permission.  */
  usergroup: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `UsersToObject`. */
  usersToObjects: Array<UsersToObject>;
  /** Reads and enables pagination through a set of `UsersToObject`. */
  usersToObjectsConnection: UsersToObjectsConnection;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectControlExecutionsArgs = {
  condition?: InputMaybe<ControlExecutionCondition>;
  filter?: InputMaybe<ControlExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
  sort?: InputMaybe<Array<ControlExecutionsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectControlExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlExecutionCondition>;
  filter?: InputMaybe<ControlExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
  sort?: InputMaybe<Array<ControlExecutionsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectDynamicAttributeArgs = {
  match?: InputMaybe<ObjectsDynamicAttribute>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectGroupNameArgs = {
  groupName?: InputMaybe<Scalars['String']['input']>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectNotificationDeliveriesByDeliveryConfigIdArgs = {
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectNotificationDeliveriesByDeliveryConfigIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectNotificationsArgs = {
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
  sort?: InputMaybe<Array<NotificationsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
  sort?: InputMaybe<Array<NotificationsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectObjectPropertiesArgs = {
  condition?: InputMaybe<ObjectPropertyCondition>;
  filter?: InputMaybe<ObjectPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectObjectPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectPropertyCondition>;
  filter?: InputMaybe<ObjectPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectObjectsToObjectsByObject1IdArgs = {
  condition?: InputMaybe<ObjectsToObjectCondition>;
  filter?: InputMaybe<ObjectsToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsToObjectsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectObjectsToObjectsByObject1IdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectsToObjectCondition>;
  filter?: InputMaybe<ObjectsToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsToObjectsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectObjectsToObjectsByObject2IdArgs = {
  condition?: InputMaybe<ObjectsToObjectCondition>;
  filter?: InputMaybe<ObjectsToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsToObjectsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectObjectsToObjectsByObject2IdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectsToObjectCondition>;
  filter?: InputMaybe<ObjectsToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsToObjectsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectPropertyArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectPropertyBoolArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectPropertyDoubleArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectPropertyIntArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectPropertyTsArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectSchemaTagsStringArgs = {
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectUserProfilesArgs = {
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  sort?: InputMaybe<Array<UserProfilesSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectUserProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  sort?: InputMaybe<Array<UserProfilesSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectUsersToObjectsArgs = {
  condition?: InputMaybe<UsersToObjectCondition>;
  filter?: InputMaybe<UsersToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
  sort?: InputMaybe<Array<UsersToObjectsSort>>;
};


/** The object is the main data structure operated within the platform. It can be of various types, it has associated Properties and its structure is controlled by Schemas. */
export type ObjectUsersToObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UsersToObjectCondition>;
  filter?: InputMaybe<UsersToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
  sort?: InputMaybe<Array<UsersToObjectsSort>>;
};

/** A condition to be used against `Object` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ObjectCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `deviceBatteryLevel` field. */
  deviceBatteryLevel?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `deviceBatteryType` field. */
  deviceBatteryType?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `deviceEmulation` field. */
  deviceEmulation?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `deviceResponseStatus` field. */
  deviceResponseStatus?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `editorgroup` field. */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `enabled` field. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `favourite` field. */
  favourite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mediaFilename` field. */
  mediaFilename?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `mediaSize` field. */
  mediaSize?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `mediaType` field. */
  mediaType?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `muted` field. */
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `readergroup` field. */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `schemaId` field. */
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `schemaName` field. */
  schemaName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `schemaType` field. */
  schemaType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `stringId` field. */
  stringId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usergroup` field. */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `Object` object types. All fields are combined with a logical ‘and.’ */
export type ObjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObjectFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `controlExecutionsConnection` relation. */
  controlExecutionsConnection?: InputMaybe<ObjectToManyControlExecutionFilter>;
  /** Some related `controlExecutionsConnection` exist. */
  controlExecutionsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `deviceBatteryLevel` field. */
  deviceBatteryLevel?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `deviceBatteryType` field. */
  deviceBatteryType?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `deviceEmulation` field. */
  deviceEmulation?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `deviceResponseStatus` field. */
  deviceResponseStatus?: InputMaybe<JsonFilter>;
  /** Filter by a dynamic field. */
  dynamicAttribute?: InputMaybe<ObjectsDynamicAttributeFilter>;
  /** Filter by the object’s `editorgroup` field. */
  editorgroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `enabled` field. */
  enabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `favourite` field. */
  favourite?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hardLinked` field. */
  hardLinked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mediaFilename` field. */
  mediaFilename?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `mediaSize` field. */
  mediaSize?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `mediaType` field. */
  mediaType?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `muted` field. */
  muted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObjectFilter>;
  /** Filter by the object’s `notificationDeliveriesByDeliveryConfigIdConnection` relation. */
  notificationDeliveriesByDeliveryConfigIdConnection?: InputMaybe<ObjectToManyNotificationDeliveryFilter>;
  /** Some related `notificationDeliveriesByDeliveryConfigIdConnection` exist. */
  notificationDeliveriesByDeliveryConfigIdConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `notificationsConnection` relation. */
  notificationsConnection?: InputMaybe<ObjectToManyNotificationFilter>;
  /** Some related `notificationsConnection` exist. */
  notificationsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectPropertiesConnection` relation. */
  objectPropertiesConnection?: InputMaybe<ObjectToManyObjectPropertyFilter>;
  /** Some related `objectPropertiesConnection` exist. */
  objectPropertiesConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectsToObjectsByObject1IdConnection` relation. */
  objectsToObjectsByObject1IdConnection?: InputMaybe<ObjectToManyObjectsToObjectFilter>;
  /** Some related `objectsToObjectsByObject1IdConnection` exist. */
  objectsToObjectsByObject1IdConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectsToObjectsByObject2IdConnection` relation. */
  objectsToObjectsByObject2IdConnection?: InputMaybe<ObjectToManyObjectsToObjectFilter>;
  /** Some related `objectsToObjectsByObject2IdConnection` exist. */
  objectsToObjectsByObject2IdConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObjectFilter>>;
  /** Filter by the object’s `readergroup` field. */
  readergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `schema` relation. */
  schema?: InputMaybe<SchemaFilter>;
  /** Filter by the object’s `schemaId` field. */
  schemaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `schemaName` field. */
  schemaName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `schemaTags` field. */
  schemaTags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `schemaType` field. */
  schemaType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `stringId` field. */
  stringId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tags` field. */
  tags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userGroupByEditorgroup` relation. */
  userGroupByEditorgroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupByReadergroup` relation. */
  userGroupByReadergroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupByUsergroup` relation. */
  userGroupByUsergroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userProfilesConnection` relation. */
  userProfilesConnection?: InputMaybe<ObjectToManyUserProfileFilter>;
  /** Some related `userProfilesConnection` exist. */
  userProfilesConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usergroup` field. */
  usergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `usersToObjectsConnection` relation. */
  usersToObjectsConnection?: InputMaybe<ObjectToManyUsersToObjectFilter>;
  /** Some related `usersToObjectsConnection` exist. */
  usersToObjectsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `Object` */
export type ObjectInput = {
  /** Object description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** User Group with EditorGroup access permission.  */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Administrative Object's status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Object ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Object's name. */
  name: Scalars['String']['input'];
  /** User Group with ReaderGroup access permission.  */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** ID of the Schema used to create the Object */
  schemaId: Scalars['UUID']['input'];
  /** Tags for Object clusterization */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User Group with UserGroup access permission.  */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents an update to a `Object`. Fields that are set will be updated. */
export type ObjectPatch = {
  /** Object description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** User Group with EditorGroup access permission.  */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Administrative Object's status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Object ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Object's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** User Group with ReaderGroup access permission.  */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** ID of the Schema used to create the Object */
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Tags for Object clusterization */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User Group with UserGroup access permission.  */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `ObjectProperty` values. */
export type ObjectPropertiesConnection = {
  __typename?: 'ObjectPropertiesConnection';
  /** A list of edges which contains the `ObjectProperty` and cursor to aid in pagination. */
  edges: Array<ObjectPropertiesEdge>;
  /** A list of `ObjectProperty` objects. */
  nodes: Array<Maybe<ObjectProperty>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObjectProperty` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ObjectProperty` edge in the connection. */
export type ObjectPropertiesEdge = {
  __typename?: 'ObjectPropertiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ObjectProperty` at the end of the edge. */
  node?: Maybe<ObjectProperty>;
};

/** A connection to a list of `ObjectPropertiesHistory` values. */
export type ObjectPropertiesHistoriesConnection = {
  __typename?: 'ObjectPropertiesHistoriesConnection';
  /** A list of edges which contains the `ObjectPropertiesHistory` and cursor to aid in pagination. */
  edges: Array<ObjectPropertiesHistoriesEdge>;
  /** A list of `ObjectPropertiesHistory` objects. */
  nodes: Array<Maybe<ObjectPropertiesHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObjectPropertiesHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ObjectPropertiesHistory` edge in the connection. */
export type ObjectPropertiesHistoriesEdge = {
  __typename?: 'ObjectPropertiesHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ObjectPropertiesHistory` at the end of the edge. */
  node?: Maybe<ObjectPropertiesHistory>;
};

/** Methods to use when ordering `ObjectPropertiesHistory`. */
export enum ObjectPropertiesHistoriesOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  GroupNameAsc = 'GROUP_NAME_ASC',
  GroupNameDesc = 'GROUP_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyAsc = 'PROPERTY_ASC',
  PropertyDesc = 'PROPERTY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  RecordedAtAsc = 'RECORDED_AT_ASC',
  RecordedAtDesc = 'RECORDED_AT_DESC',
  TransactionIdAsc = 'TRANSACTION_ID_ASC',
  TransactionIdDesc = 'TRANSACTION_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export type ObjectPropertiesHistory = Node & {
  __typename?: 'ObjectPropertiesHistory';
  by?: Maybe<Scalars['UUID']['output']>;
  groupName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  objectId: Scalars['UUID']['output'];
  property: Scalars['String']['output'];
  propertyId?: Maybe<Scalars['UUID']['output']>;
  recordedAt: Scalars['Datetime']['output'];
  transactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `User` that is related to this `ObjectPropertiesHistory`. */
  userByBy?: Maybe<User>;
  value?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `ObjectPropertiesHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ObjectPropertiesHistoryCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `groupName` field. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `property` field. */
  property?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `recordedAt` field. */
  recordedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `transactionId` field. */
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `ObjectPropertiesHistory` object types. All fields are combined with a logical ‘and.’ */
export type ObjectPropertiesHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObjectPropertiesHistoryFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `groupName` field. */
  groupName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObjectPropertiesHistoryFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObjectPropertiesHistoryFilter>>;
  /** Filter by the object’s `property` field. */
  property?: InputMaybe<StringFilter>;
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `recordedAt` field. */
  recordedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `transactionId` field. */
  transactionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `ObjectPropertiesHistory` */
export type ObjectPropertiesHistoryInput = {
  by?: InputMaybe<Scalars['UUID']['input']>;
  groupName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  objectId: Scalars['UUID']['input'];
  property: Scalars['String']['input'];
  propertyId?: InputMaybe<Scalars['UUID']['input']>;
  recordedAt: Scalars['Datetime']['input'];
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `ObjectPropertiesHistory`. Fields that are set will be updated. */
export type ObjectPropertiesHistoryPatch = {
  by?: InputMaybe<Scalars['UUID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['UUID']['input']>;
  recordedAt?: InputMaybe<Scalars['Datetime']['input']>;
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type ObjectPropertiesHistorySort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: ObjectPropertiesHistorySortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type ObjectPropertiesHistorySortBy = {
  field?: InputMaybe<ObjectPropertiesHistorySortableField>;
};

/** Sortable concrete fields for the `ObjectPropertiesHistory` type. */
export enum ObjectPropertiesHistorySortableField {
  By = 'BY',
  GroupName = 'GROUP_NAME',
  Id = 'ID',
  ObjectId = 'OBJECT_ID',
  Property = 'PROPERTY',
  PropertyId = 'PROPERTY_ID',
  RecordedAt = 'RECORDED_AT',
  TransactionId = 'TRANSACTION_ID',
  Value = 'VALUE'
}

/** Methods to use when ordering `ObjectProperty`. */
export enum ObjectPropertiesOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  EditorgroupAsc = 'EDITORGROUP_ASC',
  EditorgroupDesc = 'EDITORGROUP_DESC',
  GroupNameAsc = 'GROUP_NAME_ASC',
  GroupNameDesc = 'GROUP_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  LinkedPropertyIdAsc = 'LINKED_PROPERTY_ID_ASC',
  LinkedPropertyIdDesc = 'LINKED_PROPERTY_ID_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyAsc = 'PROPERTY_ASC',
  PropertyDesc = 'PROPERTY_DESC',
  ReadergroupAsc = 'READERGROUP_ASC',
  ReadergroupDesc = 'READERGROUP_DESC',
  StealthAsc = 'STEALTH_ASC',
  StealthDesc = 'STEALTH_DESC',
  TransactionIdAsc = 'TRANSACTION_ID_ASC',
  TransactionIdDesc = 'TRANSACTION_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsergroupAsc = 'USERGROUP_ASC',
  UsergroupDesc = 'USERGROUP_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type ObjectPropertiesSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: ObjectPropertiesSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type ObjectPropertiesSortBy = {
  field?: InputMaybe<ObjectPropertiesSortableField>;
};

/** Sortable concrete fields for the `ObjectProperty` type. */
export enum ObjectPropertiesSortableField {
  By = 'BY',
  Editorgroup = 'EDITORGROUP',
  GroupName = 'GROUP_NAME',
  Id = 'ID',
  Index = 'INDEX',
  LinkedPropertyId = 'LINKED_PROPERTY_ID',
  ObjectId = 'OBJECT_ID',
  Property = 'PROPERTY',
  Readergroup = 'READERGROUP',
  Stealth = 'STEALTH',
  TransactionId = 'TRANSACTION_ID',
  TypeId = 'TYPE_ID',
  UpdatedAt = 'UPDATED_AT',
  Usergroup = 'USERGROUP',
  Value = 'VALUE'
}

/** Object Properties are used to store individual values of corresponding Object Properties. Object Properties structure is fully controlled by Schemas.  */
export type ObjectProperty = Node & {
  __typename?: 'ObjectProperty';
  by?: Maybe<Scalars['UUID']['output']>;
  editorgroup: Scalars['UUID']['output'];
  /** Group name for Property.  */
  groupName: Scalars['String']['output'];
  /** Property unique ID. */
  id: Scalars['UUID']['output'];
  /** Array index. */
  index: Scalars['BigInt']['output'];
  /** Synthetic field: returns single key as a groupName and Property in camelCase format.  */
  key?: Maybe<Scalars['String']['output']>;
  /** Property ID which is linked to this Property. If set, when this Property gets updated, the Linked Property value would be automatically updated as well.  */
  linkedPropertyId?: Maybe<Scalars['UUID']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Object` that is related to this `ObjectProperty`. */
  object?: Maybe<Object>;
  /** This Property's Object ID.  */
  objectId: Scalars['UUID']['output'];
  previousValue?: Maybe<Scalars['JSON']['output']>;
  /** Property name.  */
  property: Scalars['String']['output'];
  readergroup: Scalars['UUID']['output'];
  spec?: Maybe<SchemaProperty>;
  /** If true, this Property would not be saved in Properties' History storage.  */
  stealth?: Maybe<Scalars['Boolean']['output']>;
  /** Transaction ID indicating a network-level message ID. Might be the same for several properties if a single network message carries multiple values.  */
  transactionId?: Maybe<Scalars['BigInt']['output']>;
  /** Synthetic field: returns a property type. */
  type?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['UUID']['output'];
  /** Value update timestamp. */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `ObjectProperty`. */
  userByBy?: Maybe<User>;
  usergroup: Scalars['UUID']['output'];
  /** Property value. */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ObjectPropertyChangedFilterType = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A condition to be used against `ObjectProperty` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ObjectPropertyCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `editorgroup` field. */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `groupName` field. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `linkedPropertyId` field. */
  linkedPropertyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `property` field. */
  property?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `readergroup` field. */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `stealth` field. */
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `transactionId` field. */
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usergroup` field. */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `ObjectProperty` object types. All fields are combined with a logical ‘and.’ */
export type ObjectPropertyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObjectPropertyFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `editorgroup` field. */
  editorgroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `groupName` field. */
  groupName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `linkedPropertyId` field. */
  linkedPropertyId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObjectPropertyFilter>;
  /** Filter by the object’s `object` relation. */
  object?: InputMaybe<ObjectFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObjectPropertyFilter>>;
  /** Filter by the object’s `property` field. */
  property?: InputMaybe<StringFilter>;
  /** Filter by the object’s `readergroup` field. */
  readergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `stealth` field. */
  stealth?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `transactionId` field. */
  transactionId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usergroup` field. */
  usergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** Represents an update to a `ObjectProperty`. Fields that are set will be updated. */
export type ObjectPropertyPatch = {
  by?: InputMaybe<Scalars['UUID']['input']>;
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Group name for Property.  */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Property unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Property ID which is linked to this Property. If set, when this Property gets updated, the Linked Property value would be automatically updated as well.  */
  linkedPropertyId?: InputMaybe<Scalars['UUID']['input']>;
  /** This Property's Object ID.  */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Property name.  */
  property?: InputMaybe<Scalars['String']['input']>;
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, this Property would not be saved in Properties' History storage.  */
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Property value. */
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against many `ControlExecution` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyControlExecutionFilter = {
  /** Every related `ControlExecution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ControlExecutionFilter>;
  /** No related `ControlExecution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ControlExecutionFilter>;
  /** Some related `ControlExecution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ControlExecutionFilter>;
};

/** A filter to be used against many `NotificationDelivery` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyNotificationDeliveryFilter = {
  /** Every related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationDeliveryFilter>;
  /** No related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationDeliveryFilter>;
  /** Some related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationDeliveryFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `ObjectProperty` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyObjectPropertyFilter = {
  /** Every related `ObjectProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectPropertyFilter>;
  /** No related `ObjectProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectPropertyFilter>;
  /** Some related `ObjectProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectPropertyFilter>;
};

/** A filter to be used against many `ObjectsToObject` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyObjectsToObjectFilter = {
  /** Every related `ObjectsToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectsToObjectFilter>;
  /** No related `ObjectsToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectsToObjectFilter>;
  /** Some related `ObjectsToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectsToObjectFilter>;
};

/** A filter to be used against many `UserProfile` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyUserProfileFilter = {
  /** Every related `UserProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserProfileFilter>;
  /** No related `UserProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserProfileFilter>;
  /** Some related `UserProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserProfileFilter>;
};

/** A filter to be used against many `UsersToObject` object types. All fields are combined with a logical ‘and.’ */
export type ObjectToManyUsersToObjectFilter = {
  /** Every related `UsersToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UsersToObjectFilter>;
  /** No related `UsersToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UsersToObjectFilter>;
  /** Some related `UsersToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UsersToObjectFilter>;
};

/** A connection to a list of `Object` values. */
export type ObjectsConnection = {
  __typename?: 'ObjectsConnection';
  /** A list of edges which contains the `Object` and cursor to aid in pagination. */
  edges: Array<ObjectsEdge>;
  /** A list of `Object` objects. */
  nodes: Array<Maybe<Object>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Object` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ObjectsDynamicAttribute = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['BigInt']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export type ObjectsDynamicAttributeFilter = {
  filter: JsonFilter;
  match: ObjectsDynamicAttribute;
};

/** A `Object` edge in the connection. */
export type ObjectsEdge = {
  __typename?: 'ObjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Object` at the end of the edge. */
  node?: Maybe<Object>;
};

/** Methods to use when ordering `Object`. */
export enum ObjectsOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DeviceBatteryLevelAsc = 'DEVICE_BATTERY_LEVEL_ASC',
  DeviceBatteryLevelDesc = 'DEVICE_BATTERY_LEVEL_DESC',
  DeviceBatteryTypeAsc = 'DEVICE_BATTERY_TYPE_ASC',
  DeviceBatteryTypeDesc = 'DEVICE_BATTERY_TYPE_DESC',
  DeviceEmulationAsc = 'DEVICE_EMULATION_ASC',
  DeviceEmulationDesc = 'DEVICE_EMULATION_DESC',
  DeviceResponseStatusAsc = 'DEVICE_RESPONSE_STATUS_ASC',
  DeviceResponseStatusDesc = 'DEVICE_RESPONSE_STATUS_DESC',
  EditorgroupAsc = 'EDITORGROUP_ASC',
  EditorgroupDesc = 'EDITORGROUP_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  FavouriteAsc = 'FAVOURITE_ASC',
  FavouriteDesc = 'FAVOURITE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MediaFilenameAsc = 'MEDIA_FILENAME_ASC',
  MediaFilenameDesc = 'MEDIA_FILENAME_DESC',
  MediaSizeAsc = 'MEDIA_SIZE_ASC',
  MediaSizeDesc = 'MEDIA_SIZE_DESC',
  MediaTypeAsc = 'MEDIA_TYPE_ASC',
  MediaTypeDesc = 'MEDIA_TYPE_DESC',
  MutedAsc = 'MUTED_ASC',
  MutedDesc = 'MUTED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReadergroupAsc = 'READERGROUP_ASC',
  ReadergroupDesc = 'READERGROUP_DESC',
  SchemaIdAsc = 'SCHEMA_ID_ASC',
  SchemaIdDesc = 'SCHEMA_ID_DESC',
  SchemaNameAsc = 'SCHEMA_NAME_ASC',
  SchemaNameDesc = 'SCHEMA_NAME_DESC',
  SchemaTypeAsc = 'SCHEMA_TYPE_ASC',
  SchemaTypeDesc = 'SCHEMA_TYPE_DESC',
  StringIdAsc = 'STRING_ID_ASC',
  StringIdDesc = 'STRING_ID_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsergroupAsc = 'USERGROUP_ASC',
  UsergroupDesc = 'USERGROUP_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type ObjectsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: ObjectsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type ObjectsSortBy = {
  dynamicAttribute?: InputMaybe<ObjectsDynamicAttribute>;
  field?: InputMaybe<ObjectsSortableField>;
};

/** Sortable concrete fields for the `Object` type. */
export enum ObjectsSortableField {
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  Description = 'DESCRIPTION',
  Editorgroup = 'EDITORGROUP',
  Enabled = 'ENABLED',
  Id = 'ID',
  Name = 'NAME',
  Readergroup = 'READERGROUP',
  SchemaId = 'SCHEMA_ID',
  Tags = 'TAGS',
  UpdatedAt = 'UPDATED_AT',
  Usergroup = 'USERGROUP'
}

/** ObjectsToObject stores Objects to Objects connection information. */
export type ObjectsToObject = Node & {
  __typename?: 'ObjectsToObject';
  forced?: Maybe<Scalars['Int']['output']>;
  /** Relation unique ID. */
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Object` that is related to this `ObjectsToObject`. */
  object1?: Maybe<Object>;
  /** Object ID connected to.  */
  object1Id: Scalars['UUID']['output'];
  /** Reads a single `Object` that is related to this `ObjectsToObject`. */
  object2?: Maybe<Object>;
  /** Object ID connecting to.  */
  object2Id: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `ObjectsToObject` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ObjectsToObjectCondition = {
  /** Checks for equality with the object’s `forced` field. */
  forced?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `object1Id` field. */
  object1Id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `object2Id` field. */
  object2Id?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `ObjectsToObject` object types. All fields are combined with a logical ‘and.’ */
export type ObjectsToObjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObjectsToObjectFilter>>;
  /** Filter by the object’s `forced` field. */
  forced?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObjectsToObjectFilter>;
  /** Filter by the object’s `object1` relation. */
  object1?: InputMaybe<ObjectFilter>;
  /** Filter by the object’s `object1Id` field. */
  object1Id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `object2` relation. */
  object2?: InputMaybe<ObjectFilter>;
  /** Filter by the object’s `object2Id` field. */
  object2Id?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObjectsToObjectFilter>>;
};

/** An input for mutations affecting `ObjectsToObject` */
export type ObjectsToObjectInput = {
  /** Object ID connected to.  */
  object1Id: Scalars['UUID']['input'];
  /** Object ID connecting to.  */
  object2Id: Scalars['UUID']['input'];
};

/** A connection to a list of `ObjectsToObject` values. */
export type ObjectsToObjectsConnection = {
  __typename?: 'ObjectsToObjectsConnection';
  /** A list of edges which contains the `ObjectsToObject` and cursor to aid in pagination. */
  edges: Array<ObjectsToObjectsEdge>;
  /** A list of `ObjectsToObject` objects. */
  nodes: Array<Maybe<ObjectsToObject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObjectsToObject` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ObjectsToObject` edge in the connection. */
export type ObjectsToObjectsEdge = {
  __typename?: 'ObjectsToObjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ObjectsToObject` at the end of the edge. */
  node?: Maybe<ObjectsToObject>;
};

/** Methods to use when ordering `ObjectsToObject`. */
export enum ObjectsToObjectsOrderBy {
  ForcedAsc = 'FORCED_ASC',
  ForcedDesc = 'FORCED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  Object1IdAsc = 'OBJECT1_ID_ASC',
  Object1IdDesc = 'OBJECT1_ID_DESC',
  Object2IdAsc = 'OBJECT2_ID_ASC',
  Object2IdDesc = 'OBJECT2_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type ObjectsToObjectsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: ObjectsToObjectsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type ObjectsToObjectsSortBy = {
  field?: InputMaybe<ObjectsToObjectsSortableField>;
};

/** Sortable concrete fields for the `ObjectsToObject` type. */
export enum ObjectsToObjectsSortableField {
  Forced = 'FORCED',
  Id = 'ID',
  Object1Id = 'OBJECT1_ID',
  Object2Id = 'OBJECT2_ID'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Property2Input = {
  groupName: Scalars['String']['input'];
  property: Scalars['String']['input'];
};

/** An input for mutations affecting `PropertyById` */
export type PropertyByIdInput = {
  propertyId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** An input for mutations affecting `PropertyByKey` */
export type PropertyByKeyInput = {
  propertyKey?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PropertyByName2Input = {
  groupName: Scalars['String']['input'];
  property: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

/** An input for mutations affecting `PropertyByName` */
export type PropertyByNameInput = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** An input for mutations affecting `PropertyLink` */
export type PropertyLinkInput = {
  destGroupName?: InputMaybe<Scalars['String']['input']>;
  destProperty?: InputMaybe<Scalars['String']['input']>;
  destSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  sourceGroupName?: InputMaybe<Scalars['String']['input']>;
  sourceObjectId?: InputMaybe<Scalars['UUID']['input']>;
  sourceProperty?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyType = Node & {
  __typename?: 'PropertyType';
  /** Type description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Type id. */
  id: Scalars['UUID']['output'];
  /** Type name (must be unique) */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** JSON Schema to be used to validate input for that type. If NULL - no validation happens. */
  schema?: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaPropertiesByTypeId: Array<SchemaProperty>;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaPropertiesByTypeIdConnection: SchemaPropertiesConnection;
};


export type PropertyTypeSchemaPropertiesByTypeIdArgs = {
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


export type PropertyTypeSchemaPropertiesByTypeIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};

/**
 * A condition to be used against `PropertyType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PropertyTypeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `schema` field. */
  schema?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `PropertyType` object types. All fields are combined with a logical ‘and.’ */
export type PropertyTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PropertyTypeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PropertyTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PropertyTypeFilter>>;
  /** Filter by the object’s `schema` field. */
  schema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `schemaPropertiesByTypeIdConnection` relation. */
  schemaPropertiesByTypeIdConnection?: InputMaybe<PropertyTypeToManySchemaPropertyFilter>;
  /** Some related `schemaPropertiesByTypeIdConnection` exist. */
  schemaPropertiesByTypeIdConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `PropertyType` */
export type PropertyTypeInput = {
  /** Type description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type id. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Type name (must be unique) */
  name: Scalars['String']['input'];
  /** JSON Schema to be used to validate input for that type. If NULL - no validation happens. */
  schema?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `PropertyType`. Fields that are set will be updated. */
export type PropertyTypePatch = {
  /** Type description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type id. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Type name (must be unique) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** JSON Schema to be used to validate input for that type. If NULL - no validation happens. */
  schema?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against many `SchemaProperty` object types. All fields are combined with a logical ‘and.’ */
export type PropertyTypeToManySchemaPropertyFilter = {
  /** Every related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaPropertyFilter>;
  /** No related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaPropertyFilter>;
  /** Some related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaPropertyFilter>;
};

/** A connection to a list of `PropertyType` values. */
export type PropertyTypesConnection = {
  __typename?: 'PropertyTypesConnection';
  /** A list of edges which contains the `PropertyType` and cursor to aid in pagination. */
  edges: Array<PropertyTypesEdge>;
  /** A list of `PropertyType` objects. */
  nodes: Array<Maybe<PropertyType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PropertyType` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PropertyType` edge in the connection. */
export type PropertyTypesEdge = {
  __typename?: 'PropertyTypesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PropertyType` at the end of the edge. */
  node?: Maybe<PropertyType>;
};

/** Methods to use when ordering `PropertyType`. */
export enum PropertyTypesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SchemaAsc = 'SCHEMA_ASC',
  SchemaDesc = 'SCHEMA_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type PropertyTypesSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: PropertyTypesSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type PropertyTypesSortBy = {
  field?: InputMaybe<PropertyTypesSortableField>;
};

/** Sortable concrete fields for the `PropertyType` type. */
export enum PropertyTypesSortableField {
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  Schema = 'SCHEMA'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  controlExecution?: Maybe<ControlExecution>;
  /** Reads a single `ControlExecution` using its globally unique `ID`. */
  controlExecutionByNodeId?: Maybe<ControlExecution>;
  /** Reads a set of `ControlExecution`. */
  controlExecutions?: Maybe<Array<ControlExecution>>;
  /** Reads and enables pagination through a set of `ControlExecution`. */
  controlExecutionsConnection?: Maybe<ControlExecutionsConnection>;
  /** Export schema from the platform in JSON format.  */
  exportSchema?: Maybe<Scalars['String']['output']>;
  /** Returns DB space usage and information.  */
  getDbInfo?: Maybe<DbInfo>;
  /** Returns distinct values of chosen property for given schema objects */
  getDistinctPropertyValuesByKey?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Returns refresh token id for the current session, can be used to form subscription topic name.  */
  getRefreshTokenId?: Maybe<Scalars['String']['output']>;
  /** Get core DB time */
  getTime?: Maybe<Scalars['String']['output']>;
  /** Returns Platform native Timezone used.  */
  getTimezone?: Maybe<Scalars['String']['output']>;
  /** Get core DB timezone shift from UTC in minutes. */
  getTimezoneShift?: Maybe<Scalars['Int']['output']>;
  /** Returns the current user's group list.  */
  getUserGroups?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /** Returns current user id (uuid).  */
  getUserId?: Maybe<Scalars['String']['output']>;
  /** Returns UUID of the object which represents the profile for the current user and current application.  */
  getUserProfileId?: Maybe<Scalars['String']['output']>;
  /** Returns version information of the platform.  */
  getVersion?: Maybe<Version>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  notification?: Maybe<Notification>;
  /** Reads a single `Notification` using its globally unique `ID`. */
  notificationByNodeId?: Maybe<Notification>;
  /** Reads a set of `NotificationDelivery`. */
  notificationDeliveries?: Maybe<Array<NotificationDelivery>>;
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveriesConnection?: Maybe<NotificationDeliveriesConnection>;
  notificationDelivery?: Maybe<NotificationDelivery>;
  /** Reads a single `NotificationDelivery` using its globally unique `ID`. */
  notificationDeliveryByNodeId?: Maybe<NotificationDelivery>;
  /** Reads a set of `Notification`. */
  notifications?: Maybe<Array<Notification>>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection?: Maybe<NotificationsConnection>;
  object?: Maybe<Object>;
  /** Reads a single `Object` using its globally unique `ID`. */
  objectByNodeId?: Maybe<Object>;
  /** Reads a set of `ObjectProperty`. */
  objectProperties?: Maybe<Array<ObjectProperty>>;
  /** Reads and enables pagination through a set of `ObjectProperty`. */
  objectPropertiesConnection?: Maybe<ObjectPropertiesConnection>;
  /** Reads a set of `ObjectPropertiesHistory`. */
  objectPropertiesHistories?: Maybe<Array<ObjectPropertiesHistory>>;
  /** Reads and enables pagination through a set of `ObjectPropertiesHistory`. */
  objectPropertiesHistoriesConnection?: Maybe<ObjectPropertiesHistoriesConnection>;
  objectPropertiesHistory?: Maybe<ObjectPropertiesHistory>;
  /** Reads a single `ObjectPropertiesHistory` using its globally unique `ID`. */
  objectPropertiesHistoryByNodeId?: Maybe<ObjectPropertiesHistory>;
  objectProperty?: Maybe<ObjectProperty>;
  /** Reads a single `ObjectProperty` using its globally unique `ID`. */
  objectPropertyByNodeId?: Maybe<ObjectProperty>;
  /** Reads a set of `Object`. */
  objects?: Maybe<Array<Object>>;
  /** Reads and enables pagination through a set of `Object`. */
  objectsConnection?: Maybe<ObjectsConnection>;
  objectsToObject?: Maybe<ObjectsToObject>;
  /** Reads a single `ObjectsToObject` using its globally unique `ID`. */
  objectsToObjectByNodeId?: Maybe<ObjectsToObject>;
  objectsToObjectByObject1IdAndObject2Id?: Maybe<ObjectsToObject>;
  /** Reads a set of `ObjectsToObject`. */
  objectsToObjects?: Maybe<Array<ObjectsToObject>>;
  /** Reads and enables pagination through a set of `ObjectsToObject`. */
  objectsToObjectsConnection?: Maybe<ObjectsToObjectsConnection>;
  propertyType?: Maybe<PropertyType>;
  propertyTypeByName?: Maybe<PropertyType>;
  /** Reads a single `PropertyType` using its globally unique `ID`. */
  propertyTypeByNodeId?: Maybe<PropertyType>;
  /** Reads a set of `PropertyType`. */
  propertyTypes?: Maybe<Array<PropertyType>>;
  /** Reads and enables pagination through a set of `PropertyType`. */
  propertyTypesConnection?: Maybe<PropertyTypesConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  schema?: Maybe<Schema>;
  /** Reads a single `Schema` using its globally unique `ID`. */
  schemaByNodeId?: Maybe<Schema>;
  schemaControl?: Maybe<SchemaControl>;
  /** Reads a single `SchemaControl` using its globally unique `ID`. */
  schemaControlByNodeId?: Maybe<SchemaControl>;
  /** Reads a set of `SchemaControl`. */
  schemaControls?: Maybe<Array<SchemaControl>>;
  /** Reads and enables pagination through a set of `SchemaControl`. */
  schemaControlsConnection?: Maybe<SchemaControlsConnection>;
  /** Reads a set of `SchemaProperty`. */
  schemaProperties?: Maybe<Array<SchemaProperty>>;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaPropertiesConnection?: Maybe<SchemaPropertiesConnection>;
  schemaProperty?: Maybe<SchemaProperty>;
  /** Reads a single `SchemaProperty` using its globally unique `ID`. */
  schemaPropertyByNodeId?: Maybe<SchemaProperty>;
  /** Reads a set of `Schema`. */
  schemata?: Maybe<Array<Schema>>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataConnection?: Maybe<SchemataConnection>;
  translation?: Maybe<Translation>;
  /** Reads a single `Translation` using its globally unique `ID`. */
  translationByNodeId?: Maybe<Translation>;
  /** Reads a set of `Translation`. */
  translations?: Maybe<Array<Translation>>;
  /** Reads and enables pagination through a set of `Translation`. */
  translationsConnection?: Maybe<TranslationsConnection>;
  user?: Maybe<User>;
  userByLogin?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  userGroup?: Maybe<UserGroup>;
  userGroupByGroupName?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` using its globally unique `ID`. */
  userGroupByNodeId?: Maybe<UserGroup>;
  /** Reads a set of `UserGroup`. */
  userGroups?: Maybe<Array<UserGroup>>;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroupsConnection?: Maybe<UserGroupsConnection>;
  userProfile?: Maybe<UserProfile>;
  /** Reads a single `UserProfile` using its globally unique `ID`. */
  userProfileByNodeId?: Maybe<UserProfile>;
  userProfileByUserIdAndObjectId?: Maybe<UserProfile>;
  /** Reads a set of `UserProfile`. */
  userProfiles?: Maybe<Array<UserProfile>>;
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfilesConnection?: Maybe<UserProfilesConnection>;
  /** Reads a set of `User`. */
  users?: Maybe<Array<User>>;
  /** Reads and enables pagination through a set of `User`. */
  usersConnection?: Maybe<UsersConnection>;
  usersToGroup?: Maybe<UsersToGroup>;
  /** Reads a single `UsersToGroup` using its globally unique `ID`. */
  usersToGroupByNodeId?: Maybe<UsersToGroup>;
  usersToGroupByUserIdAndUserGroupId?: Maybe<UsersToGroup>;
  /** Reads a set of `UsersToGroup`. */
  usersToGroups?: Maybe<Array<UsersToGroup>>;
  /** Reads and enables pagination through a set of `UsersToGroup`. */
  usersToGroupsConnection?: Maybe<UsersToGroupsConnection>;
  usersToObject?: Maybe<UsersToObject>;
  /** Reads a single `UsersToObject` using its globally unique `ID`. */
  usersToObjectByNodeId?: Maybe<UsersToObject>;
  usersToObjectByUserIdAndObjectId?: Maybe<UsersToObject>;
  /** Reads a set of `UsersToObject`. */
  usersToObjects?: Maybe<Array<UsersToObject>>;
  /** Reads and enables pagination through a set of `UsersToObject`. */
  usersToObjectsConnection?: Maybe<UsersToObjectsConnection>;
  /** Check whether user can change his password or no by user_id and new password given. Result is in JSON format. */
  validatePasswordChange?: Maybe<Scalars['String']['output']>;
  /** Reads a set of `ViewSearch`. */
  viewSearches?: Maybe<Array<ViewSearch>>;
  /** Reads and enables pagination through a set of `ViewSearch`. */
  viewSearchesConnection?: Maybe<ViewSearchesConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryControlExecutionArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryControlExecutionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryControlExecutionsArgs = {
  condition?: InputMaybe<ControlExecutionCondition>;
  filter?: InputMaybe<ControlExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
  sort?: InputMaybe<Array<ControlExecutionsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryControlExecutionsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlExecutionCondition>;
  filter?: InputMaybe<ControlExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
  sort?: InputMaybe<Array<ControlExecutionsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryExportSchemaArgs = {
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetDistinctPropertyValuesByKeyArgs = {
  keyedProperty?: InputMaybe<Scalars['String']['input']>;
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUserGroupsArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationDeliveriesArgs = {
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationDeliveriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationDeliveryArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationDeliveryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationsArgs = {
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
  sort?: InputMaybe<Array<NotificationsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
  sort?: InputMaybe<Array<NotificationsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertiesArgs = {
  condition?: InputMaybe<ObjectPropertyCondition>;
  filter?: InputMaybe<ObjectPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectPropertyCondition>;
  filter?: InputMaybe<ObjectPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertiesHistoriesArgs = {
  condition?: InputMaybe<ObjectPropertiesHistoryCondition>;
  filter?: InputMaybe<ObjectPropertiesHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesHistorySort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertiesHistoriesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectPropertiesHistoryCondition>;
  filter?: InputMaybe<ObjectPropertiesHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesHistorySort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertiesHistoryArgs = {
  id: Scalars['Int']['input'];
  recordedAt: Scalars['Datetime']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertiesHistoryByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertyArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectPropertyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsArgs = {
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsToObjectArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsToObjectByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsToObjectByObject1IdAndObject2IdArgs = {
  object1Id: Scalars['UUID']['input'];
  object2Id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsToObjectsArgs = {
  condition?: InputMaybe<ObjectsToObjectCondition>;
  filter?: InputMaybe<ObjectsToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsToObjectsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectsToObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectsToObjectCondition>;
  filter?: InputMaybe<ObjectsToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsToObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsToObjectsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPropertyTypeArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPropertyTypeByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPropertyTypeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPropertyTypesArgs = {
  condition?: InputMaybe<PropertyTypeCondition>;
  filter?: InputMaybe<PropertyTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
  sort?: InputMaybe<Array<PropertyTypesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPropertyTypesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PropertyTypeCondition>;
  filter?: InputMaybe<PropertyTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
  sort?: InputMaybe<Array<PropertyTypesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaControlArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaControlByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaControlsArgs = {
  condition?: InputMaybe<SchemaControlCondition>;
  filter?: InputMaybe<SchemaControlFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
  sort?: InputMaybe<Array<SchemaControlsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaControlsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaControlCondition>;
  filter?: InputMaybe<SchemaControlFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
  sort?: InputMaybe<Array<SchemaControlsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaPropertiesArgs = {
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaPropertyArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemaPropertyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemataArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySchemataConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslationArgs = {
  uuid: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslationsArgs = {
  condition?: InputMaybe<TranslationCondition>;
  filter?: InputMaybe<TranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
  sort?: InputMaybe<Array<TranslationsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTranslationsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TranslationCondition>;
  filter?: InputMaybe<TranslationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TranslationsOrderBy>>;
  sort?: InputMaybe<Array<TranslationsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByLoginArgs = {
  login: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupByGroupNameArgs = {
  groupName: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupsArgs = {
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  sort?: InputMaybe<Array<UserGroupsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  sort?: InputMaybe<Array<UserGroupsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfileArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfileByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfileByUserIdAndObjectIdArgs = {
  objectId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfilesArgs = {
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  sort?: InputMaybe<Array<UserProfilesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  sort?: InputMaybe<Array<UserProfilesSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToGroupArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToGroupByUserIdAndUserGroupIdArgs = {
  userGroupId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToGroupsArgs = {
  condition?: InputMaybe<UsersToGroupCondition>;
  filter?: InputMaybe<UsersToGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
  sort?: InputMaybe<Array<UsersToGroupsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UsersToGroupCondition>;
  filter?: InputMaybe<UsersToGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
  sort?: InputMaybe<Array<UsersToGroupsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToObjectArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToObjectByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToObjectByUserIdAndObjectIdArgs = {
  objectId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToObjectsArgs = {
  condition?: InputMaybe<UsersToObjectCondition>;
  filter?: InputMaybe<UsersToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
  sort?: InputMaybe<Array<UsersToObjectsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersToObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UsersToObjectCondition>;
  filter?: InputMaybe<UsersToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
  sort?: InputMaybe<Array<UsersToObjectsSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatePasswordChangeArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryViewSearchesArgs = {
  condition?: InputMaybe<ViewSearchCondition>;
  filter?: InputMaybe<ViewSearchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ViewSearchesOrderBy>>;
  sort?: InputMaybe<Array<ViewSearchSort>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryViewSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ViewSearchCondition>;
  filter?: InputMaybe<ViewSearchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ViewSearchesOrderBy>>;
  sort?: InputMaybe<Array<ViewSearchSort>>;
};

export type RefreshToken = {
  __typename?: 'RefreshToken';
  id?: Maybe<Scalars['BigInt']['output']>;
  license?: Maybe<License>;
  token?: Maybe<Scalars['String']['output']>;
  twoFa?: Maybe<TwoFa>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

/** All input for the `resetProperty` mutation. */
export type ResetPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['UUID']['input']>;
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `resetProperty` mutation. */
export type ResetPropertyPayload = {
  __typename?: 'ResetPropertyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `resolveObjectPermissions` mutation. */
export type ResolveObjectPermissionsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `resolveObjectPermissions` mutation. */
export type ResolveObjectPermissionsPayload = {
  __typename?: 'ResolveObjectPermissionsPayload';
  accessRight?: Maybe<AccessRight>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type RpcResult = {
  __typename?: 'RpcResult';
  ack?: Maybe<Scalars['Boolean']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['JSON']['output']>;
};

/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type Schema = Node & {
  __typename?: 'Schema';
  /** User ID of the Application responsible for RPC/Controls of this Schema (Schema Application Owner). */
  applicationOwner?: Maybe<Scalars['UUID']['output']>;
  /** User last updated the Schema. */
  by?: Maybe<Scalars['UUID']['output']>;
  /** Schema creation timestamp. */
  createdAt: Scalars['Datetime']['output'];
  /** @deprecated true */
  defaultTtl?: Maybe<Interval>;
  /** Schema description. */
  description?: Maybe<Scalars['String']['output']>;
  /** User Group with EditorGroup access permission.  */
  editorgroup: Scalars['UUID']['output'];
  /** Administrative Schema's status. */
  enabled: Scalars['Boolean']['output'];
  /** Synthetic field: returns user group name based on the provided group type ("editorgroup/usergroup/readergroup") for this schema. */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Schema unique ID. */
  id: Scalars['UUID']['output'];
  /** Schema author name meta information.  */
  mAuthor?: Maybe<Scalars['String']['output']>;
  /** Schema author's email meta information.  */
  mEmail?: Maybe<Scalars['String']['output']>;
  /** User ID in the external system meta information. */
  mExternalId?: Maybe<Scalars['UUID']['output']>;
  /** Schema icon in base64. */
  mIcon?: Maybe<Scalars['String']['output']>;
  /** Schema long name meta information.  */
  mLongname?: Maybe<Scalars['String']['output']>;
  /** Schema manufacturer name meta information.  */
  mManufacturer?: Maybe<Scalars['String']['output']>;
  /** Schema picture in base64. */
  mPicture?: Maybe<Scalars['String']['output']>;
  /** Tags for Schema clusterization */
  mTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Schema version meta information.  */
  mVersion?: Maybe<Scalars['String']['output']>;
  /** Schema name. */
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Object`. */
  objects: Array<Object>;
  /** Reads and enables pagination through a set of `Object`. */
  objectsConnection: ObjectsConnection;
  /**
   * Synthetic field: returns a total number of objects created from this schema.
   *
   */
  objectsCount?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  parentSchemaId?: Maybe<Scalars['UUID']['output']>;
  /** Synthetic field: returns name of parent schema if any. */
  parentSchemaName?: Maybe<Scalars['String']['output']>;
  /** Synthetic field: returns default property value based on the provided property name in the format "group_name/property_name". */
  property?: Maybe<Scalars['JSON']['output']>;
  /** User Group with ReaderGroup access permission.  */
  readergroup: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `SchemaControl`. */
  schemaControls: Array<SchemaControl>;
  /** Reads and enables pagination through a set of `SchemaControl`. */
  schemaControlsConnection: SchemaControlsConnection;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaProperties: Array<SchemaProperty>;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaPropertiesConnection: SchemaPropertiesConnection;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByParentSchemaId: Array<Schema>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByParentSchemaIdConnection: SchemataConnection;
  /** Schema type (DEVICE/MEDIA/DATASET/other). */
  type: SchemaTypes;
  /** Schema last update timestamp. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
  /** User Group with UserGroup access permission.  */
  usergroup: Scalars['UUID']['output'];
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaGroupNameArgs = {
  groupName?: InputMaybe<Scalars['String']['input']>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaObjectsArgs = {
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaPropertyArgs = {
  propertyName?: InputMaybe<Scalars['String']['input']>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaSchemaControlsArgs = {
  condition?: InputMaybe<SchemaControlCondition>;
  filter?: InputMaybe<SchemaControlFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
  sort?: InputMaybe<Array<SchemaControlsSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaSchemaControlsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaControlCondition>;
  filter?: InputMaybe<SchemaControlFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
  sort?: InputMaybe<Array<SchemaControlsSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaSchemaPropertiesArgs = {
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaSchemaPropertiesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaSchemataByParentSchemaIdArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** Schema is a second important data type within the platform. It describes which Properties and RPC/Controls would be supported by Objects instantiated from it.  */
export type SchemaSchemataByParentSchemaIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};

/** A condition to be used against `Schema` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SchemaCondition = {
  /** Checks for equality with the object’s `applicationOwner` field. */
  applicationOwner?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultTtl` field. */
  defaultTtl?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `editorgroup` field. */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `enabled` field. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mAuthor` field. */
  mAuthor?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mEmail` field. */
  mEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mExternalId` field. */
  mExternalId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mIcon` field. */
  mIcon?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mLongname` field. */
  mLongname?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mManufacturer` field. */
  mManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mPicture` field. */
  mPicture?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mTags` field. */
  mTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `mVersion` field. */
  mVersion?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `objectsCount` field. */
  objectsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parentSchemaId` field. */
  parentSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `parentSchemaName` field. */
  parentSchemaName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `readergroup` field. */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SchemaTypes>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `usergroup` field. */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

/** Schema Control represents RPC/Controls methods which can be called within Objects instantiated from this Schema.  */
export type SchemaControl = Node & {
  __typename?: 'SchemaControl';
  /** RPC/Control function Argument name. */
  argument: Scalars['String']['output'];
  argumentDefault?: Maybe<Scalars['String']['output']>;
  /** User last updated the Control. */
  by?: Maybe<Scalars['UUID']['output']>;
  /** Control creation timestamp. */
  createdAt: Scalars['Datetime']['output'];
  /** Control argument default value. */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** RPC/Control function description. */
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated true */
  hidden: Scalars['Boolean']['output'];
  /** Schema Controls unique ID. */
  id: Scalars['UUID']['output'];
  isRpc?: Maybe<Scalars['Boolean']['output']>;
  /** Control argument input mask. */
  mask?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Control argument regex for validation.  */
  regex?: Maybe<Scalars['String']['output']>;
  /** RPC/Control function name.  */
  rpc: Scalars['String']['output'];
  /** Reads a single `Schema` that is related to this `SchemaControl`. */
  schema?: Maybe<Schema>;
  /** RPC/Control's Schema ID it belongs to. */
  schemaId: Scalars['UUID']['output'];
  /** RPC/Control function Argument type. */
  typeSpec: Scalars['String']['output'];
  /** Control argument units indication.  */
  units?: Maybe<Scalars['String']['output']>;
  /** Control last update timestamp. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `SchemaControl`. */
  userByBy?: Maybe<User>;
  /** Control argument supported value range. */
  valueRange?: Maybe<Scalars['JSON']['output']>;
  /** Control argument set of possible values.  */
  valueSet?: Maybe<Scalars['JSON']['output']>;
};


/** Schema Control represents RPC/Controls methods which can be called within Objects instantiated from this Schema.  */
export type SchemaControlArgumentDefaultArgs = {
  objectId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * A condition to be used against `SchemaControl` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SchemaControlCondition = {
  /** Checks for equality with the object’s `argument` field. */
  argument?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mask` field. */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `regex` field. */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rpc` field. */
  rpc?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `schemaId` field. */
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `typeSpec` field. */
  typeSpec?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `valueRange` field. */
  valueRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `valueSet` field. */
  valueSet?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `SchemaControl` object types. All fields are combined with a logical ‘and.’ */
export type SchemaControlFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SchemaControlFilter>>;
  /** Filter by the object’s `argument` field. */
  argument?: InputMaybe<StringFilter>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isRpc` field. */
  isRpc?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mask` field. */
  mask?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SchemaControlFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SchemaControlFilter>>;
  /** Filter by the object’s `regex` field. */
  regex?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rpc` field. */
  rpc?: InputMaybe<StringFilter>;
  /** Filter by the object’s `schema` relation. */
  schema?: InputMaybe<SchemaFilter>;
  /** Filter by the object’s `schemaId` field. */
  schemaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `typeSpec` field. */
  typeSpec?: InputMaybe<StringFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `valueRange` field. */
  valueRange?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `valueSet` field. */
  valueSet?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `SchemaControl` */
export type SchemaControlInput = {
  /** RPC/Control function Argument name. */
  argument: Scalars['String']['input'];
  /** Control argument default value. */
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  /** RPC/Control function description. */
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schema Controls unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Control argument input mask. */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Control argument regex for validation.  */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** RPC/Control function name.  */
  rpc: Scalars['String']['input'];
  /** RPC/Control's Schema ID it belongs to. */
  schemaId: Scalars['UUID']['input'];
  /** RPC/Control function Argument type. */
  typeSpec: Scalars['String']['input'];
  /** Control argument units indication.  */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Control argument supported value range. */
  valueRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Control argument set of possible values.  */
  valueSet?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `SchemaControl`. Fields that are set will be updated. */
export type SchemaControlPatch = {
  /** RPC/Control function Argument name. */
  argument?: InputMaybe<Scalars['String']['input']>;
  /** Control argument default value. */
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  /** RPC/Control function description. */
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schema Controls unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Control argument input mask. */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Control argument regex for validation.  */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** RPC/Control function name.  */
  rpc?: InputMaybe<Scalars['String']['input']>;
  /** RPC/Control's Schema ID it belongs to. */
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** RPC/Control function Argument type. */
  typeSpec?: InputMaybe<Scalars['String']['input']>;
  /** Control argument units indication.  */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Control argument supported value range. */
  valueRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Control argument set of possible values.  */
  valueSet?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `SchemaControl` values. */
export type SchemaControlsConnection = {
  __typename?: 'SchemaControlsConnection';
  /** A list of edges which contains the `SchemaControl` and cursor to aid in pagination. */
  edges: Array<SchemaControlsEdge>;
  /** A list of `SchemaControl` objects. */
  nodes: Array<Maybe<SchemaControl>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SchemaControl` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SchemaControl` edge in the connection. */
export type SchemaControlsEdge = {
  __typename?: 'SchemaControlsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SchemaControl` at the end of the edge. */
  node?: Maybe<SchemaControl>;
};

/** Methods to use when ordering `SchemaControl`. */
export enum SchemaControlsOrderBy {
  ArgumentAsc = 'ARGUMENT_ASC',
  ArgumentDesc = 'ARGUMENT_DESC',
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DefaultValueAsc = 'DEFAULT_VALUE_ASC',
  DefaultValueDesc = 'DEFAULT_VALUE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MaskAsc = 'MASK_ASC',
  MaskDesc = 'MASK_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegexAsc = 'REGEX_ASC',
  RegexDesc = 'REGEX_DESC',
  RpcAsc = 'RPC_ASC',
  RpcDesc = 'RPC_DESC',
  SchemaIdAsc = 'SCHEMA_ID_ASC',
  SchemaIdDesc = 'SCHEMA_ID_DESC',
  TypeSpecAsc = 'TYPE_SPEC_ASC',
  TypeSpecDesc = 'TYPE_SPEC_DESC',
  UnitsAsc = 'UNITS_ASC',
  UnitsDesc = 'UNITS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueRangeAsc = 'VALUE_RANGE_ASC',
  ValueRangeDesc = 'VALUE_RANGE_DESC',
  ValueSetAsc = 'VALUE_SET_ASC',
  ValueSetDesc = 'VALUE_SET_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type SchemaControlsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: SchemaControlsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type SchemaControlsSortBy = {
  field?: InputMaybe<SchemaControlsSortableField>;
};

/** Sortable concrete fields for the `SchemaControl` type. */
export enum SchemaControlsSortableField {
  Argument = 'ARGUMENT',
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  DefaultValue = 'DEFAULT_VALUE',
  Description = 'DESCRIPTION',
  Hidden = 'HIDDEN',
  Id = 'ID',
  Mask = 'MASK',
  Regex = 'REGEX',
  Rpc = 'RPC',
  SchemaId = 'SCHEMA_ID',
  TypeSpec = 'TYPE_SPEC',
  Units = 'UNITS',
  UpdatedAt = 'UPDATED_AT',
  ValueRange = 'VALUE_RANGE',
  ValueSet = 'VALUE_SET'
}

/** A filter to be used against `Schema` object types. All fields are combined with a logical ‘and.’ */
export type SchemaFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SchemaFilter>>;
  /** Filter by the object’s `applicationOwner` field. */
  applicationOwner?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultTtl` field. */
  defaultTtl?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `editorgroup` field. */
  editorgroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `enabled` field. */
  enabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mAuthor` field. */
  mAuthor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mEmail` field. */
  mEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mExternalId` field. */
  mExternalId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mIcon` field. */
  mIcon?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mLongname` field. */
  mLongname?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mManufacturer` field. */
  mManufacturer?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mPicture` field. */
  mPicture?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mTags` field. */
  mTags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `mVersion` field. */
  mVersion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SchemaFilter>;
  /** Filter by the object’s `objectsConnection` relation. */
  objectsConnection?: InputMaybe<SchemaToManyObjectFilter>;
  /** Some related `objectsConnection` exist. */
  objectsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectsCount` field. */
  objectsCount?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SchemaFilter>>;
  /** Filter by the object’s `parentSchema` relation. */
  parentSchema?: InputMaybe<SchemaFilter>;
  /** A related `parentSchema` exists. */
  parentSchemaExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `parentSchemaId` field. */
  parentSchemaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `parentSchemaName` field. */
  parentSchemaName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `readergroup` field. */
  readergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `schemaControlsConnection` relation. */
  schemaControlsConnection?: InputMaybe<SchemaToManySchemaControlFilter>;
  /** Some related `schemaControlsConnection` exist. */
  schemaControlsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemaPropertiesConnection` relation. */
  schemaPropertiesConnection?: InputMaybe<SchemaToManySchemaPropertyFilter>;
  /** Some related `schemaPropertiesConnection` exist. */
  schemaPropertiesConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemataByParentSchemaIdConnection` relation. */
  schemataByParentSchemaIdConnection?: InputMaybe<SchemaToManySchemaFilter>;
  /** Some related `schemataByParentSchemaIdConnection` exist. */
  schemataByParentSchemaIdConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<SchemaTypesFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByApplicationOwner` relation. */
  userByApplicationOwner?: InputMaybe<UserFilter>;
  /** A related `userByApplicationOwner` exists. */
  userByApplicationOwnerExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userGroupByEditorgroup` relation. */
  userGroupByEditorgroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupByReadergroup` relation. */
  userGroupByReadergroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupByUsergroup` relation. */
  userGroupByUsergroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `usergroup` field. */
  usergroup?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Schema` */
export type SchemaInput = {
  /** User ID of the Application responsible for RPC/Controls of this Schema (Schema Application Owner). */
  applicationOwner?: InputMaybe<Scalars['UUID']['input']>;
  defaultTtl?: InputMaybe<IntervalInput>;
  /** Schema description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** User Group with EditorGroup access permission.  */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Administrative Schema's status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schema unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema author name meta information.  */
  mAuthor?: InputMaybe<Scalars['String']['input']>;
  /** Schema author's email meta information.  */
  mEmail?: InputMaybe<Scalars['String']['input']>;
  /** User ID in the external system meta information. */
  mExternalId?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema icon in base64. */
  mIcon?: InputMaybe<Scalars['String']['input']>;
  /** Schema long name meta information.  */
  mLongname?: InputMaybe<Scalars['String']['input']>;
  /** Schema manufacturer name meta information.  */
  mManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Schema picture in base64. */
  mPicture?: InputMaybe<Scalars['String']['input']>;
  /** Tags for Schema clusterization */
  mTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Schema version meta information.  */
  mVersion?: InputMaybe<Scalars['String']['input']>;
  /** Schema name. */
  name: Scalars['String']['input'];
  parentSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** User Group with ReaderGroup access permission.  */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema type (DEVICE/MEDIA/DATASET/other). */
  type: SchemaTypes;
  /** User Group with UserGroup access permission.  */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

/** Represents an update to a `Schema`. Fields that are set will be updated. */
export type SchemaPatch = {
  /** User ID of the Application responsible for RPC/Controls of this Schema (Schema Application Owner). */
  applicationOwner?: InputMaybe<Scalars['UUID']['input']>;
  defaultTtl?: InputMaybe<IntervalInput>;
  /** Schema description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** User Group with EditorGroup access permission.  */
  editorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Administrative Schema's status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schema unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema author name meta information.  */
  mAuthor?: InputMaybe<Scalars['String']['input']>;
  /** Schema author's email meta information.  */
  mEmail?: InputMaybe<Scalars['String']['input']>;
  /** User ID in the external system meta information. */
  mExternalId?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema icon in base64. */
  mIcon?: InputMaybe<Scalars['String']['input']>;
  /** Schema long name meta information.  */
  mLongname?: InputMaybe<Scalars['String']['input']>;
  /** Schema manufacturer name meta information.  */
  mManufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Schema picture in base64. */
  mPicture?: InputMaybe<Scalars['String']['input']>;
  /** Tags for Schema clusterization */
  mTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Schema version meta information.  */
  mVersion?: InputMaybe<Scalars['String']['input']>;
  /** Schema name. */
  name?: InputMaybe<Scalars['String']['input']>;
  parentSchemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** User Group with ReaderGroup access permission.  */
  readergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Schema type (DEVICE/MEDIA/DATASET/other). */
  type?: InputMaybe<SchemaTypes>;
  /** User Group with UserGroup access permission.  */
  usergroup?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `SchemaProperty` values. */
export type SchemaPropertiesConnection = {
  __typename?: 'SchemaPropertiesConnection';
  /** A list of edges which contains the `SchemaProperty` and cursor to aid in pagination. */
  edges: Array<SchemaPropertiesEdge>;
  /** A list of `SchemaProperty` objects. */
  nodes: Array<Maybe<SchemaProperty>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SchemaProperty` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SchemaProperty` edge in the connection. */
export type SchemaPropertiesEdge = {
  __typename?: 'SchemaPropertiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SchemaProperty` at the end of the edge. */
  node?: Maybe<SchemaProperty>;
};

/** Methods to use when ordering `SchemaProperty`. */
export enum SchemaPropertiesOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DefaultValueAsc = 'DEFAULT_VALUE_ASC',
  DefaultValueDesc = 'DEFAULT_VALUE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  GroupDescriptionAsc = 'GROUP_DESCRIPTION_ASC',
  GroupDescriptionDesc = 'GROUP_DESCRIPTION_DESC',
  GroupNameAsc = 'GROUP_NAME_ASC',
  GroupNameDesc = 'GROUP_NAME_DESC',
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  JsonSchemaAsc = 'JSON_SCHEMA_ASC',
  JsonSchemaDesc = 'JSON_SCHEMA_DESC',
  MaskAsc = 'MASK_ASC',
  MaskDesc = 'MASK_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyAsc = 'PROPERTY_ASC',
  PropertyDesc = 'PROPERTY_DESC',
  RegexAsc = 'REGEX_ASC',
  RegexDesc = 'REGEX_DESC',
  SchemaIdAsc = 'SCHEMA_ID_ASC',
  SchemaIdDesc = 'SCHEMA_ID_DESC',
  StealthAsc = 'STEALTH_ASC',
  StealthDesc = 'STEALTH_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC',
  UnitsAsc = 'UNITS_ASC',
  UnitsDesc = 'UNITS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueRangeAsc = 'VALUE_RANGE_ASC',
  ValueRangeDesc = 'VALUE_RANGE_DESC',
  ValueSetAsc = 'VALUE_SET_ASC',
  ValueSetDesc = 'VALUE_SET_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type SchemaPropertiesSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: SchemaPropertiesSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type SchemaPropertiesSortBy = {
  field?: InputMaybe<SchemaPropertiesSortableField>;
};

/** Sortable concrete fields for the `SchemaProperty` type. */
export enum SchemaPropertiesSortableField {
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  DefaultValue = 'DEFAULT_VALUE',
  Description = 'DESCRIPTION',
  GroupDescription = 'GROUP_DESCRIPTION',
  GroupName = 'GROUP_NAME',
  Hidden = 'HIDDEN',
  Id = 'ID',
  Index = 'INDEX',
  JsonSchema = 'JSON_SCHEMA',
  Mask = 'MASK',
  Property = 'PROPERTY',
  Regex = 'REGEX',
  SchemaId = 'SCHEMA_ID',
  Stealth = 'STEALTH',
  TypeId = 'TYPE_ID',
  Units = 'UNITS',
  UpdatedAt = 'UPDATED_AT',
  ValueRange = 'VALUE_RANGE',
  ValueSet = 'VALUE_SET'
}

/** Schema Property represents Properties supported by Schema.  */
export type SchemaProperty = Node & {
  __typename?: 'SchemaProperty';
  /** User last updated the Property. */
  by?: Maybe<Scalars['UUID']['output']>;
  /** Property creation timestamp. */
  createdAt: Scalars['Datetime']['output'];
  /** Property default value used on Object instantiation.  */
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  /** Property description.  */
  description?: Maybe<Scalars['String']['output']>;
  /** Schema Property Group description. */
  groupDescription?: Maybe<Scalars['String']['output']>;
  /** Schema Property Group name. */
  groupName: Scalars['String']['output'];
  /** @deprecated true */
  hidden: Scalars['Boolean']['output'];
  /** Schema Property unique ID. */
  id: Scalars['UUID']['output'];
  /** Property index (for arrays). */
  index: Scalars['BigInt']['output'];
  jsonSchema?: Maybe<Scalars['JSON']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  /** Property input mask. */
  mask?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Schema Property name. */
  property: Scalars['String']['output'];
  propertyI18N?: Maybe<Scalars['String']['output']>;
  /** Property regex for validation.  */
  regex?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Schema` that is related to this `SchemaProperty`. */
  schema?: Maybe<Schema>;
  /** Schema ID this Property belongs to. */
  schemaId: Scalars['UUID']['output'];
  /** If true, this Property would not be saved in Properties' History storage once instantiated. */
  stealth?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `PropertyType` that is related to this `SchemaProperty`. */
  type?: Maybe<PropertyType>;
  typeId: Scalars['UUID']['output'];
  /** Property units indication.  */
  units?: Maybe<Scalars['String']['output']>;
  /** Property last update timestamp. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `SchemaProperty`. */
  userByBy?: Maybe<User>;
  /** Property supported value range. */
  valueRange?: Maybe<Scalars['JSON']['output']>;
  /** Property set of possible values.  */
  valueSet?: Maybe<Scalars['JSON']['output']>;
};

export type SchemaPropertyChangedFilterType = {
  groupName?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A condition to be used against `SchemaProperty` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SchemaPropertyCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `groupDescription` field. */
  groupDescription?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `groupName` field. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `jsonSchema` field. */
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `mask` field. */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `property` field. */
  property?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `regex` field. */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `schemaId` field. */
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `stealth` field. */
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `typeId` field. */
  typeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `units` field. */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `valueRange` field. */
  valueRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `valueSet` field. */
  valueSet?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `SchemaProperty` object types. All fields are combined with a logical ‘and.’ */
export type SchemaPropertyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SchemaPropertyFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultValue` field. */
  defaultValue?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupDescription` field. */
  groupDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupName` field. */
  groupName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `jsonSchema` field. */
  jsonSchema?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mask` field. */
  mask?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SchemaPropertyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SchemaPropertyFilter>>;
  /** Filter by the object’s `property` field. */
  property?: InputMaybe<StringFilter>;
  /** Filter by the object’s `propertyI18N` field. */
  propertyI18N?: InputMaybe<StringFilter>;
  /** Filter by the object’s `regex` field. */
  regex?: InputMaybe<StringFilter>;
  /** Filter by the object’s `schema` relation. */
  schema?: InputMaybe<SchemaFilter>;
  /** Filter by the object’s `schemaId` field. */
  schemaId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `stealth` field. */
  stealth?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `type` relation. */
  type?: InputMaybe<PropertyTypeFilter>;
  /** Filter by the object’s `typeId` field. */
  typeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `units` field. */
  units?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `SchemaProperty` */
export type SchemaPropertyInput = {
  /** Property default value used on Object instantiation.  */
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Property description.  */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property Group description. */
  groupDescription?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property Group name. */
  groupName: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schema Property unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Property index (for arrays). */
  index?: InputMaybe<Scalars['BigInt']['input']>;
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Property input mask. */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property name. */
  property: Scalars['String']['input'];
  /** Property regex for validation.  */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Schema ID this Property belongs to. */
  schemaId: Scalars['UUID']['input'];
  /** If true, this Property would not be saved in Properties' History storage once instantiated. */
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  typeId: Scalars['UUID']['input'];
  /** Property units indication.  */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Property supported value range. */
  valueRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Property set of possible values.  */
  valueSet?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `SchemaProperty`. Fields that are set will be updated. */
export type SchemaPropertyPatch = {
  /** Property default value used on Object instantiation.  */
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  /** Property description.  */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property Group description. */
  groupDescription?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property Group name. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schema Property unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Property index (for arrays). */
  index?: InputMaybe<Scalars['BigInt']['input']>;
  jsonSchema?: InputMaybe<Scalars['JSON']['input']>;
  /** Property input mask. */
  mask?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property name. */
  property?: InputMaybe<Scalars['String']['input']>;
  /** Property regex for validation.  */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Schema ID this Property belongs to. */
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, this Property would not be saved in Properties' History storage once instantiated. */
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  typeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Property units indication.  */
  units?: InputMaybe<Scalars['String']['input']>;
  /** Property supported value range. */
  valueRange?: InputMaybe<Scalars['JSON']['input']>;
  /** Property set of possible values.  */
  valueSet?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against many `Object` object types. All fields are combined with a logical ‘and.’ */
export type SchemaToManyObjectFilter = {
  /** Every related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectFilter>;
  /** No related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectFilter>;
  /** Some related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectFilter>;
};

/** A filter to be used against many `SchemaControl` object types. All fields are combined with a logical ‘and.’ */
export type SchemaToManySchemaControlFilter = {
  /** Every related `SchemaControl` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaControlFilter>;
  /** No related `SchemaControl` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaControlFilter>;
  /** Some related `SchemaControl` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaControlFilter>;
};

/** A filter to be used against many `Schema` object types. All fields are combined with a logical ‘and.’ */
export type SchemaToManySchemaFilter = {
  /** Every related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaFilter>;
  /** No related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaFilter>;
  /** Some related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaFilter>;
};

/** A filter to be used against many `SchemaProperty` object types. All fields are combined with a logical ‘and.’ */
export type SchemaToManySchemaPropertyFilter = {
  /** Every related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaPropertyFilter>;
  /** No related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaPropertyFilter>;
  /** Some related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaPropertyFilter>;
};

export enum SchemaTypes {
  Application = 'APPLICATION',
  Dataset = 'DATASET',
  Device = 'DEVICE',
  Media = 'MEDIA'
}

/** A filter to be used against SchemaTypes fields. All fields are combined with a logical ‘and.’ */
export type SchemaTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SchemaTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SchemaTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SchemaTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SchemaTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SchemaTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SchemaTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SchemaTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SchemaTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SchemaTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SchemaTypes>>;
};

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type SchemasSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: SchemasSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type SchemasSortBy = {
  field?: InputMaybe<SchemasSortableField>;
};

/** Sortable concrete fields for the `Schema` type. */
export enum SchemasSortableField {
  ApplicationOwner = 'APPLICATION_OWNER',
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  DefaultTtl = 'DEFAULT_TTL',
  Description = 'DESCRIPTION',
  Editorgroup = 'EDITORGROUP',
  Enabled = 'ENABLED',
  Id = 'ID',
  MAuthor = 'M_AUTHOR',
  MEmail = 'M_EMAIL',
  MExternalId = 'M_EXTERNAL_ID',
  MIcon = 'M_ICON',
  MLongname = 'M_LONGNAME',
  MManufacturer = 'M_MANUFACTURER',
  MPicture = 'M_PICTURE',
  MTags = 'M_TAGS',
  MVersion = 'M_VERSION',
  Name = 'NAME',
  ParentSchemaId = 'PARENT_SCHEMA_ID',
  Readergroup = 'READERGROUP',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  Usergroup = 'USERGROUP'
}

/** A connection to a list of `Schema` values. */
export type SchemataConnection = {
  __typename?: 'SchemataConnection';
  /** A list of edges which contains the `Schema` and cursor to aid in pagination. */
  edges: Array<SchemataEdge>;
  /** A list of `Schema` objects. */
  nodes: Array<Maybe<Schema>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Schema` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Schema` edge in the connection. */
export type SchemataEdge = {
  __typename?: 'SchemataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Schema` at the end of the edge. */
  node?: Maybe<Schema>;
};

/** Methods to use when ordering `Schema`. */
export enum SchemataOrderBy {
  ApplicationOwnerAsc = 'APPLICATION_OWNER_ASC',
  ApplicationOwnerDesc = 'APPLICATION_OWNER_DESC',
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DefaultTtlAsc = 'DEFAULT_TTL_ASC',
  DefaultTtlDesc = 'DEFAULT_TTL_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EditorgroupAsc = 'EDITORGROUP_ASC',
  EditorgroupDesc = 'EDITORGROUP_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MAuthorAsc = 'M_AUTHOR_ASC',
  MAuthorDesc = 'M_AUTHOR_DESC',
  MEmailAsc = 'M_EMAIL_ASC',
  MEmailDesc = 'M_EMAIL_DESC',
  MExternalIdAsc = 'M_EXTERNAL_ID_ASC',
  MExternalIdDesc = 'M_EXTERNAL_ID_DESC',
  MIconAsc = 'M_ICON_ASC',
  MIconDesc = 'M_ICON_DESC',
  MLongnameAsc = 'M_LONGNAME_ASC',
  MLongnameDesc = 'M_LONGNAME_DESC',
  MManufacturerAsc = 'M_MANUFACTURER_ASC',
  MManufacturerDesc = 'M_MANUFACTURER_DESC',
  MPictureAsc = 'M_PICTURE_ASC',
  MPictureDesc = 'M_PICTURE_DESC',
  MTagsAsc = 'M_TAGS_ASC',
  MTagsDesc = 'M_TAGS_DESC',
  MVersionAsc = 'M_VERSION_ASC',
  MVersionDesc = 'M_VERSION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ObjectsCountAsc = 'OBJECTS_COUNT_ASC',
  ObjectsCountDesc = 'OBJECTS_COUNT_DESC',
  ParentSchemaIdAsc = 'PARENT_SCHEMA_ID_ASC',
  ParentSchemaIdDesc = 'PARENT_SCHEMA_ID_DESC',
  ParentSchemaNameAsc = 'PARENT_SCHEMA_NAME_ASC',
  ParentSchemaNameDesc = 'PARENT_SCHEMA_NAME_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReadergroupAsc = 'READERGROUP_ASC',
  ReadergroupDesc = 'READERGROUP_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UsergroupAsc = 'USERGROUP_ASC',
  UsergroupDesc = 'USERGROUP_DESC'
}

/** All input for the `setObjectFavourite` mutation. */
export type SetObjectFavouriteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  favourite: Scalars['Boolean']['input'];
  objectsId: Array<InputMaybe<Scalars['UUID']['input']>>;
};

/** The output of our `setObjectFavourite` mutation. */
export type SetObjectFavouritePayload = {
  __typename?: 'SetObjectFavouritePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setObjectMuted` mutation. */
export type SetObjectMutedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  muted: Scalars['Boolean']['input'];
  objectsId: Array<InputMaybe<Scalars['UUID']['input']>>;
};

/** The output of our `setObjectMuted` mutation. */
export type SetObjectMutedPayload = {
  __typename?: 'SetObjectMutedPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** When the given sortable is null, should we position this at the end of the list or the beginning of the list? */
export enum SortNulls {
  /** Order nulls last when in ascending order, or first when in descending order. */
  Default = 'DEFAULT',
  /** Order nulls first (at the beginning of the list). */
  First = 'FIRST',
  /** Order nulls last (at the end of the list). */
  Last = 'LAST'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Listen for any new Control Executions with filter functionality */
  ControlExecutions?: Maybe<ListenControlExecutionsPayload>;
  /** Listen for any new Notifications with filter functionality */
  Notifications?: Maybe<ListenNotificationsPayload>;
  /** Listen for any changes in Objects, ObjectProperties and ObjectToObjects with filter functionality */
  Objects?: Maybe<ListenObjectsPayload>;
  /** Listen for any changes in Schemas and SchemaProperties with filter functionality */
  Schemas?: Maybe<ListenSchemasPayload>;
  /** Listen for any changes in the Platform based on Topic tag */
  listen?: Maybe<ListenPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionControlExecutionsArgs = {
  filterA?: InputMaybe<SubscriptionControlExecutionFilter>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionNotificationsArgs = {
  filterA?: InputMaybe<SubscriptionNotificationFilter>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionObjectsArgs = {
  filterA?: InputMaybe<SubscriptionObjectsFilter>;
  filterB?: InputMaybe<SubscriptionObjectsFilter>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionSchemasArgs = {
  filterA?: InputMaybe<SubscriptionSchemaFilter>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionListenArgs = {
  topic: Scalars['String']['input'];
};

export type SubscriptionControlExecutionFilter = {
  caller_id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  controller?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  linked_control_id?: InputMaybe<Scalars['Int']['input']>;
  object_id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ControlTypes>>>;
};

export type SubscriptionNotificationFilter = {
  by?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  deliveryPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryUser?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  object_id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionObjectsFilter = {
  childObjects?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id?: InputMaybe<Array<Scalars['UUID']['input']>>;
  parentObjects?: InputMaybe<Array<Scalars['UUID']['input']>>;
  propertyChanged?: InputMaybe<Array<ObjectPropertyChangedFilterType>>;
  schemaId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSchemaFilter = {
  id?: InputMaybe<Array<Scalars['UUID']['input']>>;
  propertyChanged?: InputMaybe<Array<SchemaPropertyChangedFilterType>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Simple Translations item representation.
 *
 */
export type Translation = Node & {
  __typename?: 'Translation';
  /** Translation item in Chinese. */
  cn?: Maybe<Scalars['String']['output']>;
  /** Translation item in English. */
  en?: Maybe<Scalars['String']['output']>;
  /** Translation item GraphQL related query field name. */
  key?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Translation item GraphQL related query object name. */
  query?: Maybe<Scalars['String']['output']>;
  /** Translation item in Russian. */
  ru?: Maybe<Scalars['String']['output']>;
  /** Translation item in Thai. */
  th?: Maybe<Scalars['String']['output']>;
  /** Translation item unique ID. */
  uuid: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `Translation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TranslationCondition = {
  /** Checks for equality with the object’s `cn` field. */
  cn?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `en` field. */
  en?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `query` field. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ru` field. */
  ru?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `th` field. */
  th?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `uuid` field. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `Translation` object types. All fields are combined with a logical ‘and.’ */
export type TranslationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TranslationFilter>>;
  /** Filter by the object’s `cn` field. */
  cn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `en` field. */
  en?: InputMaybe<StringFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TranslationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TranslationFilter>>;
  /** Filter by the object’s `query` field. */
  query?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ru` field. */
  ru?: InputMaybe<StringFilter>;
  /** Filter by the object’s `th` field. */
  th?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uuid` field. */
  uuid?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Translation` */
export type TranslationInput = {
  /** Translation item in Chinese. */
  cn?: InputMaybe<Scalars['String']['input']>;
  /** Translation item in English. */
  en?: InputMaybe<Scalars['String']['input']>;
  /** Translation item GraphQL related query field name. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Translation item GraphQL related query object name. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Translation item in Russian. */
  ru?: InputMaybe<Scalars['String']['input']>;
  /** Translation item in Thai. */
  th?: InputMaybe<Scalars['String']['input']>;
  /** Translation item unique ID. */
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `Translation` values. */
export type TranslationsConnection = {
  __typename?: 'TranslationsConnection';
  /** A list of edges which contains the `Translation` and cursor to aid in pagination. */
  edges: Array<TranslationsEdge>;
  /** A list of `Translation` objects. */
  nodes: Array<Maybe<Translation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Translation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Translation` edge in the connection. */
export type TranslationsEdge = {
  __typename?: 'TranslationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Translation` at the end of the edge. */
  node?: Maybe<Translation>;
};

/** Methods to use when ordering `Translation`. */
export enum TranslationsOrderBy {
  CnAsc = 'CN_ASC',
  CnDesc = 'CN_DESC',
  EnAsc = 'EN_ASC',
  EnDesc = 'EN_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QueryAsc = 'QUERY_ASC',
  QueryDesc = 'QUERY_DESC',
  RuAsc = 'RU_ASC',
  RuDesc = 'RU_DESC',
  ThAsc = 'TH_ASC',
  ThDesc = 'TH_DESC',
  UuidAsc = 'UUID_ASC',
  UuidDesc = 'UUID_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type TranslationsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: TranslationsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type TranslationsSortBy = {
  field?: InputMaybe<TranslationsSortableField>;
};

/** Sortable concrete fields for the `Translation` type. */
export enum TranslationsSortableField {
  Cn = 'CN',
  En = 'EN',
  Key = 'KEY',
  Query = 'QUERY',
  Ru = 'RU',
  Th = 'TH',
  Uuid = 'UUID'
}

export type TwoFa = {
  __typename?: 'TwoFa';
  info?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum TwoFaTypes {
  Email = 'EMAIL',
  None = 'NONE',
  Sms = 'SMS'
}

/** A filter to be used against TwoFaTypes fields. All fields are combined with a logical ‘and.’ */
export type TwoFaTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TwoFaTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TwoFaTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TwoFaTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TwoFaTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TwoFaTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TwoFaTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TwoFaTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TwoFaTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TwoFaTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TwoFaTypes>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateControlExecutionAck` mutation. */
export type UpdateControlExecutionAckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  controlsExecutionId: Scalars['BigInt']['input'];
};

/** The output of our `updateControlExecutionAck` mutation. */
export type UpdateControlExecutionAckPayload = {
  __typename?: 'UpdateControlExecutionAckPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateJsonPropertyArray` mutation. */
export type UpdateJsonPropertyArrayInput = {
  arrayElement: Scalars['JSON']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  elementPosition: Scalars['Int']['input'];
  propertyId: Scalars['UUID']['input'];
};

/** The output of our `updateJsonPropertyArray` mutation. */
export type UpdateJsonPropertyArrayPayload = {
  __typename?: 'UpdateJsonPropertyArrayPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateObjectByNodeId` mutation. */
export type UpdateObjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Object` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Object` being updated. */
  patch: ObjectPatch;
};

/** All input for the `updateObject` mutation. */
export type UpdateObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique Object ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Object` being updated. */
  patch: ObjectPatch;
};

/** The output of our update `Object` mutation. */
export type UpdateObjectPayload = {
  __typename?: 'UpdateObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Object` that was updated by this mutation. */
  object?: Maybe<Object>;
  /** An edge for our `Object`. May be used by Relay 1. */
  objectEdge?: Maybe<ObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our update `Object` mutation. */
export type UpdateObjectPayloadObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
};

/** All input for the `updateObjectPropertiesById` mutation. */
export type UpdateObjectPropertiesByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  propertiesArray?: InputMaybe<Array<InputMaybe<PropertyByIdInput>>>;
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `updateObjectPropertiesById` mutation. */
export type UpdateObjectPropertiesByIdPayload = {
  __typename?: 'UpdateObjectPropertiesByIdPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateObjectPropertiesByKey` mutation. */
export type UpdateObjectPropertiesByKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  propertiesArray?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>>>;
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `updateObjectPropertiesByKey` mutation. */
export type UpdateObjectPropertiesByKeyPayload = {
  __typename?: 'UpdateObjectPropertiesByKeyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type UpdateObjectPropertiesByNameInput = {
  objectId: Scalars['UUID']['input'];
  propertiesArray: Array<PropertyByName2Input>;
  transactionId: Scalars['BigInt']['input'];
};

export type UpdateObjectPropertiesByNamePayload = {
  __typename?: 'UpdateObjectPropertiesByNamePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** All input for the `updateObjectPropertiesHistoryByNodeId` mutation. */
export type UpdateObjectPropertiesHistoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ObjectPropertiesHistory` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ObjectPropertiesHistory` being updated. */
  patch: ObjectPropertiesHistoryPatch;
};

/** All input for the `updateObjectPropertiesHistory` mutation. */
export type UpdateObjectPropertiesHistoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `ObjectPropertiesHistory` being updated. */
  patch: ObjectPropertiesHistoryPatch;
  recordedAt: Scalars['Datetime']['input'];
};

/** The output of our update `ObjectPropertiesHistory` mutation. */
export type UpdateObjectPropertiesHistoryPayload = {
  __typename?: 'UpdateObjectPropertiesHistoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ObjectPropertiesHistory` that was updated by this mutation. */
  objectPropertiesHistory?: Maybe<ObjectPropertiesHistory>;
  /** An edge for our `ObjectPropertiesHistory`. May be used by Relay 1. */
  objectPropertiesHistoryEdge?: Maybe<ObjectPropertiesHistoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ObjectPropertiesHistory`. */
  userByBy?: Maybe<User>;
};


/** The output of our update `ObjectPropertiesHistory` mutation. */
export type UpdateObjectPropertiesHistoryPayloadObjectPropertiesHistoryEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
};

/** All input for the `updateObjectPropertyByNodeId` mutation. */
export type UpdateObjectPropertyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ObjectProperty` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ObjectProperty` being updated. */
  patch: ObjectPropertyPatch;
};

/** All input for the `updateObjectPropertyByObjectGroupProperty` mutation. */
export type UpdateObjectPropertyByObjectGroupPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  objId?: InputMaybe<Scalars['UUID']['input']>;
  propertyName?: InputMaybe<Scalars['String']['input']>;
  propertyValue?: InputMaybe<Scalars['JSON']['input']>;
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `updateObjectPropertyByObjectGroupProperty` mutation. */
export type UpdateObjectPropertyByObjectGroupPropertyPayload = {
  __typename?: 'UpdateObjectPropertyByObjectGroupPropertyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateObjectProperty` mutation. */
export type UpdateObjectPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Property unique ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ObjectProperty` being updated. */
  patch: ObjectPropertyPatch;
};

/** The output of our update `ObjectProperty` mutation. */
export type UpdateObjectPropertyPayload = {
  __typename?: 'UpdateObjectPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Object` that is related to this `ObjectProperty`. */
  object?: Maybe<Object>;
  /** The `ObjectProperty` that was updated by this mutation. */
  objectProperty?: Maybe<ObjectProperty>;
  /** An edge for our `ObjectProperty`. May be used by Relay 1. */
  objectPropertyEdge?: Maybe<ObjectPropertiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `ObjectProperty`. */
  userByBy?: Maybe<User>;
};


/** The output of our update `ObjectProperty` mutation. */
export type UpdateObjectPropertyPayloadObjectPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
};

/** All input for the `updateObjectWithProperties` mutation. */
export type UpdateObjectWithPropertiesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  detailedObject?: InputMaybe<Array<InputMaybe<DetailedObjectInput>>>;
};

/** The output of our `updateObjectWithProperties` mutation. */
export type UpdateObjectWithPropertiesPayload = {
  __typename?: 'UpdateObjectWithPropertiesPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateObjectsPropertiesByKey` mutation. */
export type UpdateObjectsPropertiesByKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  propertiesArray?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>>>;
  schemaId?: InputMaybe<Scalars['UUID']['input']>;
  transactionId?: InputMaybe<Scalars['BigInt']['input']>;
};

/** The output of our `updateObjectsPropertiesByKey` mutation. */
export type UpdateObjectsPropertiesByKeyPayload = {
  __typename?: 'UpdateObjectsPropertiesByKeyPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updatePropertyTypeByName` mutation. */
export type UpdatePropertyTypeByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type name (must be unique) */
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `PropertyType` being updated. */
  patch: PropertyTypePatch;
};

/** All input for the `updatePropertyTypeByNodeId` mutation. */
export type UpdatePropertyTypeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PropertyType` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PropertyType` being updated. */
  patch: PropertyTypePatch;
};

/** All input for the `updatePropertyType` mutation. */
export type UpdatePropertyTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type id. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `PropertyType` being updated. */
  patch: PropertyTypePatch;
};

/** The output of our update `PropertyType` mutation. */
export type UpdatePropertyTypePayload = {
  __typename?: 'UpdatePropertyTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `PropertyType` that was updated by this mutation. */
  propertyType?: Maybe<PropertyType>;
  /** An edge for our `PropertyType`. May be used by Relay 1. */
  propertyTypeEdge?: Maybe<PropertyTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PropertyType` mutation. */
export type UpdatePropertyTypePayloadPropertyTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
};

/** All input for the `updateSchemaByNodeId` mutation. */
export type UpdateSchemaByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Schema` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Schema` being updated. */
  patch: SchemaPatch;
};

/** All input for the `updateSchemaControlByNodeId` mutation. */
export type UpdateSchemaControlByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaControl` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SchemaControl` being updated. */
  patch: SchemaControlPatch;
};

/** All input for the `updateSchemaControl` mutation. */
export type UpdateSchemaControlInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schema Controls unique ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `SchemaControl` being updated. */
  patch: SchemaControlPatch;
};

/** The output of our update `SchemaControl` mutation. */
export type UpdateSchemaControlPayload = {
  __typename?: 'UpdateSchemaControlPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `SchemaControl`. */
  schema?: Maybe<Schema>;
  /** The `SchemaControl` that was updated by this mutation. */
  schemaControl?: Maybe<SchemaControl>;
  /** An edge for our `SchemaControl`. May be used by Relay 1. */
  schemaControlEdge?: Maybe<SchemaControlsEdge>;
  /** Reads a single `User` that is related to this `SchemaControl`. */
  userByBy?: Maybe<User>;
};


/** The output of our update `SchemaControl` mutation. */
export type UpdateSchemaControlPayloadSchemaControlEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
};

/** All input for the `updateSchema` mutation. */
export type UpdateSchemaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schema unique ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Schema` being updated. */
  patch: SchemaPatch;
};

/** The output of our update `Schema` mutation. */
export type UpdateSchemaPayload = {
  __typename?: 'UpdateSchemaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Schema` that was updated by this mutation. */
  schema?: Maybe<Schema>;
  /** An edge for our `Schema`. May be used by Relay 1. */
  schemaEdge?: Maybe<SchemataEdge>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our update `Schema` mutation. */
export type UpdateSchemaPayloadSchemaEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
};

/** All input for the `updateSchemaPropertiesById` mutation. */
export type UpdateSchemaPropertiesByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  propertiesArray?: InputMaybe<Array<InputMaybe<PropertyByIdInput>>>;
};

/** The output of our `updateSchemaPropertiesById` mutation. */
export type UpdateSchemaPropertiesByIdPayload = {
  __typename?: 'UpdateSchemaPropertiesByIdPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateSchemaPropertiesDefaults` mutation. */
export type UpdateSchemaPropertiesDefaultsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  propertiesArray: Array<InputMaybe<PropertyByIdInput>>;
  propertiesByKeyArray: Array<InputMaybe<PropertyByKeyInput>>;
  schemaId: Scalars['UUID']['input'];
  valueInit: Scalars['Boolean']['input'];
};

/** The output of our `updateSchemaPropertiesDefaults` mutation. */
export type UpdateSchemaPropertiesDefaultsPayload = {
  __typename?: 'UpdateSchemaPropertiesDefaultsPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateSchemaPropertyByNodeId` mutation. */
export type UpdateSchemaPropertyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SchemaProperty` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SchemaProperty` being updated. */
  patch: SchemaPropertyPatch;
};

/** All input for the `updateSchemaProperty` mutation. */
export type UpdateSchemaPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schema Property unique ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `SchemaProperty` being updated. */
  patch: SchemaPropertyPatch;
};

/** The output of our update `SchemaProperty` mutation. */
export type UpdateSchemaPropertyPayload = {
  __typename?: 'UpdateSchemaPropertyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `SchemaProperty`. */
  schema?: Maybe<Schema>;
  /** The `SchemaProperty` that was updated by this mutation. */
  schemaProperty?: Maybe<SchemaProperty>;
  /** An edge for our `SchemaProperty`. May be used by Relay 1. */
  schemaPropertyEdge?: Maybe<SchemaPropertiesEdge>;
  /** Reads a single `PropertyType` that is related to this `SchemaProperty`. */
  type?: Maybe<PropertyType>;
  /** Reads a single `User` that is related to this `SchemaProperty`. */
  userByBy?: Maybe<User>;
};


/** The output of our update `SchemaProperty` mutation. */
export type UpdateSchemaPropertyPayloadSchemaPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
};

/** All input for the `updateUserByLogin` mutation. */
export type UpdateUserByLoginInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User's login name (User name).  */
  login: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserByNodeId` mutation. */
export type UpdateUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserGroupByGroupName` mutation. */
export type UpdateUserGroupByGroupNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User Group name.  */
  groupName: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `UserGroup` being updated. */
  patch: UserGroupPatch;
};

/** All input for the `updateUserGroupByNodeId` mutation. */
export type UpdateUserGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserGroup` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserGroup` being updated. */
  patch: UserGroupPatch;
};

/** All input for the `updateUserGroup` mutation. */
export type UpdateUserGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User Group unique ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `UserGroup` being updated. */
  patch: UserGroupPatch;
};

/** The output of our update `UserGroup` mutation. */
export type UpdateUserGroupPayload = {
  __typename?: 'UpdateUserGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserGroup`. */
  userByBy?: Maybe<User>;
  /** The `UserGroup` that was updated by this mutation. */
  userGroup?: Maybe<UserGroup>;
  /** An edge for our `UserGroup`. May be used by Relay 1. */
  userGroupEdge?: Maybe<UserGroupsEdge>;
};


/** The output of our update `UserGroup` mutation. */
export type UpdateUserGroupPayloadUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User unique ID. */
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUsersToGroupByNodeId` mutation. */
export type UpdateUsersToGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UsersToGroup` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UsersToGroup` being updated. */
  patch: UsersToGroupPatch;
};

/** All input for the `updateUsersToGroupByUserIdAndUserGroupId` mutation. */
export type UpdateUsersToGroupByUserIdAndUserGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `UsersToGroup` being updated. */
  patch: UsersToGroupPatch;
  /** User Group unique ID. */
  userGroupId: Scalars['UUID']['input'];
  /** User unique ID. */
  userId: Scalars['UUID']['input'];
};

/** All input for the `updateUsersToGroup` mutation. */
export type UpdateUsersToGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `UsersToGroup` being updated. */
  patch: UsersToGroupPatch;
};

/** The output of our update `UsersToGroup` mutation. */
export type UpdateUsersToGroupPayload = {
  __typename?: 'UpdateUsersToGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UsersToGroup`. */
  user?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `UsersToGroup`. */
  userGroup?: Maybe<UserGroup>;
  /** The `UsersToGroup` that was updated by this mutation. */
  usersToGroup?: Maybe<UsersToGroup>;
  /** An edge for our `UsersToGroup`. May be used by Relay 1. */
  usersToGroupEdge?: Maybe<UsersToGroupsEdge>;
};


/** The output of our update `UsersToGroup` mutation. */
export type UpdateUsersToGroupPayloadUsersToGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
};

/** All input for the `updateUsersToObjectByNodeId` mutation. */
export type UpdateUsersToObjectByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UsersToObject` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UsersToObject` being updated. */
  patch: UsersToObjectPatch;
};

/** All input for the `updateUsersToObjectByUserIdAndObjectId` mutation. */
export type UpdateUsersToObjectByUserIdAndObjectIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Object unique ID. */
  objectId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `UsersToObject` being updated. */
  patch: UsersToObjectPatch;
  /** User unique ID. */
  userId: Scalars['UUID']['input'];
};

/** All input for the `updateUsersToObject` mutation. */
export type UpdateUsersToObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `UsersToObject` being updated. */
  patch: UsersToObjectPatch;
};

/** The output of our update `UsersToObject` mutation. */
export type UpdateUsersToObjectPayload = {
  __typename?: 'UpdateUsersToObjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Object` that is related to this `UsersToObject`. */
  object?: Maybe<Object>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UsersToObject`. */
  user?: Maybe<User>;
  /** The `UsersToObject` that was updated by this mutation. */
  usersToObject?: Maybe<UsersToObject>;
  /** An edge for our `UsersToObject`. May be used by Relay 1. */
  usersToObjectEdge?: Maybe<UsersToObjectsEdge>;
};


/** The output of our update `UsersToObject` mutation. */
export type UpdateUsersToObjectPayloadUsersToObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
};

/** Users existing within the platform.  */
export type User = Node & {
  __typename?: 'User';
  /** Indicates if the User is activated. */
  activated?: Maybe<Scalars['Boolean']['output']>;
  /** User last updated the User. */
  by?: Maybe<Scalars['UUID']['output']>;
  /** Reads and enables pagination through a set of `ControlExecution`. */
  controlExecutionsByCallerId: Array<ControlExecution>;
  /** Reads and enables pagination through a set of `ControlExecution`. */
  controlExecutionsByCallerIdConnection: ControlExecutionsConnection;
  /** User creation timestamp. */
  createdAt: Scalars['Datetime']['output'];
  defaultEditorgroup?: Maybe<Scalars['UUID']['output']>;
  defaultReadergroup: Scalars['UUID']['output'];
  defaultUsergroup: Scalars['UUID']['output'];
  /** User description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Administrative User's status. */
  enabled: Scalars['Boolean']['output'];
  /** User unique ID. */
  id: Scalars['UUID']['output'];
  /** User's login name (User name).  */
  login: Scalars['String']['output'];
  logonStatus?: Maybe<Scalars['String']['output']>;
  /** User email meta information. */
  mEmail?: Maybe<Scalars['String']['output']>;
  /** User ID in the external system meta information. */
  mExternalId?: Maybe<Scalars['JSON']['output']>;
  /** User icon (Media Object) meta information. */
  mIcon?: Maybe<Scalars['UUID']['output']>;
  /** User name meta information. */
  mName?: Maybe<Scalars['String']['output']>;
  /** User phone meta information. */
  mPhone?: Maybe<Scalars['String']['output']>;
  /** User picture (Media Object) meta information. */
  mPicture?: Maybe<Scalars['UUID']['output']>;
  mTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveriesByUser: Array<NotificationDelivery>;
  /** Reads and enables pagination through a set of `NotificationDelivery`. */
  notificationDeliveriesByUserConnection: NotificationDeliveriesConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsByBy: Array<Notification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsByByConnection: NotificationsConnection;
  /** Reads and enables pagination through a set of `ObjectProperty`. */
  objectPropertiesByBy: Array<ObjectProperty>;
  /** Reads and enables pagination through a set of `ObjectProperty`. */
  objectPropertiesByByConnection: ObjectPropertiesConnection;
  /** Reads and enables pagination through a set of `ObjectPropertiesHistory`. */
  objectPropertiesHistoriesByBy: Array<ObjectPropertiesHistory>;
  /** Reads and enables pagination through a set of `ObjectPropertiesHistory`. */
  objectPropertiesHistoriesByByConnection: ObjectPropertiesHistoriesConnection;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByBy: Array<Object>;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByByConnection: ObjectsConnection;
  /** User password hash. */
  password: Scalars['String']['output'];
  passwordExpireAt: Scalars['Datetime']['output'];
  /** Indicates if the User's password reset requested. */
  passwordReset?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `SchemaControl`. */
  schemaControlsByBy: Array<SchemaControl>;
  /** Reads and enables pagination through a set of `SchemaControl`. */
  schemaControlsByByConnection: SchemaControlsConnection;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaPropertiesByBy: Array<SchemaProperty>;
  /** Reads and enables pagination through a set of `SchemaProperty`. */
  schemaPropertiesByByConnection: SchemaPropertiesConnection;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByApplicationOwner: Array<Schema>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByApplicationOwnerConnection: SchemataConnection;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByBy: Array<Schema>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByByConnection: SchemataConnection;
  /** @deprecated true */
  showhidden?: Maybe<Scalars['Boolean']['output']>;
  /** Refresh token expiration in days.  */
  tokenExp?: Maybe<Scalars['BigInt']['output']>;
  twoFaType: TwoFaTypes;
  /** User type (USER or APP) */
  type: UserTypes;
  um: Scalars['Boolean']['output'];
  /** User last update timestamp. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroupsByBy: Array<UserGroup>;
  /** Reads and enables pagination through a set of `UserGroup`. */
  userGroupsByByConnection: UserGroupsConnection;
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfiles: Array<UserProfile>;
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfilesConnection: UserProfilesConnection;
  /** Reads and enables pagination through a set of `UsersToGroup`. */
  usersToGroups: Array<UsersToGroup>;
  /** Reads and enables pagination through a set of `UsersToGroup`. */
  usersToGroupsConnection: UsersToGroupsConnection;
  /** Reads and enables pagination through a set of `UsersToObject`. */
  usersToObjects: Array<UsersToObject>;
  /** Reads and enables pagination through a set of `UsersToObject`. */
  usersToObjectsConnection: UsersToObjectsConnection;
};


/** Users existing within the platform.  */
export type UserControlExecutionsByCallerIdArgs = {
  condition?: InputMaybe<ControlExecutionCondition>;
  filter?: InputMaybe<ControlExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
  sort?: InputMaybe<Array<ControlExecutionsSort>>;
};


/** Users existing within the platform.  */
export type UserControlExecutionsByCallerIdConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ControlExecutionCondition>;
  filter?: InputMaybe<ControlExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy>>;
  sort?: InputMaybe<Array<ControlExecutionsSort>>;
};


/** Users existing within the platform.  */
export type UserNotificationDeliveriesByUserArgs = {
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** Users existing within the platform.  */
export type UserNotificationDeliveriesByUserConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationDeliveryCondition>;
  filter?: InputMaybe<NotificationDeliveryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationDeliveriesOrderBy>>;
  sort?: InputMaybe<Array<NotificationDeliveriesSort>>;
};


/** Users existing within the platform.  */
export type UserNotificationsByByArgs = {
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
  sort?: InputMaybe<Array<NotificationsSort>>;
};


/** Users existing within the platform.  */
export type UserNotificationsByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
  sort?: InputMaybe<Array<NotificationsSort>>;
};


/** Users existing within the platform.  */
export type UserObjectPropertiesByByArgs = {
  condition?: InputMaybe<ObjectPropertyCondition>;
  filter?: InputMaybe<ObjectPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesSort>>;
};


/** Users existing within the platform.  */
export type UserObjectPropertiesByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectPropertyCondition>;
  filter?: InputMaybe<ObjectPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesSort>>;
};


/** Users existing within the platform.  */
export type UserObjectPropertiesHistoriesByByArgs = {
  condition?: InputMaybe<ObjectPropertiesHistoryCondition>;
  filter?: InputMaybe<ObjectPropertiesHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesHistorySort>>;
};


/** Users existing within the platform.  */
export type UserObjectPropertiesHistoriesByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectPropertiesHistoryCondition>;
  filter?: InputMaybe<ObjectPropertiesHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy>>;
  sort?: InputMaybe<Array<ObjectPropertiesHistorySort>>;
};


/** Users existing within the platform.  */
export type UserObjectsByByArgs = {
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** Users existing within the platform.  */
export type UserObjectsByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** Users existing within the platform.  */
export type UserSchemaControlsByByArgs = {
  condition?: InputMaybe<SchemaControlCondition>;
  filter?: InputMaybe<SchemaControlFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
  sort?: InputMaybe<Array<SchemaControlsSort>>;
};


/** Users existing within the platform.  */
export type UserSchemaControlsByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaControlCondition>;
  filter?: InputMaybe<SchemaControlFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaControlsOrderBy>>;
  sort?: InputMaybe<Array<SchemaControlsSort>>;
};


/** Users existing within the platform.  */
export type UserSchemaPropertiesByByArgs = {
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


/** Users existing within the platform.  */
export type UserSchemaPropertiesByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaPropertyCondition>;
  filter?: InputMaybe<SchemaPropertyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemaPropertiesOrderBy>>;
  sort?: InputMaybe<Array<SchemaPropertiesSort>>;
};


/** Users existing within the platform.  */
export type UserSchemataByApplicationOwnerArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** Users existing within the platform.  */
export type UserSchemataByApplicationOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** Users existing within the platform.  */
export type UserSchemataByByArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** Users existing within the platform.  */
export type UserSchemataByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** Users existing within the platform.  */
export type UserUserGroupsByByArgs = {
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  sort?: InputMaybe<Array<UserGroupsSort>>;
};


/** Users existing within the platform.  */
export type UserUserGroupsByByConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserGroupCondition>;
  filter?: InputMaybe<UserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  sort?: InputMaybe<Array<UserGroupsSort>>;
};


/** Users existing within the platform.  */
export type UserUserProfilesArgs = {
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  sort?: InputMaybe<Array<UserProfilesSort>>;
};


/** Users existing within the platform.  */
export type UserUserProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
  sort?: InputMaybe<Array<UserProfilesSort>>;
};


/** Users existing within the platform.  */
export type UserUsersToGroupsArgs = {
  condition?: InputMaybe<UsersToGroupCondition>;
  filter?: InputMaybe<UsersToGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
  sort?: InputMaybe<Array<UsersToGroupsSort>>;
};


/** Users existing within the platform.  */
export type UserUsersToGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UsersToGroupCondition>;
  filter?: InputMaybe<UsersToGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
  sort?: InputMaybe<Array<UsersToGroupsSort>>;
};


/** Users existing within the platform.  */
export type UserUsersToObjectsArgs = {
  condition?: InputMaybe<UsersToObjectCondition>;
  filter?: InputMaybe<UsersToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
  sort?: InputMaybe<Array<UsersToObjectsSort>>;
};


/** Users existing within the platform.  */
export type UserUsersToObjectsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UsersToObjectCondition>;
  filter?: InputMaybe<UsersToObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToObjectsOrderBy>>;
  sort?: InputMaybe<Array<UsersToObjectsSort>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `activated` field. */
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultEditorgroup` field. */
  defaultEditorgroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `defaultReadergroup` field. */
  defaultReadergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `defaultUsergroup` field. */
  defaultUsergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `enabled` field. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `login` field. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logonStatus` field. */
  logonStatus?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mEmail` field. */
  mEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mExternalId` field. */
  mExternalId?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `mIcon` field. */
  mIcon?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mName` field. */
  mName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mPhone` field. */
  mPhone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mPicture` field. */
  mPicture?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `mTags` field. */
  mTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `password` field. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `passwordExpireAt` field. */
  passwordExpireAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `passwordReset` field. */
  passwordReset?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `showhidden` field. */
  showhidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tokenExp` field. */
  tokenExp?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `twoFaType` field. */
  twoFaType?: InputMaybe<TwoFaTypes>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<UserTypes>;
  /** Checks for equality with the object’s `um` field. */
  um?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Filter by the object’s `activated` field. */
  activated?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `controlExecutionsByCallerIdConnection` relation. */
  controlExecutionsByCallerIdConnection?: InputMaybe<UserToManyControlExecutionFilter>;
  /** Some related `controlExecutionsByCallerIdConnection` exist. */
  controlExecutionsByCallerIdConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultEditorgroup` field. */
  defaultEditorgroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `defaultReadergroup` field. */
  defaultReadergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `defaultUsergroup` field. */
  defaultUsergroup?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `enabled` field. */
  enabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `login` field. */
  login?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logonStatus` field. */
  logonStatus?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mEmail` field. */
  mEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mExternalId` field. */
  mExternalId?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `mIcon` field. */
  mIcon?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mName` field. */
  mName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mPhone` field. */
  mPhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mPicture` field. */
  mPicture?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `mTags` field. */
  mTags?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Filter by the object’s `notificationDeliveriesByUserConnection` relation. */
  notificationDeliveriesByUserConnection?: InputMaybe<UserToManyNotificationDeliveryFilter>;
  /** Some related `notificationDeliveriesByUserConnection` exist. */
  notificationDeliveriesByUserConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `notificationsByByConnection` relation. */
  notificationsByByConnection?: InputMaybe<UserToManyNotificationFilter>;
  /** Some related `notificationsByByConnection` exist. */
  notificationsByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectPropertiesByByConnection` relation. */
  objectPropertiesByByConnection?: InputMaybe<UserToManyObjectPropertyFilter>;
  /** Some related `objectPropertiesByByConnection` exist. */
  objectPropertiesByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectPropertiesHistoriesByByConnection` relation. */
  objectPropertiesHistoriesByByConnection?: InputMaybe<UserToManyObjectPropertiesHistoryFilter>;
  /** Some related `objectPropertiesHistoriesByByConnection` exist. */
  objectPropertiesHistoriesByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectsByByConnection` relation. */
  objectsByByConnection?: InputMaybe<UserToManyObjectFilter>;
  /** Some related `objectsByByConnection` exist. */
  objectsByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `password` field. */
  password?: InputMaybe<StringFilter>;
  /** Filter by the object’s `passwordExpireAt` field. */
  passwordExpireAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `passwordReset` field. */
  passwordReset?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `schemaControlsByByConnection` relation. */
  schemaControlsByByConnection?: InputMaybe<UserToManySchemaControlFilter>;
  /** Some related `schemaControlsByByConnection` exist. */
  schemaControlsByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemaPropertiesByByConnection` relation. */
  schemaPropertiesByByConnection?: InputMaybe<UserToManySchemaPropertyFilter>;
  /** Some related `schemaPropertiesByByConnection` exist. */
  schemaPropertiesByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemataByApplicationOwnerConnection` relation. */
  schemataByApplicationOwnerConnection?: InputMaybe<UserToManySchemaFilter>;
  /** Some related `schemataByApplicationOwnerConnection` exist. */
  schemataByApplicationOwnerConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemataByByConnection` relation. */
  schemataByByConnection?: InputMaybe<UserToManySchemaFilter>;
  /** Some related `schemataByByConnection` exist. */
  schemataByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `showhidden` field. */
  showhidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tokenExp` field. */
  tokenExp?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `twoFaType` field. */
  twoFaType?: InputMaybe<TwoFaTypesFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<UserTypesFilter>;
  /** Filter by the object’s `um` field. */
  um?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userGroupByDefaultEditorgroup` relation. */
  userGroupByDefaultEditorgroup?: InputMaybe<UserGroupFilter>;
  /** A related `userGroupByDefaultEditorgroup` exists. */
  userGroupByDefaultEditorgroupExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userGroupByDefaultReadergroup` relation. */
  userGroupByDefaultReadergroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupByDefaultUsergroup` relation. */
  userGroupByDefaultUsergroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupsByByConnection` relation. */
  userGroupsByByConnection?: InputMaybe<UserToManyUserGroupFilter>;
  /** Some related `userGroupsByByConnection` exist. */
  userGroupsByByConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userProfilesConnection` relation. */
  userProfilesConnection?: InputMaybe<UserToManyUserProfileFilter>;
  /** Some related `userProfilesConnection` exist. */
  userProfilesConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usersToGroupsConnection` relation. */
  usersToGroupsConnection?: InputMaybe<UserToManyUsersToGroupFilter>;
  /** Some related `usersToGroupsConnection` exist. */
  usersToGroupsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usersToObjectsConnection` relation. */
  usersToObjectsConnection?: InputMaybe<UserToManyUsersToObjectFilter>;
  /** Some related `usersToObjectsConnection` exist. */
  usersToObjectsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** User Groups represent groups of Users. */
export type UserGroup = Node & {
  __typename?: 'UserGroup';
  /** User last updated the Object. */
  by?: Maybe<Scalars['UUID']['output']>;
  /** User Group creation timestamp. */
  createdAt: Scalars['Datetime']['output'];
  /** User Group description. */
  description?: Maybe<Scalars['String']['output']>;
  /** User Group name.  */
  groupName: Scalars['String']['output'];
  /** User Group unique ID. */
  id: Scalars['UUID']['output'];
  /** Indicates if the User Group is a system group.  */
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Object`. */
  objectsByEditorgroup: Array<Object>;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByEditorgroupConnection: ObjectsConnection;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByReadergroup: Array<Object>;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByReadergroupConnection: ObjectsConnection;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByUsergroup: Array<Object>;
  /** Reads and enables pagination through a set of `Object`. */
  objectsByUsergroupConnection: ObjectsConnection;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByEditorgroup: Array<Schema>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByEditorgroupConnection: SchemataConnection;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByReadergroup: Array<Schema>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByReadergroupConnection: SchemataConnection;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByUsergroup: Array<Schema>;
  /** Reads and enables pagination through a set of `Schema`. */
  schemataByUsergroupConnection: SchemataConnection;
  /** User Group last update timestamp. */
  updatedAt: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `UserGroup`. */
  userByBy?: Maybe<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultEditorgroup: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultEditorgroupConnection: UsersConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultReadergroup: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultReadergroupConnection: UsersConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultUsergroup: Array<User>;
  /** Reads and enables pagination through a set of `User`. */
  usersByDefaultUsergroupConnection: UsersConnection;
  /** Reads and enables pagination through a set of `UsersToGroup`. */
  usersToGroups: Array<UsersToGroup>;
  /** Reads and enables pagination through a set of `UsersToGroup`. */
  usersToGroupsConnection: UsersToGroupsConnection;
};


/** User Groups represent groups of Users. */
export type UserGroupObjectsByEditorgroupArgs = {
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupObjectsByEditorgroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupObjectsByReadergroupArgs = {
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupObjectsByReadergroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupObjectsByUsergroupArgs = {
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupObjectsByUsergroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectCondition>;
  filter?: InputMaybe<ObjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
  sort?: InputMaybe<Array<ObjectsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupSchemataByEditorgroupArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupSchemataByEditorgroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupSchemataByReadergroupArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupSchemataByReadergroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupSchemataByUsergroupArgs = {
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupSchemataByUsergroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SchemaCondition>;
  filter?: InputMaybe<SchemaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
  sort?: InputMaybe<Array<SchemasSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersByDefaultEditorgroupArgs = {
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersByDefaultEditorgroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersByDefaultReadergroupArgs = {
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersByDefaultReadergroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersByDefaultUsergroupArgs = {
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersByDefaultUsergroupConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  sort?: InputMaybe<Array<UsersSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersToGroupsArgs = {
  condition?: InputMaybe<UsersToGroupCondition>;
  filter?: InputMaybe<UsersToGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
  sort?: InputMaybe<Array<UsersToGroupsSort>>;
};


/** User Groups represent groups of Users. */
export type UserGroupUsersToGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UsersToGroupCondition>;
  filter?: InputMaybe<UsersToGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersToGroupsOrderBy>>;
  sort?: InputMaybe<Array<UsersToGroupsSort>>;
};

/**
 * A condition to be used against `UserGroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserGroupCondition = {
  /** Checks for equality with the object’s `by` field. */
  by?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `groupName` field. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `isSystem` field. */
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `UserGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserGroupFilter>>;
  /** Filter by the object’s `by` field. */
  by?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupName` field. */
  groupName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isSystem` field. */
  isSystem?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `objectsByEditorgroupConnection` relation. */
  objectsByEditorgroupConnection?: InputMaybe<UserGroupToManyObjectFilter>;
  /** Some related `objectsByEditorgroupConnection` exist. */
  objectsByEditorgroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectsByReadergroupConnection` relation. */
  objectsByReadergroupConnection?: InputMaybe<UserGroupToManyObjectFilter>;
  /** Some related `objectsByReadergroupConnection` exist. */
  objectsByReadergroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `objectsByUsergroupConnection` relation. */
  objectsByUsergroupConnection?: InputMaybe<UserGroupToManyObjectFilter>;
  /** Some related `objectsByUsergroupConnection` exist. */
  objectsByUsergroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserGroupFilter>>;
  /** Filter by the object’s `schemataByEditorgroupConnection` relation. */
  schemataByEditorgroupConnection?: InputMaybe<UserGroupToManySchemaFilter>;
  /** Some related `schemataByEditorgroupConnection` exist. */
  schemataByEditorgroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemataByReadergroupConnection` relation. */
  schemataByReadergroupConnection?: InputMaybe<UserGroupToManySchemaFilter>;
  /** Some related `schemataByReadergroupConnection` exist. */
  schemataByReadergroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `schemataByUsergroupConnection` relation. */
  schemataByUsergroupConnection?: InputMaybe<UserGroupToManySchemaFilter>;
  /** Some related `schemataByUsergroupConnection` exist. */
  schemataByUsergroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userByBy` relation. */
  userByBy?: InputMaybe<UserFilter>;
  /** A related `userByBy` exists. */
  userByByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usersByDefaultEditorgroupConnection` relation. */
  usersByDefaultEditorgroupConnection?: InputMaybe<UserGroupToManyUserFilter>;
  /** Some related `usersByDefaultEditorgroupConnection` exist. */
  usersByDefaultEditorgroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usersByDefaultReadergroupConnection` relation. */
  usersByDefaultReadergroupConnection?: InputMaybe<UserGroupToManyUserFilter>;
  /** Some related `usersByDefaultReadergroupConnection` exist. */
  usersByDefaultReadergroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usersByDefaultUsergroupConnection` relation. */
  usersByDefaultUsergroupConnection?: InputMaybe<UserGroupToManyUserFilter>;
  /** Some related `usersByDefaultUsergroupConnection` exist. */
  usersByDefaultUsergroupConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `usersToGroupsConnection` relation. */
  usersToGroupsConnection?: InputMaybe<UserGroupToManyUsersToGroupFilter>;
  /** Some related `usersToGroupsConnection` exist. */
  usersToGroupsConnectionExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `UserGroup` */
export type UserGroupInput = {
  /** User Group description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** User Group name.  */
  groupName: Scalars['String']['input'];
  /** User Group unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Indicates if the User Group is a system group.  */
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `UserGroup`. Fields that are set will be updated. */
export type UserGroupPatch = {
  /** User Group description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** User Group name.  */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** User Group unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Indicates if the User Group is a system group.  */
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `Object` object types. All fields are combined with a logical ‘and.’ */
export type UserGroupToManyObjectFilter = {
  /** Every related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectFilter>;
  /** No related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectFilter>;
  /** Some related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectFilter>;
};

/** A filter to be used against many `Schema` object types. All fields are combined with a logical ‘and.’ */
export type UserGroupToManySchemaFilter = {
  /** Every related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaFilter>;
  /** No related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaFilter>;
  /** Some related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaFilter>;
};

/** A filter to be used against many `User` object types. All fields are combined with a logical ‘and.’ */
export type UserGroupToManyUserFilter = {
  /** Every related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserFilter>;
  /** No related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserFilter>;
  /** Some related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserFilter>;
};

/** A filter to be used against many `UsersToGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserGroupToManyUsersToGroupFilter = {
  /** Every related `UsersToGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UsersToGroupFilter>;
  /** No related `UsersToGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UsersToGroupFilter>;
  /** Some related `UsersToGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UsersToGroupFilter>;
};

/** A connection to a list of `UserGroup` values. */
export type UserGroupsConnection = {
  __typename?: 'UserGroupsConnection';
  /** A list of edges which contains the `UserGroup` and cursor to aid in pagination. */
  edges: Array<UserGroupsEdge>;
  /** A list of `UserGroup` objects. */
  nodes: Array<Maybe<UserGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserGroup` edge in the connection. */
export type UserGroupsEdge = {
  __typename?: 'UserGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserGroup` at the end of the edge. */
  node?: Maybe<UserGroup>;
};

/** Methods to use when ordering `UserGroup`. */
export enum UserGroupsOrderBy {
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  GroupNameAsc = 'GROUP_NAME_ASC',
  GroupNameDesc = 'GROUP_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsSystemAsc = 'IS_SYSTEM_ASC',
  IsSystemDesc = 'IS_SYSTEM_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type UserGroupsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: UserGroupsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type UserGroupsSortBy = {
  field?: InputMaybe<UserGroupsSortableField>;
};

/** Sortable concrete fields for the `UserGroup` type. */
export enum UserGroupsSortableField {
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  Description = 'DESCRIPTION',
  GroupName = 'GROUP_NAME',
  Id = 'ID',
  IsSystem = 'IS_SYSTEM',
  UpdatedAt = 'UPDATED_AT'
}

/** An input for mutations affecting `User` */
export type UserInput = {
  /** Indicates if the User is activated. */
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEditorgroup?: InputMaybe<Scalars['UUID']['input']>;
  defaultReadergroup?: InputMaybe<Scalars['UUID']['input']>;
  defaultUsergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** User description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Administrative User's status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** User's login name (User name).  */
  login: Scalars['String']['input'];
  logonStatus?: InputMaybe<Scalars['String']['input']>;
  /** User email meta information. */
  mEmail?: InputMaybe<Scalars['String']['input']>;
  /** User ID in the external system meta information. */
  mExternalId?: InputMaybe<Scalars['JSON']['input']>;
  /** User icon (Media Object) meta information. */
  mIcon?: InputMaybe<Scalars['UUID']['input']>;
  /** User name meta information. */
  mName?: InputMaybe<Scalars['String']['input']>;
  /** User phone meta information. */
  mPhone?: InputMaybe<Scalars['String']['input']>;
  /** User picture (Media Object) meta information. */
  mPicture?: InputMaybe<Scalars['UUID']['input']>;
  mTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User password hash. */
  password: Scalars['String']['input'];
  passwordExpireAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Indicates if the User's password reset requested. */
  passwordReset?: InputMaybe<Scalars['Boolean']['input']>;
  showhidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Refresh token expiration in days.  */
  tokenExp?: InputMaybe<Scalars['BigInt']['input']>;
  twoFaType?: InputMaybe<TwoFaTypes>;
  /** User type (USER or APP) */
  type: UserTypes;
  um?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  /** Indicates if the User is activated. */
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEditorgroup?: InputMaybe<Scalars['UUID']['input']>;
  defaultReadergroup?: InputMaybe<Scalars['UUID']['input']>;
  defaultUsergroup?: InputMaybe<Scalars['UUID']['input']>;
  /** User description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Administrative User's status. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User unique ID. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** User's login name (User name).  */
  login?: InputMaybe<Scalars['String']['input']>;
  logonStatus?: InputMaybe<Scalars['String']['input']>;
  /** User email meta information. */
  mEmail?: InputMaybe<Scalars['String']['input']>;
  /** User ID in the external system meta information. */
  mExternalId?: InputMaybe<Scalars['JSON']['input']>;
  /** User icon (Media Object) meta information. */
  mIcon?: InputMaybe<Scalars['UUID']['input']>;
  /** User name meta information. */
  mName?: InputMaybe<Scalars['String']['input']>;
  /** User phone meta information. */
  mPhone?: InputMaybe<Scalars['String']['input']>;
  /** User picture (Media Object) meta information. */
  mPicture?: InputMaybe<Scalars['UUID']['input']>;
  mTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** User password hash. */
  password?: InputMaybe<Scalars['String']['input']>;
  passwordExpireAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Indicates if the User's password reset requested. */
  passwordReset?: InputMaybe<Scalars['Boolean']['input']>;
  showhidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Refresh token expiration in days.  */
  tokenExp?: InputMaybe<Scalars['BigInt']['input']>;
  twoFaType?: InputMaybe<TwoFaTypes>;
  um?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfile = Node & {
  __typename?: 'UserProfile';
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Object` that is related to this `UserProfile`. */
  object?: Maybe<Object>;
  objectId: Scalars['UUID']['output'];
  /** Reads a single `User` that is related to this `UserProfile`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserProfile` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserProfileCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UserProfile` object types. All fields are combined with a logical ‘and.’ */
export type UserProfileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserProfileFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserProfileFilter>;
  /** Filter by the object’s `object` relation. */
  object?: InputMaybe<ObjectFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserProfileFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `UserProfile` values. */
export type UserProfilesConnection = {
  __typename?: 'UserProfilesConnection';
  /** A list of edges which contains the `UserProfile` and cursor to aid in pagination. */
  edges: Array<UserProfilesEdge>;
  /** A list of `UserProfile` objects. */
  nodes: Array<Maybe<UserProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserProfile` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserProfile` edge in the connection. */
export type UserProfilesEdge = {
  __typename?: 'UserProfilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserProfile` at the end of the edge. */
  node?: Maybe<UserProfile>;
};

/** Methods to use when ordering `UserProfile`. */
export enum UserProfilesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type UserProfilesSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: UserProfilesSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type UserProfilesSortBy = {
  field?: InputMaybe<UserProfilesSortableField>;
};

/** Sortable concrete fields for the `UserProfile` type. */
export enum UserProfilesSortableField {
  Id = 'ID',
  ObjectId = 'OBJECT_ID',
  UserId = 'USER_ID'
}

/** A filter to be used against many `ControlExecution` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyControlExecutionFilter = {
  /** Every related `ControlExecution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ControlExecutionFilter>;
  /** No related `ControlExecution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ControlExecutionFilter>;
  /** Some related `ControlExecution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ControlExecutionFilter>;
};

/** A filter to be used against many `NotificationDelivery` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyNotificationDeliveryFilter = {
  /** Every related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationDeliveryFilter>;
  /** No related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationDeliveryFilter>;
  /** Some related `NotificationDelivery` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationDeliveryFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `Object` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyObjectFilter = {
  /** Every related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectFilter>;
  /** No related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectFilter>;
  /** Some related `Object` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectFilter>;
};

/** A filter to be used against many `ObjectPropertiesHistory` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyObjectPropertiesHistoryFilter = {
  /** Every related `ObjectPropertiesHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectPropertiesHistoryFilter>;
  /** No related `ObjectPropertiesHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectPropertiesHistoryFilter>;
  /** Some related `ObjectPropertiesHistory` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectPropertiesHistoryFilter>;
};

/** A filter to be used against many `ObjectProperty` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyObjectPropertyFilter = {
  /** Every related `ObjectProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ObjectPropertyFilter>;
  /** No related `ObjectProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ObjectPropertyFilter>;
  /** Some related `ObjectProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ObjectPropertyFilter>;
};

/** A filter to be used against many `SchemaControl` object types. All fields are combined with a logical ‘and.’ */
export type UserToManySchemaControlFilter = {
  /** Every related `SchemaControl` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaControlFilter>;
  /** No related `SchemaControl` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaControlFilter>;
  /** Some related `SchemaControl` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaControlFilter>;
};

/** A filter to be used against many `Schema` object types. All fields are combined with a logical ‘and.’ */
export type UserToManySchemaFilter = {
  /** Every related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaFilter>;
  /** No related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaFilter>;
  /** Some related `Schema` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaFilter>;
};

/** A filter to be used against many `SchemaProperty` object types. All fields are combined with a logical ‘and.’ */
export type UserToManySchemaPropertyFilter = {
  /** Every related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SchemaPropertyFilter>;
  /** No related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SchemaPropertyFilter>;
  /** Some related `SchemaProperty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SchemaPropertyFilter>;
};

/** A filter to be used against many `UserGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserGroupFilter = {
  /** Every related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserGroupFilter>;
  /** No related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserGroupFilter>;
  /** Some related `UserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserGroupFilter>;
};

/** A filter to be used against many `UserProfile` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserProfileFilter = {
  /** Every related `UserProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserProfileFilter>;
  /** No related `UserProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserProfileFilter>;
  /** Some related `UserProfile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserProfileFilter>;
};

/** A filter to be used against many `UsersToGroup` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUsersToGroupFilter = {
  /** Every related `UsersToGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UsersToGroupFilter>;
  /** No related `UsersToGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UsersToGroupFilter>;
  /** Some related `UsersToGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UsersToGroupFilter>;
};

/** A filter to be used against many `UsersToObject` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUsersToObjectFilter = {
  /** Every related `UsersToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UsersToObjectFilter>;
  /** No related `UsersToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UsersToObjectFilter>;
  /** Some related `UsersToObject` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UsersToObjectFilter>;
};

export enum UserTypes {
  App = 'APP',
  User = 'USER'
}

/** A filter to be used against UserTypes fields. All fields are combined with a logical ‘and.’ */
export type UserTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserTypes>>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  ActivatedAsc = 'ACTIVATED_ASC',
  ActivatedDesc = 'ACTIVATED_DESC',
  ByAsc = 'BY_ASC',
  ByDesc = 'BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DefaultEditorgroupAsc = 'DEFAULT_EDITORGROUP_ASC',
  DefaultEditorgroupDesc = 'DEFAULT_EDITORGROUP_DESC',
  DefaultReadergroupAsc = 'DEFAULT_READERGROUP_ASC',
  DefaultReadergroupDesc = 'DEFAULT_READERGROUP_DESC',
  DefaultUsergroupAsc = 'DEFAULT_USERGROUP_ASC',
  DefaultUsergroupDesc = 'DEFAULT_USERGROUP_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LoginAsc = 'LOGIN_ASC',
  LoginDesc = 'LOGIN_DESC',
  LogonStatusAsc = 'LOGON_STATUS_ASC',
  LogonStatusDesc = 'LOGON_STATUS_DESC',
  MEmailAsc = 'M_EMAIL_ASC',
  MEmailDesc = 'M_EMAIL_DESC',
  MExternalIdAsc = 'M_EXTERNAL_ID_ASC',
  MExternalIdDesc = 'M_EXTERNAL_ID_DESC',
  MIconAsc = 'M_ICON_ASC',
  MIconDesc = 'M_ICON_DESC',
  MNameAsc = 'M_NAME_ASC',
  MNameDesc = 'M_NAME_DESC',
  MPhoneAsc = 'M_PHONE_ASC',
  MPhoneDesc = 'M_PHONE_DESC',
  MPictureAsc = 'M_PICTURE_ASC',
  MPictureDesc = 'M_PICTURE_DESC',
  MTagsAsc = 'M_TAGS_ASC',
  MTagsDesc = 'M_TAGS_DESC',
  Natural = 'NATURAL',
  PasswordAsc = 'PASSWORD_ASC',
  PasswordDesc = 'PASSWORD_DESC',
  PasswordExpireAtAsc = 'PASSWORD_EXPIRE_AT_ASC',
  PasswordExpireAtDesc = 'PASSWORD_EXPIRE_AT_DESC',
  PasswordResetAsc = 'PASSWORD_RESET_ASC',
  PasswordResetDesc = 'PASSWORD_RESET_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShowhiddenAsc = 'SHOWHIDDEN_ASC',
  ShowhiddenDesc = 'SHOWHIDDEN_DESC',
  TokenExpAsc = 'TOKEN_EXP_ASC',
  TokenExpDesc = 'TOKEN_EXP_DESC',
  TwoFaTypeAsc = 'TWO_FA_TYPE_ASC',
  TwoFaTypeDesc = 'TWO_FA_TYPE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UmAsc = 'UM_ASC',
  UmDesc = 'UM_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type UsersSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: UsersSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type UsersSortBy = {
  field?: InputMaybe<UsersSortableField>;
};

/** Sortable concrete fields for the `User` type. */
export enum UsersSortableField {
  Activated = 'ACTIVATED',
  By = 'BY',
  CreatedAt = 'CREATED_AT',
  DefaultEditorgroup = 'DEFAULT_EDITORGROUP',
  DefaultReadergroup = 'DEFAULT_READERGROUP',
  DefaultUsergroup = 'DEFAULT_USERGROUP',
  Description = 'DESCRIPTION',
  Enabled = 'ENABLED',
  Id = 'ID',
  Login = 'LOGIN',
  LogonStatus = 'LOGON_STATUS',
  MEmail = 'M_EMAIL',
  MExternalId = 'M_EXTERNAL_ID',
  MIcon = 'M_ICON',
  MName = 'M_NAME',
  MPhone = 'M_PHONE',
  MPicture = 'M_PICTURE',
  MTags = 'M_TAGS',
  Password = 'PASSWORD',
  PasswordExpireAt = 'PASSWORD_EXPIRE_AT',
  PasswordReset = 'PASSWORD_RESET',
  Showhidden = 'SHOWHIDDEN',
  TokenExp = 'TOKEN_EXP',
  TwoFaType = 'TWO_FA_TYPE',
  Type = 'TYPE',
  Um = 'UM',
  UpdatedAt = 'UPDATED_AT'
}

/** Users and Groups relation.  */
export type UsersToGroup = Node & {
  __typename?: 'UsersToGroup';
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `UsersToGroup`. */
  user?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `UsersToGroup`. */
  userGroup?: Maybe<UserGroup>;
  /** User Group unique ID. */
  userGroupId: Scalars['UUID']['output'];
  /** User unique ID. */
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UsersToGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UsersToGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userGroupId` field. */
  userGroupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UsersToGroup` object types. All fields are combined with a logical ‘and.’ */
export type UsersToGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UsersToGroupFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UsersToGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UsersToGroupFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userGroup` relation. */
  userGroup?: InputMaybe<UserGroupFilter>;
  /** Filter by the object’s `userGroupId` field. */
  userGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UsersToGroup` */
export type UsersToGroupInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** User Group unique ID. */
  userGroupId: Scalars['UUID']['input'];
  /** User unique ID. */
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `UsersToGroup`. Fields that are set will be updated. */
export type UsersToGroupPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** User Group unique ID. */
  userGroupId?: InputMaybe<Scalars['UUID']['input']>;
  /** User unique ID. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `UsersToGroup` values. */
export type UsersToGroupsConnection = {
  __typename?: 'UsersToGroupsConnection';
  /** A list of edges which contains the `UsersToGroup` and cursor to aid in pagination. */
  edges: Array<UsersToGroupsEdge>;
  /** A list of `UsersToGroup` objects. */
  nodes: Array<Maybe<UsersToGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UsersToGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UsersToGroup` edge in the connection. */
export type UsersToGroupsEdge = {
  __typename?: 'UsersToGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UsersToGroup` at the end of the edge. */
  node?: Maybe<UsersToGroup>;
};

/** Methods to use when ordering `UsersToGroup`. */
export enum UsersToGroupsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserGroupIdAsc = 'USER_GROUP_ID_ASC',
  UserGroupIdDesc = 'USER_GROUP_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type UsersToGroupsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: UsersToGroupsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type UsersToGroupsSortBy = {
  field?: InputMaybe<UsersToGroupsSortableField>;
};

/** Sortable concrete fields for the `UsersToGroup` type. */
export enum UsersToGroupsSortableField {
  Id = 'ID',
  UserGroupId = 'USER_GROUP_ID',
  UserId = 'USER_ID'
}

/**
 * Users and Objects relation.
 * Deprecated?
 */
export type UsersToObject = Node & {
  __typename?: 'UsersToObject';
  id: Scalars['UUID']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Object` that is related to this `UsersToObject`. */
  object?: Maybe<Object>;
  /** Object unique ID. */
  objectId: Scalars['UUID']['output'];
  /** Reads a single `User` that is related to this `UsersToObject`. */
  user?: Maybe<User>;
  /** User unique ID. */
  userId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UsersToObject` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UsersToObjectCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UsersToObject` object types. All fields are combined with a logical ‘and.’ */
export type UsersToObjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UsersToObjectFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UsersToObjectFilter>;
  /** Filter by the object’s `object` relation. */
  object?: InputMaybe<ObjectFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UsersToObjectFilter>>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UsersToObject` */
export type UsersToObjectInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Object unique ID. */
  objectId: Scalars['UUID']['input'];
  /** User unique ID. */
  userId: Scalars['UUID']['input'];
};

/** Represents an update to a `UsersToObject`. Fields that are set will be updated. */
export type UsersToObjectPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Object unique ID. */
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  /** User unique ID. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `UsersToObject` values. */
export type UsersToObjectsConnection = {
  __typename?: 'UsersToObjectsConnection';
  /** A list of edges which contains the `UsersToObject` and cursor to aid in pagination. */
  edges: Array<UsersToObjectsEdge>;
  /** A list of `UsersToObject` objects. */
  nodes: Array<Maybe<UsersToObject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UsersToObject` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UsersToObject` edge in the connection. */
export type UsersToObjectsEdge = {
  __typename?: 'UsersToObjectsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UsersToObject` at the end of the edge. */
  node?: Maybe<UsersToObject>;
};

/** Methods to use when ordering `UsersToObject`. */
export enum UsersToObjectsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type UsersToObjectsSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: UsersToObjectsSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type UsersToObjectsSortBy = {
  field?: InputMaybe<UsersToObjectsSortableField>;
};

/** Sortable concrete fields for the `UsersToObject` type. */
export enum UsersToObjectsSortableField {
  Id = 'ID',
  ObjectId = 'OBJECT_ID',
  UserId = 'USER_ID'
}

export type Version = {
  __typename?: 'Version';
  long?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type ViewSearch = {
  __typename?: 'ViewSearch';
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stringId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ViewSearch` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ViewSearchCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `stringId` field. */
  stringId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ViewSearch` object types. All fields are combined with a logical ‘and.’ */
export type ViewSearchFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ViewSearchFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ViewSearchFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ViewSearchFilter>>;
  /** Filter by the object’s `stringId` field. */
  stringId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** Specifies a sort for the `Object` type - what should we sort by, should it be ascending or descending, and how should we handle nulls? */
export type ViewSearchSort = {
  ascending?: Scalars['Boolean']['input'];
  nulls?: SortNulls;
  sortBy: ViewSearchSortBy;
};

/** The specifier of what we should sort by.  Exactly one of these values must be specified and non-null (this will use `@oneOf` [when that feature is merged into GraphQL](https://github.com/graphql/graphql-spec/pull/825)). */
export type ViewSearchSortBy = {
  field?: InputMaybe<ViewSearchSortableField>;
};

/** Sortable concrete fields for the `ViewSearch` type. */
export enum ViewSearchSortableField {
  Id = 'ID',
  Name = 'NAME',
  StringId = 'STRING_ID',
  Type = 'TYPE'
}

/** A connection to a list of `ViewSearch` values. */
export type ViewSearchesConnection = {
  __typename?: 'ViewSearchesConnection';
  /** A list of edges which contains the `ViewSearch` and cursor to aid in pagination. */
  edges: Array<ViewSearchesEdge>;
  /** A list of `ViewSearch` objects. */
  nodes: Array<Maybe<ViewSearch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ViewSearch` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ViewSearch` edge in the connection. */
export type ViewSearchesEdge = {
  __typename?: 'ViewSearchesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ViewSearch` at the end of the edge. */
  node?: Maybe<ViewSearch>;
};

/** Methods to use when ordering `ViewSearch`. */
export enum ViewSearchesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  StringIdAsc = 'STRING_ID_ASC',
  StringIdDesc = 'STRING_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

/** All input for the create mn`Object` mutation. */
export type MnCreateObjectInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Object` to be created by this mutation. */
  mnObject?: InputMaybe<Array<ObjectInput>>;
};

/** The output of our many create `Object` mutation. */
export type MnCreateObjectPayload = {
  __typename?: 'mnCreateObjectPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Object` that was created by this mutation. */
  object?: Maybe<Object>;
  /** An edge for our `Object`. May be used by Relay 1. */
  objectEdge?: Maybe<ObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our many create `Object` mutation. */
export type MnCreateObjectPayloadObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
};

/** All input for the create mn`Schema` mutation. */
export type MnCreateSchemaInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Schema` to be created by this mutation. */
  mnSchema?: InputMaybe<Array<SchemaInput>>;
};

/** The output of our many create `Schema` mutation. */
export type MnCreateSchemaPayload = {
  __typename?: 'mnCreateSchemaPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Schema` that was created by this mutation. */
  schema?: Maybe<Schema>;
  /** An edge for our `Schema`. May be used by Relay 1. */
  schemaEdge?: Maybe<SchemataEdge>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our many create `Schema` mutation. */
export type MnCreateSchemaPayloadSchemaEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
};

/** All input for the create mn`User` mutation. */
export type MnCreateUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `User` to be created by this mutation. */
  mnUser?: InputMaybe<Array<UserInput>>;
};

/** The output of our many create `User` mutation. */
export type MnCreateUserPayload = {
  __typename?: 'mnCreateUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
};


/** The output of our many create `User` mutation. */
export type MnCreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the delete `mnDeleteObject` mutation. */
export type MnDeleteObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Object` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<ObjectPatch>>;
};

/** The output of our delete mn `Object` mutation. */
export type MnDeleteObjectPayload = {
  __typename?: 'mnDeleteObjectPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedObjectNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Object` that was deleted by this mutation. */
  object?: Maybe<Object>;
  /** An edge for our `Object`. May be used by Relay 1. */
  objectEdge?: Maybe<ObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our delete mn `Object` mutation. */
export type MnDeleteObjectPayloadObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
};

/** All input for the delete `mnDeleteSchema` mutation. */
export type MnDeleteSchemaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Schema` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<SchemaPatch>>;
};

/** The output of our delete mn `Schema` mutation. */
export type MnDeleteSchemaPayload = {
  __typename?: 'mnDeleteSchemaPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSchemaNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Schema` that was deleted by this mutation. */
  schema?: Maybe<Schema>;
  /** An edge for our `Schema`. May be used by Relay 1. */
  schemaEdge?: Maybe<SchemataEdge>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our delete mn `Schema` mutation. */
export type MnDeleteSchemaPayloadSchemaEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
};

/** All input for the delete `mnDeleteUser` mutation. */
export type MnDeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `User` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<UserPatch>>;
};

/** The output of our delete mn `User` mutation. */
export type MnDeleteUserPayload = {
  __typename?: 'mnDeleteUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
};


/** The output of our delete mn `User` mutation. */
export type MnDeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the update `mnUpdateObject` mutation. */
export type MnUpdateObjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Object` to be updated. */
  mnPatch?: InputMaybe<Array<ObjectPatch>>;
};

/** The output of our update mn `Object` mutation. */
export type MnUpdateObjectPayload = {
  __typename?: 'mnUpdateObjectPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Object` that was updated by this mutation. */
  object?: Maybe<Object>;
  /** An edge for our `Object`. May be used by Relay 1. */
  objectEdge?: Maybe<ObjectsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Schema` that is related to this `Object`. */
  schema?: Maybe<Schema>;
  /** Reads a single `User` that is related to this `Object`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Object`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our update mn `Object` mutation. */
export type MnUpdateObjectPayloadObjectEdgeArgs = {
  orderBy?: InputMaybe<Array<ObjectsOrderBy>>;
};

/** All input for the update `mnUpdateSchema` mutation. */
export type MnUpdateSchemaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `Schema` to be updated. */
  mnPatch?: InputMaybe<Array<SchemaPatch>>;
};

/** The output of our update mn `Schema` mutation. */
export type MnUpdateSchemaPayload = {
  __typename?: 'mnUpdateSchemaPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Schema` that is related to this `Schema`. */
  parentSchema?: Maybe<Schema>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Schema` that was updated by this mutation. */
  schema?: Maybe<Schema>;
  /** An edge for our `Schema`. May be used by Relay 1. */
  schemaEdge?: Maybe<SchemataEdge>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByApplicationOwner?: Maybe<User>;
  /** Reads a single `User` that is related to this `Schema`. */
  userByBy?: Maybe<User>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `Schema`. */
  userGroupByUsergroup?: Maybe<UserGroup>;
};


/** The output of our update mn `Schema` mutation. */
export type MnUpdateSchemaPayloadSchemaEdgeArgs = {
  orderBy?: InputMaybe<Array<SchemataOrderBy>>;
};

/** All input for the update `mnUpdateUser` mutation. */
export type MnUpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The one or many `User` to be updated. */
  mnPatch?: InputMaybe<Array<UserPatch>>;
};

/** The output of our update mn `User` mutation. */
export type MnUpdateUserPayload = {
  __typename?: 'mnUpdateUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultEditorgroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultReadergroup?: Maybe<UserGroup>;
  /** Reads a single `UserGroup` that is related to this `User`. */
  userGroupByDefaultUsergroup?: Maybe<UserGroup>;
};


/** The output of our update mn `User` mutation. */
export type MnUpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type GetTimezoneShiftQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimezoneShiftQuery = { __typename?: 'Query', getTimezoneShift?: number | null, getTimezone?: string | null, getTime?: string | null };

export type GetVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVersionQuery = { __typename?: 'Query', getVersion?: { __typename?: 'Version', short?: string | null, long?: string | null } | null };

export type GetTimezoneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimezoneQuery = { __typename?: 'Query', getTimezone?: string | null };

export type GetDashboardsWithoutCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardsWithoutCollectionsQuery = { __typename?: 'Query', dashboards?: Array<(
    { __typename?: 'Object', id: any, name: string, schemaTags?: Array<string | null> | null, objectsToObjectsByObject1Id: Array<{ __typename?: 'ObjectsToObject', id: any, object2?: { __typename?: 'Object', id: any, name: string, schemaTags?: Array<string | null> | null } | null }> }
    & { ' $fragmentRefs'?: { 'LayoutObjectFragment': LayoutObjectFragment;'ObjectPartsFragment': ObjectPartsFragment } }
  )> | null };

export type GetWidgetInfoQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWidgetInfoQuery = { __typename?: 'Query', schemata?: Array<{ __typename?: 'Schema', id: any, objectsCount?: number | null, description?: string | null, mPicture?: string | null }> | null };

export type SelectedSchemaQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SelectedSchemaQuery = { __typename?: 'Query', schema?: { __typename?: 'Schema', type: SchemaTypes, mTags?: Array<string | null> | null } | null };

export type UserAppsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UserAppsQuery = { __typename?: 'Query', user?: { __typename?: 'User', userProfiles: Array<{ __typename?: 'UserProfile', object?: { __typename?: 'Object', id: any, enabled: boolean, name?: any | null, icon?: any | null, url?: any | null } | null }> } | null };

export type LoadGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LoadGroupsQuery = { __typename?: 'Query', userGroups?: Array<{ __typename?: 'UserGroup', id: any, isSystem?: boolean | null, groupName: string, description?: string | null }> | null };

export type UpdateMutationVariables = Exact<{
  input: UpdateObjectInput;
}>;


export type UpdateMutation = { __typename?: 'Mutation', updateObject?: { __typename?: 'UpdateObjectPayload', clientMutationId?: string | null } | null };

export type GetControlsListQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetControlsListQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, schema?: { __typename?: 'Schema', id: any, schemaControls: Array<{ __typename?: 'SchemaControl', id: any, rpc: string, argument: string, description?: string | null }> } | null } | null };

export type GetObjectPropertyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetObjectPropertyQuery = { __typename?: 'Query', objectProperty?: { __typename?: 'ObjectProperty', id: any, spec?: { __typename?: 'SchemaProperty', units?: string | null, description?: string | null } | null } | null };

export type SelectedSchemaTypeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SelectedSchemaTypeQuery = { __typename?: 'Query', schema?: { __typename?: 'Schema', id: any, type: SchemaTypes, mTags?: Array<string | null> | null } | null };

export type ListenMonitoringItemsListSubscriptionVariables = Exact<{
  objectId: Scalars['UUID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ListenMonitoringItemsListSubscription = { __typename?: 'Subscription', Objects?: { __typename?: 'ListenObjectsPayload', event?: string | null, relatedNodeId?: string | null, relatedNode?: { __typename: 'ControlExecution' } | { __typename: 'Notification' } | { __typename: 'NotificationDelivery' } | { __typename: 'Object' } | { __typename: 'ObjectPropertiesHistory' } | { __typename: 'ObjectProperty', objectId: any, id: any, key?: string | null, type?: string | null, typeId: any, linkedPropertyId?: any | null, updatedAt?: any | null, groupName: string, property: string, value?: any | null, userByBy?: { __typename?: 'User', login: string, mName?: string | null } | null } | { __typename: 'ObjectsToObject', id: any, object2?: { __typename?: 'Object', id: any, name: string, hardLinked?: boolean | null, objectProperties: Array<{ __typename?: 'ObjectProperty', id: any, key?: string | null, type?: string | null, typeId: any, linkedPropertyId?: any | null, updatedAt?: any | null, groupName: string, property: string, value?: any | null, userByBy?: { __typename?: 'User', login: string, mName?: string | null } | null }> } | null } | { __typename: 'PropertyType' } | { __typename: 'Query' } | { __typename: 'Schema' } | { __typename: 'SchemaControl' } | { __typename: 'SchemaProperty' } | { __typename: 'Translation' } | { __typename: 'User' } | { __typename: 'UserGroup' } | { __typename: 'UserProfile' } | { __typename: 'UsersToGroup' } | { __typename: 'UsersToObject' } | null } | null };

export type GetMonitorObjectWithoutFragmentsQueryVariables = Exact<{
  objectId: Scalars['UUID']['input'];
}>;


export type GetMonitorObjectWithoutFragmentsQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, name: string, schemaTags?: Array<string | null> | null, objectProperties: Array<{ __typename: 'ObjectProperty', groupName: string, property: string, value?: any | null, key?: string | null, id: any, linkedPropertyId?: any | null, updatedAt?: any | null, spec?: { __typename: 'SchemaProperty', id: any, hidden: boolean, units?: string | null, key?: string | null, valueSet?: any | null, valueRange?: any | null, description?: string | null, defaultValue?: any | null, type?: { __typename: 'PropertyType', id: any, name: string } | null } | null, userByBy?: { __typename: 'User', id: any, login: string } | null }>, objectsToObjectsByObject1Id: Array<{ __typename?: 'ObjectsToObject', id: any, object2?: (
        { __typename?: 'Object', id: any, name: string, muted?: boolean | null, description?: string | null, schemaTags?: Array<string | null> | null, schemaType?: string | null, enabled: boolean, objectProperties: Array<{ __typename?: 'ObjectProperty', id: any, groupName: string, property: string, linkedPropertyId?: any | null, value?: any | null, key?: string | null, updatedAt?: any | null, userByBy?: { __typename?: 'User', id: any, login: string } | null }> }
        & { ' $fragmentRefs'?: { 'AccessGroupsFragmentFragment': AccessGroupsFragmentFragment } }
      ) | null }> } | null };

export type LoadSchemaPropertiesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LoadSchemaPropertiesQuery = { __typename?: 'Query', schema?: { __typename?: 'Schema', schemaProperties: Array<{ __typename?: 'SchemaProperty', id: any, groupName: string, property: string, description?: string | null }> } | null };

export type ObjectsSubscriptionVariables = Exact<{
  objId?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type ObjectsSubscription = { __typename?: 'Subscription', Objects?: { __typename?: 'ListenObjectsPayload', event?: string | null, relatedNodeId?: string | null, relatedNode?: { __typename?: 'ControlExecution' } | { __typename?: 'Notification' } | { __typename?: 'NotificationDelivery' } | { __typename?: 'Object', id: any, name: string } | { __typename?: 'ObjectPropertiesHistory' } | { __typename?: 'ObjectProperty', linkedPropertyId?: any | null, id: any, groupName: string, property: string, value?: any | null, key?: string | null } | { __typename?: 'ObjectsToObject', id: any, object1Id: any, object2Id: any } | { __typename?: 'PropertyType' } | { __typename?: 'Query' } | { __typename?: 'Schema' } | { __typename?: 'SchemaControl' } | { __typename?: 'SchemaProperty' } | { __typename?: 'Translation' } | { __typename?: 'User' } | { __typename?: 'UserGroup' } | { __typename?: 'UserProfile' } | { __typename?: 'UsersToGroup' } | { __typename?: 'UsersToObject' } | null } | null };

export type CreateDashboardMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>> | InputMaybe<PropertyByKeyInput>>;
  editorGroup?: InputMaybe<Scalars['UUID']['input']>;
  readerGroup?: InputMaybe<Scalars['UUID']['input']>;
  userGroup?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateDashboardMutation = { __typename?: 'Mutation', createObjectWithProperties?: { __typename?: 'CreateObjectWithPropertiesPayload', clientMutationId?: string | null, uuid?: any | null } | null };

export type GetFullCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullCollectionsQuery = { __typename?: 'Query', dashboards?: Array<{ __typename?: 'Object', id: any, enabled: boolean, name: string, objectsToObjectsByObject2Id: Array<{ __typename?: 'ObjectsToObject', id: any, object1?: (
        { __typename?: 'Object', id: any, name: string, enabled: boolean, schemaTags?: Array<string | null> | null }
        & { ' $fragmentRefs'?: { 'AccessGroupsFragmentFragment': AccessGroupsFragmentFragment } }
      ) | null }> }> | null };

export type GetDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardsQuery = { __typename?: 'Query', dashboards?: Array<{ __typename?: 'Object', id: any, name: string }> | null };

export type UpdateObjectWithPropertiesMutationVariables = Exact<{
  input: UpdateObjectWithPropertiesInput;
}>;


export type UpdateObjectWithPropertiesMutation = { __typename?: 'Mutation', updateObjectWithProperties?: { __typename?: 'UpdateObjectWithPropertiesPayload', clientMutationId?: string | null } | null };

export type GetCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsQuery = { __typename?: 'Query', collections?: Array<{ __typename?: 'Object', id: any, name: string, enabled: boolean, schemaTags?: Array<string | null> | null }> | null };

export type LinkObjectMutationVariables = Exact<{
  widgetId: Scalars['UUID']['input'];
  objectId: Scalars['UUID']['input'];
}>;


export type LinkObjectMutation = { __typename?: 'Mutation', createObjectsToObject?: { __typename?: 'CreateObjectsToObjectPayload', objectsToObject?: { __typename?: 'ObjectsToObject', id: any } | null } | null };

export type UnlinkObjectMutationVariables = Exact<{
  linkId: Scalars['UUID']['input'];
}>;


export type UnlinkObjectMutation = { __typename?: 'Mutation', deleteObjectsToObject?: { __typename?: 'DeleteObjectsToObjectPayload', clientMutationId?: string | null } | null };

export type GetControlsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ControlExecutionFilter>;
  orderBy?: InputMaybe<Array<ControlExecutionsOrderBy> | ControlExecutionsOrderBy>;
}>;


export type GetControlsQuery = { __typename?: 'Query', controlExecutionsConnection?: { __typename?: 'ControlExecutionsConnection', totalCount: number, edges: Array<{ __typename?: 'ControlExecutionsEdge', node?: { __typename?: 'ControlExecution', params: any, type?: ControlTypes | null, id: number, linkedControlId?: any | null, name: string, createdAt: any, objectId: any, ack?: boolean | null, done?: boolean | null, error?: string | null, callerId?: any | null, caller?: { __typename?: 'User', mName?: string | null } | null } | null }> } | null };

export type GetDashboardQueryVariables = Exact<{
  objId: Scalars['UUID']['input'];
}>;


export type GetDashboardQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, name: string, description?: string | null, schemaName?: string | null, enabled: boolean, muted?: boolean | null, readergroup: any, usergroup: any, editorgroup: any, collections: Array<{ __typename?: 'ObjectsToObject', id: any, target?: { __typename?: 'Object', name: string, id: any } | null }>, objectsToObjectsByObject1Id: Array<{ __typename?: 'ObjectsToObject', id: any, object2?: { __typename?: 'Object', id: any, name: string, description?: string | null, schemaType?: string | null } | null }>, objectProperties: Array<{ __typename?: 'ObjectProperty', groupName: string, property: string, key?: string | null, value?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null, description?: string | null, valueSet?: any | null, type?: { __typename?: 'PropertyType', name: string } | null } | null }> } | null };

export type GetDashboardNamesWithoutCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardNamesWithoutCollectionsQuery = { __typename?: 'Query', dashboards?: Array<{ __typename?: 'Object', id: any, name: string }> | null };

export type LoadAllGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadAllGroupsQuery = { __typename?: 'Query', userGroups?: Array<{ __typename?: 'UserGroup', id: any, isSystem?: boolean | null, groupName: string, description?: string | null }> | null };

export type ListConnectedObjectsQueryVariables = Exact<{
  widgetId: Scalars['UUID']['input'];
}>;


export type ListConnectedObjectsQuery = { __typename?: 'Query', objects?: Array<{ __typename?: 'Object', id: any, name: string, objectsToObjectsByObject1Id: Array<{ __typename?: 'ObjectsToObject', forced?: number | null, object2?: { __typename?: 'Object', id: any } | null }> }> | null };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { __typename?: 'Query', userGroups?: Array<{ __typename?: 'UserGroup', id: any, isSystem?: boolean | null, groupName: string, description?: string | null }> | null };

export type GetObjectsByIdOrNameQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetObjectsByIdOrNameQuery = { __typename?: 'Query', objects?: Array<{ __typename?: 'Object', value: any, title: string }> | null };

export type FetchNotificationByDeliveryIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FetchNotificationByDeliveryIdQuery = { __typename?: 'Query', notificationDelivery?: { __typename?: 'NotificationDelivery', id: any, message: string, notification?: { __typename?: 'Notification', id: any, object?: { __typename?: 'Object', id: any, objectsToObjectsByObject2Id: Array<{ __typename?: 'ObjectsToObject', id: any, object1?: { __typename?: 'Object', id: any, objectsToObjectsByObject2Id: Array<{ __typename?: 'ObjectsToObject', id: any, object1?: { __typename?: 'Object', id: any, schemaTags?: Array<string | null> | null } | null }> } | null }> } | null } | null } | null };

export type FetchNotificationsDeliveriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationDeliveryCondition>;
}>;


export type FetchNotificationsDeliveriesQuery = { __typename?: 'Query', notificationDeliveriesConnection?: { __typename?: 'NotificationDeliveriesConnection', nodes: Array<{ __typename?: 'NotificationDelivery', id: any, message: string, createdAt: any, user?: any | null, userLogin: string, notification?: { __typename?: 'Notification', id: any, message: string, createdAt: any, byName?: string | null, tags?: Array<string | null> | null, userByBy?: { __typename?: 'User', id: any, login: string, mName?: string | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null, endCursor?: any | null } } | null };

export type ListenNotificationsSubscriptionVariables = Exact<{
  deliveryUser?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
  deliveryPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ListenNotificationsSubscription = { __typename?: 'Subscription', Notifications?: { __typename?: 'ListenNotificationsPayload', event?: string | null, relatedNode?: { __typename?: 'ControlExecution' } | { __typename?: 'Notification' } | { __typename?: 'NotificationDelivery', id: any, message: string, createdAt: any, user?: any | null, userLogin: string, notification?: { __typename?: 'Notification', id: any, message: string, createdAt: any, byName?: string | null, tags?: Array<string | null> | null, userByBy?: { __typename?: 'User', id: any, login: string, mName?: string | null } | null } | null } | { __typename?: 'Object' } | { __typename?: 'ObjectPropertiesHistory' } | { __typename?: 'ObjectProperty' } | { __typename?: 'ObjectsToObject' } | { __typename?: 'PropertyType' } | { __typename?: 'Query' } | { __typename?: 'Schema' } | { __typename?: 'SchemaControl' } | { __typename?: 'SchemaProperty' } | { __typename?: 'Translation' } | { __typename?: 'User' } | { __typename?: 'UserGroup' } | { __typename?: 'UserProfile' } | { __typename?: 'UsersToGroup' } | { __typename?: 'UsersToObject' } | null } | null };

export type GetObjectNameByIdQueryVariables = Exact<{
  objectId: Scalars['UUID']['input'];
}>;


export type GetObjectNameByIdQuery = { __typename?: 'Query', object?: { __typename?: 'Object', name: string } | null };

export type GetHistoryUnitsQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetHistoryUnitsQuery = { __typename?: 'Query', objectProperties?: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null } | null }> | null };

export type GetSchemaQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchemaQuery = { __typename?: 'Query', schema?: { __typename?: 'Schema', id: any, name: string, schemaProperties: Array<{ __typename?: 'SchemaProperty', id: any, key?: string | null, groupName: string, property: string, description?: string | null, valueSet?: any | null, valueRange?: any | null, type?: { __typename?: 'PropertyType', name: string } | null }> } | null };

export type FetchHistoryListConnectionQueryVariables = Exact<{
  filter?: InputMaybe<ObjectPropertiesHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectPropertiesHistoriesOrderBy> | ObjectPropertiesHistoriesOrderBy>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FetchHistoryListConnectionQuery = { __typename?: 'Query', objectPropertiesHistoriesConnection?: { __typename?: 'ObjectPropertiesHistoriesConnection', totalCount: number, edges: Array<{ __typename?: 'ObjectPropertiesHistoriesEdge', node?: { __typename?: 'ObjectPropertiesHistory', property: string, propertyId?: any | null, id: number, value?: any | null, recordedAt: any, userByBy?: { __typename?: 'User', id: any, mName?: string | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null, endCursor?: any | null } } | null };

export type RemoveObjectMutationVariables = Exact<{
  input: MnDeleteObjectInput;
}>;


export type RemoveObjectMutation = { __typename?: 'Mutation', mnDeleteObject?: { __typename?: 'mnDeleteObjectPayload', clientMutationId?: string | null } | null };

export type UpdatePropertyMutationVariables = Exact<{
  input: UpdateObjectPropertyInput;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateObjectProperty?: { __typename?: 'UpdateObjectPropertyPayload', clientMutationId?: string | null } | null };

export type CreateReportMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>> | InputMaybe<PropertyByKeyInput>>;
  editorGroup?: InputMaybe<Scalars['UUID']['input']>;
  readerGroup?: InputMaybe<Scalars['UUID']['input']>;
  userGroup?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createObjectWithProperties?: { __typename?: 'CreateObjectWithPropertiesPayload', clientMutationId?: string | null, uuid?: any | null } | null };

export type ResolveObjectPermissionsMutationVariables = Exact<{
  input: ResolveObjectPermissionsInput;
}>;


export type ResolveObjectPermissionsMutation = { __typename?: 'Mutation', resolveObjectPermissions?: { __typename?: 'ResolveObjectPermissionsPayload', accessRight?: { __typename?: 'AccessRight', edit?: boolean | null } | null } | null };

export type GetWidgetsTransformedQueryVariables = Exact<{
  dashboardId: Scalars['UUID']['input'];
}>;


export type GetWidgetsTransformedQuery = { __typename?: 'Query', dashboard?: (
    { __typename?: 'Object', groups: Array<{ __typename?: 'ObjectsToObject', id: any, group?: (
        { __typename?: 'Object', widgets: Array<{ __typename?: 'ObjectsToObject', widget?: { __typename?: 'Object', id: any, name: string, description?: string | null, schemaTags?: Array<string | null> | null, enabled: boolean, userGroupByEditorgroup?: { __typename?: 'UserGroup', groupName: string } | null, userGroupByUsergroup?: { __typename?: 'UserGroup', groupName: string } | null, userGroupByReadergroup?: { __typename?: 'UserGroup', groupName: string } | null, objectProperties: Array<{ __typename?: 'ObjectProperty', linkedPropertyId?: any | null, id: any, groupName: string, property: string, value?: any | null, key?: string | null, updatedAt?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null, hidden: boolean, key?: string | null, valueSet?: any | null, valueRange?: any | null, description?: string | null, defaultValue?: any | null, type?: { __typename?: 'PropertyType', name: string } | null } | null, userByBy?: { __typename?: 'User', id: any, login: string } | null }> } | null }>, columnsCount: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null }>, bg: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null }>, bgImage: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null }>, type: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null }>, layouts: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null }> }
        & { ' $fragmentRefs'?: { 'ObjectPartsFragment': ObjectPartsFragment } }
      ) | null }> }
    & { ' $fragmentRefs'?: { 'LayoutObjectFragment': LayoutObjectFragment } }
  ) | null };

export type GetReportQueryVariables = Exact<{
  objId: Scalars['UUID']['input'];
}>;


export type GetReportQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, name: string, description?: string | null, readergroup: any, usergroup: any, editorgroup: any, objectProperties: Array<{ __typename?: 'ObjectProperty', groupName: string, property: string, key?: string | null, value?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null, description?: string | null, valueRange?: any | null, valueSet?: any | null, hidden: boolean, type?: { __typename?: 'PropertyType', name: string } | null } | null }> } | null };

export type GetFullReportQueryVariables = Exact<{
  objId: Scalars['UUID']['input'];
}>;


export type GetFullReportQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, name: string, description?: string | null, readergroup: any, usergroup: any, editorgroup: any, collections: Array<{ __typename?: 'ObjectsToObject', id: any, target?: { __typename?: 'Object', name: string, id: any } | null }>, objectsToObjectsByObject1Id: Array<{ __typename?: 'ObjectsToObject', id: any, object2?: { __typename?: 'Object', id: any, name: string, description?: string | null, schemaType?: string | null } | null }>, objectProperties: Array<{ __typename?: 'ObjectProperty', groupName: string, property: string, key?: string | null, value?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null, description?: string | null, valueRange?: any | null, valueSet?: any | null, hidden: boolean, type?: { __typename?: 'PropertyType', name: string } | null } | null }> } | null };

export type ReportPropsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportPropsQuery = { __typename?: 'Query', schemata?: Array<{ __typename?: 'Schema', name: string, objectsCount?: number | null, schemaProperties: Array<{ __typename?: 'SchemaProperty', defaultValue?: any | null, groupName: string, property: string, description?: string | null, hidden: boolean, valueSet?: any | null, key?: string | null, type?: { __typename?: 'PropertyType', name: string } | null }> }> | null };

export type GetReportsWithoutCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsWithoutCollectionsQuery = { __typename?: 'Query', reports?: Array<(
    { __typename?: 'Object', id: any, name: string, schemaTags?: Array<string | null> | null }
    & { ' $fragmentRefs'?: { 'AccessGroupsFragmentFragment': AccessGroupsFragmentFragment } }
  )> | null };

export type AccessGroupsFragmentFragment = { __typename?: 'Object', userGroupByEditorgroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, userGroupByUsergroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, userGroupByReadergroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null } & { ' $fragmentName'?: 'AccessGroupsFragmentFragment' };

export type LayoutObjectFragment = { __typename?: 'Object', layouts: Array<{ __typename?: 'ObjectProperty', id: any, value?: any | null }> } & { ' $fragmentName'?: 'LayoutObjectFragment' };

export type ObjectPartsFragment = { __typename?: 'Object', id: any, name: string, description?: string | null, schemaTags?: Array<string | null> | null, enabled: boolean, userGroupByEditorgroup?: { __typename?: 'UserGroup', groupName: string } | null, userGroupByUsergroup?: { __typename?: 'UserGroup', groupName: string } | null, userGroupByReadergroup?: { __typename?: 'UserGroup', groupName: string } | null, objectProperties: Array<{ __typename?: 'ObjectProperty', linkedPropertyId?: any | null, id: any, groupName: string, property: string, value?: any | null, key?: string | null, updatedAt?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null, hidden: boolean, key?: string | null, valueSet?: any | null, valueRange?: any | null, description?: string | null, defaultValue?: any | null, type?: { __typename?: 'PropertyType', name: string } | null } | null, userByBy?: { __typename?: 'User', id: any, login: string } | null }> } & { ' $fragmentName'?: 'ObjectPartsFragment' };

export type GetRpcQueryVariables = Exact<{
  deviceId: Scalars['UUID']['input'];
}>;


export type GetRpcQuery = { __typename?: 'Query', object?: { __typename?: 'Object', schema?: { __typename?: 'Schema', schemaControls: Array<{ __typename?: 'SchemaControl', rpc: string, description?: string | null, schemaId: any, isRpc?: boolean | null, valueRange?: any | null, valueSet?: any | null, defaultValue?: any | null, argument: string, typeSpec: string, typeId: string }> } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', clientMutationId?: string | null } | null };

export type CreateWidgetMutationVariables = Exact<{
  groupId: Scalars['UUID']['input'];
  widgetType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>> | InputMaybe<PropertyByKeyInput>>;
}>;


export type CreateWidgetMutation = { __typename?: 'Mutation', createObjectWithProperties?: { __typename?: 'CreateObjectWithPropertiesPayload', clientMutationId?: string | null, uuid?: any | null } | null };

export type GetWidgetQueryVariables = Exact<{
  objId: Scalars['UUID']['input'];
  groupNames?: InputMaybe<Array<ObjectPropertyFilter> | ObjectPropertyFilter>;
}>;


export type GetWidgetQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, name: string, description?: string | null, schemaName?: string | null, enabled: boolean, muted?: boolean | null, userGroupByEditorgroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, userGroupByUsergroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, userGroupByReadergroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, objectProperties: Array<{ __typename?: 'ObjectProperty', groupName: string, property: string, id: any, key?: string | null, value?: any | null, spec?: { __typename?: 'SchemaProperty', units?: string | null, key?: string | null, description?: string | null, hidden: boolean, valueSet?: any | null, type?: { __typename?: 'PropertyType', name: string } | null } | null }> } | null };

export type UpdateGroupMutationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  values?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>> | InputMaybe<PropertyByKeyInput>>;
}>;


export type UpdateGroupMutationMutation = { __typename?: 'Mutation', updateObjectWithProperties?: { __typename?: 'UpdateObjectWithPropertiesPayload', clientMutationId?: string | null } | null };

export type UpdateObjMutationVariables = Exact<{
  widgetId: Scalars['UUID']['input'];
  values?: InputMaybe<Array<InputMaybe<PropertyByKeyInput>> | InputMaybe<PropertyByKeyInput>>;
}>;


export type UpdateObjMutation = { __typename?: 'Mutation', updateObjectWithProperties?: { __typename?: 'UpdateObjectWithPropertiesPayload', clientMutationId?: string | null } | null };

export type CreateControlExecutionMutationVariables = Exact<{
  input: CreateControlExecutionInput;
}>;


export type CreateControlExecutionMutation = { __typename?: 'Mutation', createControlExecution?: { __typename?: 'CreateControlExecutionPayload', clientMutationId?: string | null, controlExecution?: { __typename?: 'ControlExecution', id: number, params: any, name: string, nodeId: string, linkedControlId?: any | null, objectId: any } | null } | null };

export type GetObjectQueryVariables = Exact<{
  objectId: Scalars['UUID']['input'];
}>;


export type GetObjectQuery = { __typename?: 'Query', object?: { __typename?: 'Object', id: any, name: string, description?: string | null, schemaTags?: Array<string | null> | null, schemaType?: string | null, enabled: boolean, muted?: boolean | null, schema?: { __typename?: 'Schema', id: any, name: string, mPicture?: string | null, mIcon?: string | null } | null, userGroupByEditorgroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, userGroupByUsergroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, userGroupByReadergroup?: { __typename?: 'UserGroup', id: any, groupName: string } | null, objectProperties: Array<{ __typename?: 'ObjectProperty', groupName: string, property: string, value?: any | null, key?: string | null, id: any, linkedPropertyId?: any | null, updatedAt?: any | null, spec?: { __typename?: 'SchemaProperty', id: any, hidden: boolean, units?: string | null, key?: string | null, valueSet?: any | null, valueRange?: any | null, description?: string | null, defaultValue?: any | null, type?: { __typename?: 'PropertyType', id: any, name: string } | null } | null, userByBy?: { __typename?: 'User', id: any, login: string } | null }>, objectsToObjectsByObject1Id: Array<{ __typename?: 'ObjectsToObject', id: any, object2?: (
        { __typename?: 'Object', id: any, name: string, muted?: boolean | null, description?: string | null, schemaTags?: Array<string | null> | null, schemaType?: string | null, enabled: boolean, objectProperties: Array<{ __typename?: 'ObjectProperty', id: any, groupName: string, property: string, linkedPropertyId?: any | null, value?: any | null, key?: string | null, updatedAt?: any | null, userByBy?: { __typename?: 'User', id: any, login: string } | null }> }
        & { ' $fragmentRefs'?: { 'AccessGroupsFragmentFragment': AccessGroupsFragmentFragment } }
      ) | null }>, objectsToObjectsByObject2Id: Array<{ __typename?: 'ObjectsToObject', id: any, object1?: (
        { __typename?: 'Object', id: any, name: string, description?: string | null, schemaTags?: Array<string | null> | null, schemaType?: string | null, enabled: boolean, objectProperties: Array<{ __typename?: 'ObjectProperty', id: any, groupName: string, property: string, linkedPropertyId?: any | null, value?: any | null, key?: string | null, updatedAt?: any | null, userByBy?: { __typename?: 'User', id: any, login: string } | null }> }
        & { ' $fragmentRefs'?: { 'AccessGroupsFragmentFragment': AccessGroupsFragmentFragment } }
      ) | null }> } | null };

export type GetObjectPropertiesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetObjectPropertiesByIdsQuery = { __typename?: 'Query', objectProperties?: Array<{ __typename?: 'ObjectProperty', id: any, key?: string | null, value?: any | null, property: string, groupName: string, type?: string | null, objectId: any, spec?: { __typename?: 'SchemaProperty', id: any, nodeId: string, description?: string | null, valueSet?: any | null, type?: { __typename?: 'PropertyType', name: string } | null } | null }> | null };

export const AccessGroupsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<AccessGroupsFragmentFragment, unknown>;
export const LayoutObjectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LayoutObject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"layouts"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Settings","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Layouts","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<LayoutObjectFragment, unknown>;
export const ObjectPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObjectParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]} as unknown as DocumentNode<ObjectPartsFragment, unknown>;
export const GetTimezoneShiftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTimezoneShift"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTimezoneShift"}},{"kind":"Field","name":{"kind":"Name","value":"getTimezone"}},{"kind":"Field","name":{"kind":"Name","value":"getTime"}}]}}]} as unknown as DocumentNode<GetTimezoneShiftQuery, GetTimezoneShiftQueryVariables>;
export const GetVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short"}},{"kind":"Field","name":{"kind":"Name","value":"long"}}]}}]}}]} as unknown as DocumentNode<GetVersionQuery, GetVersionQueryVariables>;
export const GetTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTimezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTimezone"}}]}}]} as unknown as DocumentNode<GetTimezoneQuery, GetTimezoneQueryVariables>;
export const GetDashboardsWithoutCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboardsWithoutCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dashboards"},"name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"dashboard","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectsToObjectsByObject1IdConnection"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"every"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"collection","block":false}]}}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LayoutObject"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObjectParts"}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LayoutObject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"layouts"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Settings","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Layouts","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObjectParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardsWithoutCollectionsQuery, GetDashboardsWithoutCollectionsQueryVariables>;
export const GetWidgetInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidgetInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"widget","block":false},{"kind":"Variable","name":{"kind":"Name","value":"type"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectsCount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mPicture"}}]}}]}}]} as unknown as DocumentNode<GetWidgetInfoQuery, GetWidgetInfoQueryVariables>;
export const SelectedSchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"selectedSchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"mTags"}}]}}]}}]} as unknown as DocumentNode<SelectedSchemaQuery, SelectedSchemaQueryVariables>;
export const UserAppsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userApps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyName"},"value":{"kind":"StringValue","value":"Program/Name","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"icon"},"name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyName"},"value":{"kind":"StringValue","value":"Program/Icon","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"url"},"name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"propertyName"},"value":{"kind":"StringValue","value":"Program/URL","block":false}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<UserAppsQuery, UserAppsQueryVariables>;
export const LoadGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"GROUP_NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<LoadGroupsQuery, LoadGroupsQueryVariables>;
export const UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateObjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateMutation, UpdateMutationVariables>;
export const GetControlsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControlsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schemaControls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rpc"}},{"kind":"Field","name":{"kind":"Name","value":"argument"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetControlsListQuery, GetControlsListQueryVariables>;
export const GetObjectPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObjectProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetObjectPropertyQuery, GetObjectPropertyQueryVariables>;
export const SelectedSchemaTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"selectedSchemaType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"mTags"}}]}}]}}]} as unknown as DocumentNode<SelectedSchemaTypeQuery, SelectedSchemaTypeQueryVariables>;
export const ListenMonitoringItemsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"listenMonitoringItemsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tags"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentObjects"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tags"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tags"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectsToObject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hardLinked"}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"}},{"kind":"Field","name":{"kind":"Name","value":"mName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeId"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"}},{"kind":"Field","name":{"kind":"Name","value":"mName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListenMonitoringItemsListSubscription, ListenMonitoringItemsListSubscriptionVariables>;
export const GetMonitorObjectWithoutFragmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMonitorObjectWithoutFragments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GROUP_NAME_ASC"},{"kind":"EnumValue","value":"PROPERTY_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schema"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentSchemaExists"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"schemaType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"device","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"schemaType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGroupsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GROUP_NAME_DESC"},{"kind":"EnumValue","value":"PROPERTY_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<GetMonitorObjectWithoutFragmentsQuery, GetMonitorObjectWithoutFragmentsQueryVariables>;
export const LoadSchemaPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadSchemaProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<LoadSchemaPropertiesQuery, LoadSchemaPropertiesQueryVariables>;
export const ObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"Objects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectsToObject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object1Id"}},{"kind":"Field","name":{"kind":"Name","value":"object2Id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedNodeId"}}]}}]}}]} as unknown as DocumentNode<ObjectsSubscription, ObjectsSubscriptionVariables>;
export const CreateDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyByKeyInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editorGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"readerGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createObjectWithProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"dashboard","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"keyedProperties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ListValue","values":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"childs"},"value":{"kind":"ListValue","values":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"editorGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editorGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"readerGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"readerGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroup"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<CreateDashboardMutation, CreateDashboardMutationVariables>;
export const GetFullCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dashboards"},"name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"collection","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject2Id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGroupsFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<GetFullCollectionsQuery, GetFullCollectionsQueryVariables>;
export const GetDashboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dashboards"},"name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"dashboard","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetDashboardsQuery, GetDashboardsQueryVariables>;
export const UpdateObjectWithPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateObjectWithProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateObjectWithPropertiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateObjectWithProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateObjectWithPropertiesMutation, UpdateObjectWithPropertiesMutationVariables>;
export const GetCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collections"},"name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"collection","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}}]}}]}}]} as unknown as DocumentNode<GetCollectionsQuery, GetCollectionsQueryVariables>;
export const LinkObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createObjectsToObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectsToObject"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object1Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"object2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectsToObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LinkObjectMutation, LinkObjectMutationVariables>;
export const UnlinkObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unlinkObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteObjectsToObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UnlinkObjectMutation, UnlinkObjectMutationVariables>;
export const GetControlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getControls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ControlExecutionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ControlExecutionsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlExecutionsConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"linkedControlId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"caller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ack"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"callerId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetControlsQuery, GetControlsQueryVariables>;
export const GetDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"readergroup"}},{"kind":"Field","name":{"kind":"Name","value":"usergroup"}},{"kind":"Field","name":{"kind":"Name","value":"editorgroup"}},{"kind":"Field","alias":{"kind":"Name","value":"collections"},"name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"StringValue","value":"collection","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"target"},"name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object1Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"PROPERTY"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardQuery, GetDashboardQueryVariables>;
export const GetDashboardNamesWithoutCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboardNamesWithoutCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dashboards"},"name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"dashboard","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectsToObjectsByObject1IdConnection"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"every"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"collection","block":false}]}}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetDashboardNamesWithoutCollectionsQuery, GetDashboardNamesWithoutCollectionsQueryVariables>;
export const LoadAllGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loadAllGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<LoadAllGroupsQuery, LoadAllGroupsQueryVariables>;
export const ListConnectedObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listConnectedObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectsToObjectsByObject2IdConnection"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forced"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListConnectedObjectsQuery, ListConnectedObjectsQueryVariables>;
export const GetGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetObjectsByIdOrNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObjectsByIdOrName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"media","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stringId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includesInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetObjectsByIdOrNameQuery, GetObjectsByIdOrNameQueryVariables>;
export const FetchNotificationByDeliveryIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchNotificationByDeliveryId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationDelivery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject2Id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject2Id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchNotificationByDeliveryIdQuery, FetchNotificationByDeliveryIdQueryVariables>;
export const FetchNotificationsDeliveriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchNotificationsDeliveries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"30"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"condition"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationDeliveryCondition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationDeliveriesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"CREATED_AT_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"condition"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"userLogin"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}},{"kind":"Field","name":{"kind":"Name","value":"mName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byName"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<FetchNotificationsDeliveriesQuery, FetchNotificationsDeliveriesQueryVariables>;
export const ListenNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"listenNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryUser"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryPath"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterA"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deliveryUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryUser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deliveryPath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryPath"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationDelivery"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"userLogin"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}},{"kind":"Field","name":{"kind":"Name","value":"mName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byName"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListenNotificationsSubscription, ListenNotificationsSubscriptionVariables>;
export const GetObjectNameByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObjectNameById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetObjectNameByIdQuery, GetObjectNameByIdQueryVariables>;
export const GetHistoryUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHistoryUnits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"30"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}}]}}]}}]}}]} as unknown as DocumentNode<GetHistoryUnitsQuery, GetHistoryUnitsQueryVariables>;
export const GetSchemaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSchema"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schemaProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"GROUP_NAME"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}}]}}]}}]}}]} as unknown as DocumentNode<GetSchemaQuery, GetSchemaQueryVariables>;
export const FetchHistoryListConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchHistoryListConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectPropertiesHistoryFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectPropertiesHistoriesOrderBy"}}}},"defaultValue":{"kind":"EnumValue","value":"RECORDED_AT_DESC"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectPropertiesHistoriesConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"propertyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FetchHistoryListConnectionQuery, FetchHistoryListConnectionQueryVariables>;
export const RemoveObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mnDeleteObjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mnDeleteObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<RemoveObjectMutation, RemoveObjectMutationVariables>;
export const UpdatePropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateObjectPropertyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateObjectProperty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const CreateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyByKeyInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editorGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"readerGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createObjectWithProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"report","block":false}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"keyedProperties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ListValue","values":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"childs"},"value":{"kind":"ListValue","values":[]}},{"kind":"ObjectField","name":{"kind":"Name","value":"editorGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editorGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"readerGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"readerGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroup"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const ResolveObjectPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resolveObjectPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResolveObjectPermissionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveObjectPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessRight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edit"}}]}}]}}]}}]} as unknown as DocumentNode<ResolveObjectPermissionsMutation, ResolveObjectPermissionsMutationVariables>;
export const GetWidgetsTransformedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidgetsTransformed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"dashboard"},"name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LayoutObject"}},{"kind":"Field","alias":{"kind":"Name","value":"groups"},"name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"group","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"group"},"name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"widgets"},"name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"media","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"widget"},"name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"columnsCount"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"General","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Columns count","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bg"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"General","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Background color","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bgImage"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Custom","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Background image","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"General","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Container type","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"layouts"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"General","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Layouts","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ObjectParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LayoutObject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"layouts"},"name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"groupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Settings","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"Layouts","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ObjectParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]} as unknown as DocumentNode<GetWidgetsTransformedQuery, GetWidgetsTransformedQueryVariables>;
export const GetReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"readergroup"}},{"kind":"Field","name":{"kind":"Name","value":"usergroup"}},{"kind":"Field","name":{"kind":"Name","value":"editorgroup"}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"PROPERTY"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportQuery, GetReportQueryVariables>;
export const GetFullReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFullReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"readergroup"}},{"kind":"Field","name":{"kind":"Name","value":"usergroup"}},{"kind":"Field","name":{"kind":"Name","value":"editorgroup"}},{"kind":"Field","alias":{"kind":"Name","value":"collections"},"name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"StringValue","value":"collection","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"target"},"name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object1Id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"PROPERTY"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetFullReportQuery, GetFullReportQueryVariables>;
export const ReportPropsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reportProps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"report","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectsCount"}},{"kind":"Field","name":{"kind":"Name","value":"schemaProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<ReportPropsQuery, ReportPropsQueryVariables>;
export const GetReportsWithoutCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReportsWithoutCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reports"},"name":{"kind":"Name","value":"objects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"report","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"objectsToObjectsByObject1IdConnection"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"every"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"collection","block":false}]}}]}}]}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NAME_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGroupsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<GetReportsWithoutCollectionsQuery, GetReportsWithoutCollectionsQueryVariables>;
export const GetRpcDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRPC"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaControls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"RPC_DESC"},{"kind":"EnumValue","value":"ARGUMENT_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rpc"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaId"}},{"kind":"Field","name":{"kind":"Name","value":"isRpc"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"argument"}},{"kind":"Field","name":{"kind":"Name","value":"typeSpec"}},{"kind":"Field","alias":{"kind":"Name","value":"typeId"},"name":{"kind":"Name","value":"typeSpec"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRpcQuery, GetRpcQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyByKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createObjectWithProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"schemaTags"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"application","block":false},{"kind":"StringValue","value":"board","block":false},{"kind":"StringValue","value":"widget","block":false},{"kind":"Variable","name":{"kind":"Name","value":"widgetType"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"keyedProperties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parents"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"childs"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<CreateWidgetMutation, CreateWidgetMutationVariables>;
export const GetWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectPropertyFilter"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaName"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PROPERTY_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupNames"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<GetWidgetQuery, GetWidgetQueryVariables>;
export const UpdateGroupMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGroupMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyByKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateObjectWithProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"detailedObject"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"keyedProperties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateGroupMutationMutation, UpdateGroupMutationMutationVariables>;
export const UpdateObjDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateObj"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyByKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateObjectWithProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"detailedObject"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"widgetId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"keyedProperties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<UpdateObjMutation, UpdateObjMutationVariables>;
export const CreateControlExecutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createControlExecution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateControlExecutionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createControlExecution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"linkedControlId"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}}]}}]}}]} as unknown as DocumentNode<CreateControlExecutionMutation, CreateControlExecutionMutationVariables>;
export const GetObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mPicture"}},{"kind":"Field","name":{"kind":"Name","value":"mIcon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"schemaType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GROUP_NAME_ASC"},{"kind":"EnumValue","value":"PROPERTY_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}},{"kind":"Field","name":{"kind":"Name","value":"valueRange"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject1Id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"object2"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"StringValue","value":"media","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"muted"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"schemaType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGroupsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GROUP_NAME_DESC"},{"kind":"EnumValue","value":"PROPERTY_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectsToObjectsByObject2Id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"object1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"schemaTags"}},{"kind":"Field","name":{"kind":"Name","value":"schemaType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGroupsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"GROUP_NAME_DESC"},{"kind":"EnumValue","value":"PROPERTY_DESC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"linkedPropertyId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userByBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"login"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGroupsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Object"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupByEditorgroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByUsergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupByReadergroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<GetObjectQuery, GetObjectQueryVariables>;
export const GetObjectPropertiesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getObjectPropertiesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"spec"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"valueSet"}}]}}]}}]}}]} as unknown as DocumentNode<GetObjectPropertiesByIdsQuery, GetObjectPropertiesByIdsQueryVariables>;